import appConfig from '../../../config/app_config';

const DE = {
  EMAIL: 'Email',
  CONFIRM_EMAIL: 'Email bestätigen',
  LOG_OUT: 'Ausloggen',
  DOUBLEUSERGROUP_ERROR:
    'Leider können Sie einem Benutzer nur eine Partnergruppe zuweisen.',
  DUPLICATEDPARTNERNAME_ERROR:
    'Der Partnername ist leider bereits in unserem System vorhanden. Bitte ändern Sie den Namen und fahren Sie fort.',
  YES_SEND_MSG: 'Ja, Nachricht senden',
  SEND_MSG_TO_TS: 'Nachricht an Zeitfenster senden: ',
  ON_THE: ' auf der ',
  ENTER_TITLE_MSG: 'Geben Sie den Titel der Nachricht ein',
  ENTER_TEXT_MSG: 'Geben Sie den Text der Nachricht ein',
  SEND_MSG_TO_TS_CHECK:
    'Sind Sie sicher, dass Sie eine Nachricht an alle Benutzer aus dem Zeitfenster senden möchten: ',

  // Capacity Info page
  CAPACITY_INFO: 'Kapazitätsinfo',
  CAP_CAL_FOR: 'Kapazitätskalender für',
  CAP_SEL_EVENT:
    'Bitte wählen Sie ein Ereignis aus, um die Kalenderdaten abzurufen',
  CAP_EVENT_CAP: 'Event capacity: ',
  CAP_FREE_EVENT_CAP: 'Freie ereignis kapazität: ',
  CAP_FREE_BATCH_CAP: 'Freie Chargenkapazität: ',
  CAP_BOOKED_BATCH_CAP: 'Gebuchte Chargenkapazität: ',
  CAP_CUR_OCCUPANCY: 'aktuelle Belegung: ',
  CAP_TOTAL_EVENT_CAP: 'Gesamte ereignis kapazität: ',
  CAP_BATCH_TIME: 'Batch-Zeit: ',
  CAP_TOTAL_BATCH_CAP: 'Gesamte chargenkapazität: ',

  CREATE_EVENT: 'Neues ereignis',
  CATEGORIES_NONE: 'Keine Kategorien verfügbar',

  // reorder alerts
  SUCCESS_PROD: 'Die folgenden Artikel wurden Ihrem Einkaufswagen hinzugefügt:',
  FAIL_PROD:
    '\n' +
    'Die folgenden Artikel konnten Ihrem Einkaufswagen nicht hinzugefügt werden:',

  // payments status error
  EXPIRED: 'Abgelaufen',
  CANCELED: 'Abgebrochen',
  FAILED: 'Gescheitert',

  STATUS_CONFIRMED: 'Bestätigt',
  STATUS_PARTNER_CONFIRM: 'Auf Bestätigung warten',
  STATUS_REQUESTED_PAYMENT: 'Warten auf Zahlung',
  STATUS_CANCELLED: 'Cancelled',

  COMM_MGR_05:
    'Es wurden keine Benutzer gefunden, die den ausgewählten Kriterien entsprechen!',
  DEFINE_AREA: 'Bereich definieren',

  PIN: 'Geheimzahl',
  WELCOME_MESSAGE_TITLE: 'Herzlich willkommen',
  WELCOME_MESSAGE: `Willkommen auf Ihrer persönlichen Seite. Hier finden Sie alles, was Sie zur Planung und Personalisierung Ihres Besuchs benötigen ${appConfig.dss.environmentName}. Sie können Ihre Einstellungen einfach unter Einstellungen ändern. Wir wünschen Ihnen viel Spaß bei Ihrem Besuch in  ${appConfig.dss.environmentName} `,

  EDIT: 'Bearbeiten',
  EDIT_MESSAGE: 'Nachricht bearbeiten',

  MESSAGE_TITLE_1: 'Welche Art von Nachricht möchten Sie senden?',
  MESSAGE_TITLE_2:
    'Sie können für eine einzelne Nachricht auswählen oder eine Engagement-Kampagne starten',
  MESSAGE_TITLE_3:
    'Um eine Nachricht zu senden, muss ich wissen, an wen Sie sie senden möchten.',
  MESSAGE_TITLE_4:
    'Was möchten Sie senden und wann sollte es an sie geliefert werden?',
  MESSAGE_TITLE_5:
    'Welche Besuchergruppe möchten Sie mit Ihrer Engagement-Kampagne erreichen?',
  MESSAGE_CATEGORY: 'Nachrichtenkategorie',
  SELECT_MESSAGE_CATEGORY: 'Wählen Sie eine Nachrichtenkategorie',

  PREVIEW: 'Vorschau',

  START: 'Chargendetails zufließen ',
  END: ' Details zur Abflusscharge',
  'DATE/TIMEINFO': 'Allgemeine Chargendetails mit allen anderen Feldern',
  PRICECATEGORIES: 'Chargenpreisdetails',
  PERIOD_INFO: 'Details zur Ereignisstapeldauer',

  SELECT: 'Wählen',
  CONTRIBUTORS: 'Mitwirkende',
  PRODUCTS: 'Produkte',
  CHOOSE_YOUR_PRODUCTS: 'Wählen Sie Ihre Produkte',
  SETTINGS_SAVE_OK: 'Einstellungen korrekt gespeichert',
  SETTINGS_SAVE_KO: 'Fehler beim Speichern der Einstellungen',
  MY_VISIT: 'Mein Besuch',
  EVENTS: 'Veranstaltungen',
  SETTINGS: 'die Einstellungen',
  INTERESTED_IN: 'Ich interessiere mich für Veranstaltungen für',
  SELECT_LOCATION: 'Wähle einen Standort',
  SELECT_EVENT: 'Wählen Sie ein Ereignis aus',
  SELECT_TIME_PERIOD: 'Wählen Sie einen Zeitraum',
  SELECT_FROM: 'Von',
  SELECT_UNTIL: 'Bis',
  SELECT_WINNER: 'Gewinner auswählen',
  BACK: 'Zurück',
  COMMUNICATION_CENTER: 'Kommunikationszentrum',
  SAVED_COMMUNICATION: 'Gespeicherte Kommunikation',
  NEW_COMMUNICATION: 'Neue Kommunikation',
  COMMUNICATION: 'Kommunikation',
  COMMUNICATIONS: 'Kommunikation',
  TYPE: 'Art',
  DATE: 'Datum',
  TIME: 'Zeit',
  CHOOSE_EVENT_OPTION: 'Wählen Sie eine Ereignisoption',
  CHOOSE_BATCHGROUP_OPTION: 'Wählen Sie eine Stapelgruppenoption',
  ENGAGEMENT_CAMPAIGN: 'Starten Sie eine Engagement-Kampagne',
  ENGAGEMENT_CAMPAIGN_SUB:
    'Wird für die Werbung für die Veranstaltung und das Catering verwendet.',
  CATERING_PROMOTION: 'Catering-Förderung',
  SECOND_PROMOTION: 'Zweite Beförderung',
  PLANBOARD: 'Planboard',
  MY_PLANBOARD: 'Mein Planboard',
  SHOW_PLANBOARD: 'Planboard anzeigen',
  WHOM: 'Wem',
  SEND_MESSAGE_TO: 'Nachricht senden an',
  WHAT: 'Was',
  TITLE_MESSAGE: 'Titelnachricht',
  LINK_TEXT: 'Ausgehender Link',
  TEXT_MESSAGE: 'Textnachricht',
  PROMOCODE: 'Aktionscode',
  ADD_FAVORITE: 'zu Favoriten hinzufügen',
  FAVORITE: 'Favorit',
  WHEN: 'Wann',
  NEW_MESSAGE: 'Neue Nachricht',
  SINGLE_MESSAGE: 'Senden Sie eine einzelne Nachricht',
  SINGLE_MESSAGE_SUB:
    'Wird für Updates oder zusätzliche Informationen für Ihre Besucher verwendet.',
  THE_LOTTERY: 'Die Lotterie',
  START_LOTTERY: 'Starten Sie die Lotterie',
  FIRST_PROMOTION: 'Erste Beförderung',
  MESSAGE: 'Botschaft',
  MESSAGES: 'Mitteilungen',
  ERROR_HEADER: 'Sieht so aus, als wäre etwas schief gelaufen.',
  ERROR_NO_CONNECTION:
    'Ein Problem ist aufgetreten. Bitte wenden Sie sich an das Kundendienstzentrum von The Driving Force',
  USER_PICTURE_UPLOAD:
    'Fügen Sie Ihr Foto hinzu, um Ihr Konto persönlich zu gestalten',
  USER_QR_CODE:
    'Dies ist Ihr persönlicher QR-Code. Sie können diesen Code scannen, um Briefmarken zu erhalten. Mit einem vollständigen Satz Briefmarken können Sie Rabatte erhalten. ',
  DISCOUNT: 'Rabatt',
  ITEM_NUMBER: 'Artikelnummer',

  EVENT_FLEX_ARRIVAL: 'Prozentsatz flexibler Benutzer',
  EVENT_AVERAGE_WAITTIME: 'Durchschnittliche Wartezeit',
  EVENT_MAX_WAITTIME: 'Maximale Wartezeit',
  EVENT_AVERAGE_DEVIATION: 'Durchschnittliche Abweichung',
  EVENT_MAX_DEVIATION: 'Maximale Abweichung',
  DISTRIBUTION_IN_TIME: 'DIT',
  DISTRIBUTION_IN_TIME_BIG: 'Zeitliche Verteilung',
  DISTRIBUTION_IN_PLACE: 'DIP',
  ERROR_LOGIN: 'Fehler, falsche Daten',
  ERROR: 'Error',
  ERROR_EMAIL_EXIST: 'E-Mail vorhanden',

  TITLE_CHART_0: 'Besucher',
  TITLE_CHART_1: 'Wartezeit',
  TITLE_CHART_2: 'Einträge',
  TITLE_CHART_3: 'Vorfälle',
  TITLE_CHART_4: 'Zuflussmuster',
  TITLE_CHART_5: 'Abflussmuster',
  EMPTY_SLOT: 'Leerer Schlitz',
  MOVE_SLOT_FORWARD: 'Steckplatz verschieben',
  EVENT_TITLE: 'Ereignis-Dashboard',
  INCIDENT_TITLE: 'Vorfall',
  INCIDENT_TITLE_2: '',
  TOTAL_ARRIVALS: 'Gesamtzahl der Ankünfte',

  // Growthvitamine / Groeivitamine / Growth vitamine / Groei vitamine CARDS
  DISCOUNT_ORDER: 'discount on your entire order',
  DISCOUNT_PRODUCT: 'discount on product',
  AVAILABLE_UNTIL: 'Available until',
  AWARD_VITAMIN: 'Special Offer',
  GROWTH_VITAMIN_EXPIRE_TEXT: 'Angebot endet am %s',
  GROWTH_VITAMIN_MIN_VALUE_TEXT: 'Gültig ab einem Bestellwert € %f',

  // Homepage
  USER_LOGGED_OUT: 'erfolgreich abgemeldet',
  ACTIVITIES_DESC:
    'Durchsuchen Sie die Themen und finden Sie Aktivitäten, die Ihnen gefallen',
  NO_CONTINUE_USING_WEBSITE: 'Nein, ich möchte die Website nutzen',
  VIEW_ACTIVITIES: 'Aussicht',
  SEARCH_ACTIVITY: 'Suchen Sie nach einer Aktivität',
  SEARCH_PRODUCTS: 'Produktsuche',
  HIGHLIGHTS: 'Themen',
  HIGHLIGHTS_DESC:
    'Durchsuchen Sie die accountName Themenaktivitäten und finden Sie heraus, warum Sie auf jeden Fall accountName besuchen sollten',
  ACTIVITIES_FOR_HIGHLIGHT: 'Aktivitäten für Themen ',
  ACTIVITIES_FOR_LOCATION: 'Aktivitäten für den Standort ',
  CLOSE_ACTIVITIES: 'Schließe dieses Fenster',
  GET_ACCOUNT_APP: 'Holen Sie sich jetzt die accountName App!',
  ACCOUNT_APP_TEXT:
    'Holen Sie sich die accountName-App und lassen Sie sich von allem inspirieren, was Sie sehen und tun können. Die accountName-App bietet Ihnen viele Vorteile für Ihren Besuch in ' +
    'accountName. Finden, buchen und greifen Sie ganz einfach mit wenigen Fingertipps auf Ihre Lieblingsaktivitäten zu.',
  ACCOUNT_APP_TEXT2:
    'Die accountName-App ist alles, was Sie benötigen, um Ihren accountName-Besuch optimal zu nutzen.',
  WHATS_ON: 'Was läuft',
  WHATS_ON_DESC: 'Was gibt es zu tun',
  FILTER_RESULTS: 'Filter Ergebnisse',
  TODAY: 'Heute',
  NEXT_7_DAYS: 'Nächste 7 Tage',
  NEXT_30_DAYS: 'Nächste 30 Tage',
  NEXT_3_MONTHS: 'Nächste 3 Monate',
  SELECT_SPEC_DAYS: 'Wählen Sie bestimmte Tage aus',
  WHAT_IS_WHERE: 'Was ist wo?',
  WHAT_IS_WHERE_DESC: 'Was ist wo',
  ACT_FOR_HIGHLIGHT: 'Aktivitäten für dieses Thema!',
  ACTIVITIES: 'Termine',
  ACTIVITIES_HOMEPAGE: 'Aktivitäten',
  ACTIVITIES_TITLE: 'Stöbern Sie durch unsere Aktivitäten',
  GET_PERS_SUG:
    'Erhalten Sie personalisierte Vorschläge, indem Sie Kategorien mit den Schaltern auf der linken Seite auswählen. ',
  USER_WELCOME: 'Willkommen zurück ',
  PASS_MAX_FUN: 'Erstellen Sie einen Reisepass für maximalen Spaß',
  PERS_PASS: 'Ihr persönlicher Reisepass',
  CREATE_PASS_DESC_1:
    'Erstellen Sie Ihren persönlichen Reisepass und holen Sie das Beste aus Ihrem Besuch heraus ',
  CREATE_PASS_DESC_2:
    'Der Reisepass bietet Ihnen Zugang zu exklusiven Aktivitäten und Ermäßigungen und ermöglicht es Ihnen, Ihren Besuch vollständig an Ihre Wünsche und Interessen anzupassen. Sie werden garantiert mehr Spaß haben. ',
  CREATE_PASS_NOW: 'Erstellen Sie jetzt Ihren persönlichen Reisepass! ',
  CREATE_PASS: 'Pass erstellen',
  PASS_DESC_1:
    'Planen Sie Ihren Besuch weiter oder erstellen Sie eine neue Reise nach ',
  PASS_DESC_2:
    'Gehen Sie zu Ihrem persönlichen Reisepass, um Ihre gespeicherten Favoriten, persönlichen Vorschläge und Interessen anzuzeigen.',
  GO_TO_PASS: 'Gehen Sie zu Mein Konto',

  // QR-code scanner
  QR_CODE: 'QR-code scanner',
  ENTER_AMOUNT: 'Geben Sie den Betrag in Euro ein',
  SCAN_CODE: 'Scannen Sie den QR-Code des Kunden',
  ERROR1: 'Sie haben nichts eingegeben!',
  LAST_RESULT: 'Letztes Ergebnis:',

  // User passport
  USER_WANT_LOGOUT: 'Ja, ich möchte mich abmelden',
  USER_PASSPORT: 'Mein Konto',
  USER_PASSPORT_DESC:
    'Erstellen Sie Ihren persönlichen Reisepass, um Aktivitätsvorschläge zu personalisieren, besondere Belohnungen zu erhalten und Ihre Favoritenliste anzuzeigen.',
  USER_INTERRESTS: 'Deine Interessen',
  USER_INTERRESTS_DESC:
    'Teilen Sie uns mit, an welchen Aktivitäten Sie interessiert sind, damit wir passende Aktivitäten anbieten können. ',
  YOUR_USER_REWARD_LVL: 'Ihre aktuelle Belohnungsstufe',
  USER_REWARD_LVL: 'Belohnungsstufe',
  USER_CURRENT_LEVEL: 'Aktuelles Level',
  USER_REWARD_LVL_DESC:
    'Sammeln Sie Belohnungspunkte, indem Sie Aktivitäten ausführen. Holen Sie sich genug Punkte, um das nächste Level zu erreichen und spezielle Aktivitäten und Rabatte freizuschalten. ',
  USER_FAVORITES: 'Deine Favoriten',
  USER_FAVORITES_DESC:
    'Aktivitäten, die Sie Ihrer Favoritenliste hinzugefügt haben. ',
  USER_REWARD_POINTS: 'Punkte',
  USER_EARNED_POINTS: 'Verdiente Punkte',
  USER_POINTS_TO_NEXT_LEVEL: 'Zeigt auf das nächste Level',
  USER_INTERESTS: 'Meine Interessen',
  DEL_FAV: 'Favorit löschen',
  SURE_DELETE_ACTIVITY: 'Möchten Sie die Aktivität wirklich löschen ',
  SURE_DELETE_FAV: ' aus Ihrer Favoritenliste ? ',
  USER_DETAILS: 'Persönliche Daten',
  USER_SELECTIONS: 'Ihre Auswahl',
  USER_LOCATION_NOT_FOUND: 'Adresse nicht gefunden',
  USER_LOCATION_NOT_FOUND_DESC: 'Die Adresse wurde nicht gefunden',
  USER_LOCATION_NOT_FOUND_DESC2:
    'Beim Speichern Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
  USER_DETAILS_NOT_SAVED: 'Benutzerdaten werden nicht gespeichert',
  USER_DETAILS_SAVED: 'Die Benutzerdaten werden gespeichert',
  GETTING_USER_INTERESTS: 'Benutzerinteressen erhalten',
  FILTER_ACTIVITIES: 'Aktivitäten filtern',

  // Incidents
  INCIDENT_DESCRIPTION_REPORTER: 'Beschreibung des Reporters',
  INCIDENT_DESCRIPTION: 'Fügen Sie eine Beschreibung hinzu',
  INCIDENT_HAPPEND: 'Um welche Art von Vorfall handelt es sich',
  INCIDENT_FILL_IN: 'Füllen Sie die Ereignisdaten aus',
  INCIDENT_TYPE: 'Typ Vorfall',
  INCIDENT_LIFE_THREAT: 'Lebensbedrohlich?',
  INCIDENT_SITUATION: 'Lebensbedrohlich?',
  INCIDENT_LOCATION:
    'Wahr? (Klicken Sie mit der rechten Maustaste auf die Karte, auf der sich der Vorfall ereignet hat).',
  INCIDENT_EXACT_LOCATION: 'Geben Sie den Speicherort an',
  INCIDENT_ROAD_ID: 'Straßendaten',
  INCIDENT_ADRESS: 'Adressdaten',
  INCIDENT_YES_NO: 'Ja/Nein',
  INCIDENT_GPS: 'GPS Koordinaten',
  INCIDENT_STREET: 'Straßenname',
  INCIDENT_NUMMER: 'Nummer',
  INCIDENT_PLACE: 'Stadtname',
  INCIDENT_DESCRIPTION_PLACEHOLDER:
    'Beschreibung des genauen Standorts der Rettungsdienste.',
  INCIDENT_ADDITIONAL_LOCATION: 'Zusätzlicher Standort',
  INCIDENT_PHOTO: 'Kommentare und Foto hinzufügen.',
  INCIDENT_USER: 'Name des Reporters',
  NO_INCIDENT_DATA: 'Keine Vorfalldaten',
  GO_INCIDENT: 'Sehen',
  NO_USERS: 'Keine Benutzer gefunden',
  INCIDENT_CLOSE: 'Vorfall schließen',
  INCIDENT_REMOVED: 'Vorfall entfernt',
  INCIDENT_NOT_REMOVED: 'Vorfall kann nicht entfernt werden',
  INCIDENT_DIALOG_CLOSE:
    'Sind Sie sicher, dass Sie diesen Vorfall schließen möchten??',
  INCIDENT_DIALOG_EDIT: 'Wollen Sie die Änderungen speichern?',
  INCIDENT_SEND: 'Senden',
  INCIDENT_EDIT: 'Änderungen speichern',
  INCIDENT_PICTURE: 'Ereignisbild',

  INC_1: 'Verkehrsunfall',
  INC_2: 'Trümmer',
  INC_3: 'Verwundet',
  INC_4: 'Überfüllt',
  INC_5: 'Technischer Fehler',
  INC_6: 'Verkehrsunfall',
  INC_7: 'Feuer',
  INC_8: 'Verdächtige Situation',
  YES: 'Ja',
  NO: 'Nein',

  // Event
  EVENT_ADD_REWARD_LEVEL: 'Belohnungsstufe hinzufügen',
  EVENT_ASSIGN_REWARDS: 'Weisen Sie Belohnungen zu',
  EVENT_REWARD_MANAGEMENT: 'Belohnungsmanagement',
  EVENT_ASSIGN_REWARD_EXPLANATION:
    'Um diesem Event eine Belohnung zuzuweisen, speichern Sie bitte zuerst das Event!',
  EVENT_REWARD_EXPLANATION:
    'Um diesem Event eine Belohnungsstufe hinzuzufügen, speichern Sie das Event bitte zuerst!',
  EVENT_DISCOUNT_CARDS_EXPLANATION:
    'Um eine Rabattkarte hinzuzufügen, speichern Sie bitte zuerst die Veranstaltung!',
  EVENT_DISCOUNT_CARDS: 'Rabattkarten',
  EVENT_SUBACTIVITIES: 'Unteraktivitäten',
  EVENT_ALTERNATIVES: 'Alternativen',
  EVENT_TICKET_TYPES: 'Ticketarten',
  EVENT_EXTRA: 'Extra event',
  EVENT_STOP_NAME: 'Name des Ereignisstopps',
  EVENT_END_LOCATION: 'Endort',
  EVENT_START_LOCATION: 'Startort',
  EVENT_LOCATION: 'Veranstaltungsort',
  EVENT_ROUTE: 'Ereignisroute',
  EVENT_RESET: 'Zurücksetzen',
  EVENT_RANKING: 'Event-Ranking',
  EVENT_PARTNER: 'Veranstaltungspartner',
  EVENT_PRODUCT: 'Veranstaltung/Produkte',
  EVENT_DATE_RANGE: 'Datumsbereich',
  EVENT_AGE_RESTRICTIO: 'Altersbeschränkung',
  EVENT_ACTIVE_COMPLETE_TIME: 'vollständige Zeit aktivieren',
  EVENT_CHECK_IN_TIME: 'Check-in-Zeit',
  EVENT_CHECK_OUT_TIME: 'Check-aus-Zeit',
  EVENT_ACTIONS: 'Akties',
  EVENT_EARLIEST_CHECKIN_TIME: 'Früheste Check-in-Zeit',
  EVENT_LATEST_CHECKIN_TIME: 'Späteste Check-in-Zeit',
  EVENT_DURATION_ARRIVAL_BATCHES: 'Dauer Ankunft Chargen',
  EVENT_MAX_INFLOW: 'Maximaler Zufluss',
  EVENT_EARLIEST_CHECKOUT_TIME: 'Früheste Check-out-Zeit',
  EVENT_LATEST_CHECKOUT_TIME: 'Späteste Check-out-Zeit',
  EVENT_DURATION_DEPARTURE_BATCHES: 'Dauer Abflugchargen',
  EVENT_MAX_OUTFLOW: 'Maximaler Abfluss',
  EVENT_STEPS: 'Schritte',
  EVENT_PRICE_INFORMATION: 'Preisinformationen',
  EVENT_CHART_EXPLANATION:
    'Wenn Sie ein Datum und einen Ort auswählen, wird ein Diagramm erstellt, in dem die Menge angezeigt wird.',
  EVENT_MINIMAL_DURATION: 'Minimale Dauer',
  EVENT_MAXIMUM_DURATION: 'Maximale Dauer',
  EVENT_BOOKING_POLICY: 'Buchungsrichtlinien',
  EVENT_FLEX_PERCENTAGE: 'Flex-Prozentsatz',
  EVENT_PRICE_CATEGORY: 'Preiskategorie',
  EVENT_ADD_PRICE_CATEGORY: 'Preiskategorie hinzufügen',
  EVENT_THRESHOLD: 'Schwelle',
  EVENT_PLEASE_ADD_PRICECATEGORY:
    'Bitte fügen Sie dieser Chargengruppe mindestens 1 Preiskategorie hinzu',
  EVENT_EXTERNAL_PLATFORM: 'Externe Plattformen',
  EVENT_TOUR: 'Touren',
  EVENT_AVERAGE_SPEED: 'Durchschnittsgeschwindigkeit (km/h)',
  EVENT_DELIVERY_OR_TAKEAWAY:
    'Treffen Sie nach Möglichkeit die Wahl, ob das Produkt geliefert oder selbst abgeholt werden soll.',
  EVENT_INSERT_STARTTIME: 'Geben Sie Ihre neue Startzeit ein',
  EVENT_INSERT_ENDTIME: 'Geben Sie Ihre neue Endzeit ein',
  EVENT_CURRENT_START_AND_ENDTIME:
    'Ihre aktuelle Start- und Endzeit für das Ereignis: eventName ist',
  EVENT_CURRENT_START_AND_ENDDATE:
    'Ihr aktuelles Start- und Enddatum für event: eventName ist',
  EVENT_NO_TICKETS_SELECTED: 'Es sind keine Tickets ausgewählt',
  EVENT_PLEASE_SELECT_TICKET: 'Bitte wählen Sie Ihre Tickets',
  EVENT_NO_DATE_CHOSEN: 'Kein Datum gewählt',
  EVENT_CHOOSE_DATE: 'Wählen Sie ein Datum',
  EVENT_BOOK: 'Event buchen',
  EVENT_INPUT_TIME_INCORRECT: 'Die Startzeit ist später als die Endzeit',
  EVENT_TIME_INCORRECT: 'Zeit falsch',
  EVENT_PREFERRED_ARRIVAL: 'Bevorzugte Ankunftszeit',
  EVENT_PREFERRED_DEPARTURE: 'Bevorzugte Abfahrtszeit',
  EVENT_STARTS_EVERY: 'Startet jeden',
  NO_EVENT: 'Keine Ereignisse gefunden',
  NO_EVENTS_NOW_FOR_PARTNER:
    'Für diesen Partner wurden keine Ereignisse gefunden',
  NO_EVENTS_NOW_FOR_ACCOUNT:
    'Für diesen Accounter wurden keine Ereignisse gefunden',
  EVENT: 'Veranstaltung',
  EDIT_EVENT: 'Ereignis bearbeiten',
  EVENT_EDIT: 'Wählen Sie ein zu bearbeitendes Ereignis aus',
  EVENT_REGISTRATION: 'Veranstaltungsanmeldung',
  EVENT_DURATION: 'Dauer der Veranstaltung',
  EVENT_DESC_SHORT: 'Beschreibung',
  EVENT_LOC_SHORT: 'Standort',
  EVENT_CAP_SHORT: 'Kapazität',
  EVENT_CAT_SHORT: 'Kategorien',
  EVENT_PIC_SHORT: 'Bild',
  EVENT_MESSAGE_PICTURE: 'Nachrichtenbild',
  EVENT_MESSAGE_PRODUCT: 'Produkt',
  EVENT_MESSAGE_PRODUCT_OPT: 'Produkt (optional)',
  EVENT_MESSAGE_SELECT_PRODUCT: 'Wähle ein Produkt',
  EVENT_BUDGET_SHORT: 'Budget',
  EVENT_PARTOF_SHORT: 'Teil von -Themen-',
  EVENT_TW_SHORT: 'Zeitfenster',
  EVENT_PIC_NONE: 'Kein Bild verfügbar',
  EVENT_VISIBILITY: 'Sichtbar für',
  EVENT_NAME: 'Name der Veranstaltung',
  EVENT_TYPE: 'Art der Veranstaltung',
  EVENT_DESCRIPTION: 'Beschreibung des Ereignisses',
  EVENT_STARTTIME: 'Startzeit der Veranstaltung',
  EVENT_ENDTIME: 'Endzeit der Veranstaltung',
  EVENT_INTERVAL: 'Intervall',
  EVENT_MAXCAPACITY: 'Maximale Kapazität pro Intervall',
  EVENT_INFLOWCAPACITY: 'Kapazität pro Intervall',
  EVENT_PRICE: 'Veranstaltungspreis',
  EVENT_MAX_WAIT_TIME: 'Maximale Wartezeit in Minuten',
  EVENT_HISTORIC_ARRIVAL: 'Historische Ankünfte',
  EVENT_LANGUAGE: 'Sprachspezifikationen',
  EVENT_FILTERTYPE: 'Filtern Sie Ereignisse nach Typ: ',
  EVENT_AGENDA_NEW: '"Neuer Tagesordnungspunkt',
  EVENT_DATES_SELECTION: 'Auswahl der Daten',
  EVENT_DAYS_SELECTION: 'Auswahl der Tage',
  EVENT_START_DATE: 'Anfangsdatum',
  EVENT_END_DATE: 'Endtermin',
  EVENT_START_TIME: 'Startzeit',
  EVENT_END_TIME: 'Endzeit',
  EVENT_MAX_INFLOW: 'Maximaler Zufluss',
  EVENT_RATE_PRICE: 'Preis bewerten',
  EVENT_REWARD_POINTS: 'Belohnungspunkte',
  EVENT_NO_BATCHGROUPS: 'Keine Tagesordnungspunkte verfügbar',
  EVENT_MESSAGE_TITLE: 'Nachrichtentitel',
  EVENT_MESSAGE_TEXT: 'Nachrichtentext',
  EVENT_MESSAGE_REW_LVL: 'Nachricht an Belohnungsstufe senden',
  EVENT_USER_SELECTION: 'Auswahl der Benutzer',
  EVENT_DATE: 'Datum',
  EVENT_TIME: 'Zeit',
  EVENT_COMM_TYPE: 'Kommunikationsart',
  EVENT_MESSAGE_STATUS: 'Nachrichtenstatus',
  EVENT_MESSAGE_SEND: 'Senden',
  EVENT_MESSAGE_NOT_SEND: 'Nicht senden',
  EVENT_ERROR_MSG_1:
    'Anscheinend haben Sie nicht alle erforderlichen Felder (korrekt) ausgefüllt.',
  EVENT_ERROR_MSG_2:
    'Bitte füllen Sie alle erforderlichen Felder aus, um fortzufahren.',
  EVENT_DEL_AGENDA_ITEM:
    'Möchten Sie diesen Tagesordnungspunkt wirklich löschen?',
  EVENT_DEL_MESSAGE: 'Möchten Sie diese Nachricht wirklich löschen?',
  DELIVERY_PARTNER: 'Lieferpartner',
  DELIVERY_IMPROVEMENT_1: 'Ihre Produkte wert: ',
  DELIVERY_IMPROVEMENT_2:
    'kann kostenlos mit einem Bestellwert von geliefert werden: ',

  /// / Event info buttons on the event wizard
  // Event detail screen
  EVENT_FORAGE_MESSAGE:
    'Dieses Produkt hat eine Bewertung von (age)+. Können Sie bestätigen, dass Sie im richtigen Alter sind?',
  EVENT_NAME_INFO:
    "Der 'Name des Ereignisses' bestimmt den Namen für dieses Ereignis. Der Ereignisname wird für Kunden in der Kalenderübersicht angezeigt. entweder 'Fixed' oder 'Repetitive'. Wenn das Ereignis mehr als einmal am Tag auftritt, ist das Ereignis \"Wiederholend\".",
  EVENT_TYPE_INFO:
    "Der 'Ereignistyp' bestimmt den Typ dieses Ereignisses. Ein Ereignis ist entweder 'Fest' oder 'Wiederholend'. Wenn das Ereignis mehr als einmal am Tag auftritt, ist das Ereignis \"Wiederholend\".",
  EVENT_TW_INFO:
    "The 'Time-Window' of an event is either 'Fixed' or 'Repetitive'. If the event occures more than once a day, the event is 'Repetitive'.",
  EVENT_LOC_INFO:
    "Der 'Ort' ist der Ort, an dem die Veranstaltung stattfindet. Der Standort wird für Kunden in der Kalenderübersicht angezeigt.",
  EVENT_PARTOF_INFO:
    'Eine Veranstaltung kann Teil mehrerer Themen sein. Wenn das Ereignis nahtlos zu einem Thema passt, sollte dieses Ereignis zu diesem Thema hinzugefügt werden.',
  EVENT_CAP_INFO:
    "Die 'Kapazität' ist die maximale Kapazität der Veranstaltung.",
  EVENT_BUDGET_INFO:
    'Das "Budget" ist das Budget für eine Veranstaltung, wie oft es einem Kunden basierend auf dem "Preis" der Veranstaltung vorgeschlagen wird.',
  EVENT_LEAD_INFO:
    "Die 'Vorlaufzeit' ist die Vorlaufzeit in Minuten für das Ereignis (Standard ist 0).",
  EVENT_COOL_INFO:
    "Die 'Abklingzeit' ist die Abklingzeit in Minuten für das Ereignis (Standard ist 0).",
  DURATION_INFO:
    "Die 'Dauer' ist die Dauer in Minuten für das Ereignis (Standardeinstellung ist 60).",
  EVENT_DESC_INFO:
    "Die 'Beschreibung' der Veranstaltung ist eine kurze Einführung in die Veranstaltung. Die Beschreibung wird für Kunden im Bildschirm mit den Ereignisdetails angezeigt.",
  EVENT_PIC_INFO:
    "Das 'Bild' der Veranstaltung ist für Kunden in der Kalenderübersicht sichtbar und wenn ein Kunde eine Veranstaltung zur Information / Buchung öffnet.",
  EVENT_YT_LINK_INFO:
    'Der YouTube-Link wird bereitgestellt, damit der Benutzer den Link in der YouTube-Anwendung oder im Web öffnen kann.',
  // Event agenda screen
  EVENT_BG_TYPE_INFO:
    'Die Verfügbarkeit eines Tagesordnungspunkts bestimmt, wie oft der Tagesordnungspunkt verfügbar ist. Entweder spezifisch für bestimmte Tage oder einen Tag oder wiederholt, wenn sich der Tagesordnungspunkt wiederholt.',
  EVENT_DATES_SEL_INFO:
    "Die 'Auswahl der Daten' sind die Daten, an denen der spezifische Tagesordnungspunkt abgehalten wird. Es sind mehrere Tage als Eingabe möglich. Mehrere Tage als Eingabe sind möglich.",
  EVENT_DAYS_SEL_INFO:
    'Die "Auswahl der Tage" sind die Tage, an denen der sich wiederholende Tagesordnungspunkt abgehalten wird. Mehrere Tage als Eingabe sind möglich.',
  EVENT_START_DATE_INFO:
    "Das 'Startdatum' ist das Startdatum, an dem der Tagesordnungspunkt gehalten wird",
  EVENT_END_DATE_INFO:
    'Das „Enddatum“ ist das Enddatum, an dem der Tagesordnungspunkt abgehalten wird',
  EVENT_START_TIME_INFO:
    "Die 'Startzeit' ist die Startzeit des Tagesordnungspunkts.",
  EVENT_END_TIME_INFO: "Die 'Endzeit' ist die Endzeit des Tagesordnungspunkts.",
  EVENT_INTERVAL_INFO:
    'Das Intervall ist die Dauer (in Minuten) zwischen dem Ende eines einzelnen Tagesordnungspunkts und dem Beginn des nächsten einzelnen Tagesordnungspunkts',
  EVENT_DURATION_INFO:
    'Die Dauer des Tagesordnungspunkts ist die Länge (in Minuten) eines einzelnen Tagesordnungspunkts, die mehrmals am Tag festgelegt werden kann.',
  EVENT_MAXINFLOW_INFO:
    'Der "maximale Zufluss" ist die maximale Anzahl von Personen, die gleichzeitig den Standort betreten können',
  EVENT_PRICE_INFO:
    "Der 'Veranstaltungspreis' ist der Preis, den ein Besucher für diesen Tagesordnungspunkt zahlen muss.",
  EVENT_RATE_PRICE_INFO:
    'Der "Preis" ist der Preis, den Sie bereit sind, zusätzlich zu zahlen, wenn der Tagesordnungspunkt einem Besucher vorgeschlagen wird.',
  EVENT_REWARD_POINTS_INFO:
    "Die 'Belohnungspunkte' sind die Punkte, die ein Besucher erhalten kann, wenn der Besucher diesen Tagesordnungspunkt bucht.",
  // Event communication screen
  EVENT_MSG_TITLE_INFO: "Der 'Nachrichtentitel' ist der Titel der Nachricht.",
  EVENT_MSG_TEXT_INFO: "Der 'Nachrichtentext' ist der Text der Nachricht.",
  EVENT_MSG_RWD_LVL_INFO:
    'Jedes Ereignis hat drei Belohnungsstufen. Klicken Sie auf eine der Belohnungsstufen, um die Benutzer anzugeben, an die eine Nachricht gesendet werden soll.',
  EVENT_MSG_USER_SEL_INFO:
    'Sie können eine Nachricht an die abonnierten Benutzer für das Ereignis, die nicht abonnierten Benutzer oder an beide senden.',
  EVENT_MSG_DATE_INFO:
    'Wählen Sie das Datum, an dem Sie die Nachricht senden möchten.',
  EVENT_MSG_TIME_INFO:
    'Wählen Sie die Zeit, zu der Sie die Nachricht senden möchten.',
  EVENT_MSG_COMM_TYPE_INFO:
    'Wählen Sie den Plattformtyp der Kommunikation für die zu sendende Nachricht.',

  NEW_QUADRANT: 'Neuen Quadranten erstellen',
  TYPE_QUADRANT: 'Art des Quadranten',
  TYPE_OBJECT: 'Objekt',
  SELECT_SIGNALS: 'Signale auswählen',
  NO_INCIDENT: 'Kein Vorfall',
  CONFIRM: 'Bestätigen',
  SELECTED_EVENT: 'Ausgewähltes Ereignis',

  // Batchgroup

  BATCHGROUP_NAME: 'Name der Chargengruppe',
  BATCHGROUP_EDIT: 'Batchgruppe bearbeiten',
  BATCHGROUP_DELETE: 'Batchgruppe löschen',
  BATCHGROUP_CONF_DELETE: 'Möchten Sie die Stapelgruppe wirklich löschen: ',
  BATCHGROUP_DESCRIPTION: 'Beschreibung der Chargengruppe',
  BATCHGROUP_CHAINBOX: 'Die Chargengruppe enthält verkettbare Chargen',
  BATCHGROUP_STARTTIME: 'Startzeit der Batchgruppe',
  BATCHGROUP_ENDTIME: 'Endzeit der Batchgruppe',
  BATCHGROUP_STARTDATE: 'Startdatum der Batchgruppe',
  BATCHGROUP_ENDDATE: 'Enddatum der Batchgruppe',
  BATCHGROUP_DATES: 'Daten der Chargengruppe',
  BATCHGROUP_INTERVAL: 'Die Chargen beginnen alle .... (min)',
  BATCHGROUP_INTERVAL_END: 'Chargen enden alle .... (min)',
  BATCHGROUP_CAPACITYPERBATCH: 'Capacity per batch',
  BATCHGROUP_DURATION: 'Dauer der Charge',
  BATCHGROUP_TYPERE: 'Wiederholen von Zeitfenster (s)',
  BATCHGROUP_ADD: 'Batchgruppe hinzufügen',
  BATCHGROUP_DETAILS: 'Chargengruppendetails',
  BATCHGROUP_CHOOSETYPE: 'Wählen Sie einen Stapelgruppentyp',
  BATCHGROUP_DAYS: 'Wählen Sie die Tage aus, an denen das Ereignis auftritt',
  BATCHGROUP_NOPASTDATE:
    'Bitte wählen Sie ein Datum, das nicht in der Vergangenheit liegt',
  BATCHGROUP_TYPESP: 'Bestimmte Daten',

  // External calendar
  EXTERNAL_CALENDAR: 'Externer Kalender',
  EXTERNAL_CALENDAR_ADD: 'Externen Kalender hinzufügen',
  EXTERNAL_CALENDAR_DELETE: 'Externen Kalender löschen',
  EXTERNAL_CALENDAR_CONF_DELETE:
    'Möchten Sie den folgenden Kalender wirklich löschen: ',

  // Products
  PRODUCT_CATEGORIES: 'Produktkategorien',
  PRODUCT_CATEGORY_EXPLANATION:
    'Um eine Produktkategorie für diese Veranstaltung hinzuzufügen, speichern Sie bitte zuerst die Veranstaltung!',
  PRODUCT_ADD_CATEGORY: 'Produktkategorie hinzufügen',
  PRODUCT_IN_STOCK: 'auf Lager',
  PRODUCT_DELETE: 'Delete product',
  PRODUCT_ASPECT_DELETE: 'Aspekt löschen',
  PRODUCT_ITEM_DELETE: 'Item löschen',
  PRODUCT_PRICE_CATEGORY_DELETE: 'Preiskategorie löschen',
  PRODUCT_CONF_DELETE: 'Möchten Sie dieses Produkt wirklich löschen:',
  PRODUCT_ASPECT_CONF_DELETE: 'Möchten Sie diesen Aspekt wirklich löschen:',
  PRODUCT_ITEM_CONF_DELETE:
    'Möchten Sie das ausgewählte Element wirklich löschen? ',
  PRODUCT_PRICE_CATEGORY_CONF_DELETE:
    'Möchten Sie die ausgewählte Preiskategorie wirklich löschen?',
  VIEW_PRODUCT: 'Produkt anzeigen',
  CREATE_PRODUCT: 'Ein Produkt erstellen',
  PRODUCT_NAME: 'Produktname',
  PRODUCT_PRICE: 'Preis des Produktes',
  PRODUCT_DESCRIPTION: 'Beschreibung des Produkts',
  PRODUCT_VAT: 'MwSt.% Des Produktes',
  PRODUCT_BRAND: 'Markenname des Produkts',
  PRODUCT_PICTURE: 'Bild des Produktes',
  PRODUCT_CATEGORIES: 'Kategorien des Produkts',
  PRODUCT_CAPACITY: 'Produktkapazität',
  PRODUCT_AGE: 'Mindestalter für das Produkt',
  PRODUCT_CATEGORY: 'Produktkategorie',
  PRODUCTS_ADD_MORE: 'Mehr hinzufügen',
  PRODUCT_SOLD_OUT: 'Nicht vorrättig',
  PREPARATION_INSTRUCTION_BTN: 'Anweisung',
  PREPARATION_INSTRUCTION_TITLE: 'Zubereitungsanleitung',
  PRODUCT_LEAD_TIME_ALERT: 'Dieses Produkt hat eine Mindestlieferzeit von',
  PRODUCT_DATE_TIME_ALERT: 'Dieses Produkt kann zwischen bestellt werden',
  PRODUCT_DATE_TIME: 'bis',
  INCL_VAT_TEMPLATE: 'inkl. %s MWST',
  EXCL_VAT_TEMPLATE: 'exkl. %s MwSt',
  INCL_VAT: 'inkl. MWST',
  EXCL_VAT: 'exkl. MwSt',
  PRODUCT_AVAILABILITY: 'Verfügbarkeit',
  PRODUCT_NOT_ALWAYS_AVAILABILITY: 'Nicht immer verfügbar',

  // Rental
  RENTAL_PERIOD: 'Wähle ein Datum',
  CHECK_AVAILABILITY: 'Zeitrauminformationen speichern',

  // Login
  LOGIN_YOUR_EMAIL: 'Ihr Emailadresse',
  LOGIN_YOUR_PASSWORD: 'Ihr Passwort',
  LOGIN_NO_ACCOUNT_YET: 'Noch keinen Account?',
  LOGIN_ACCOUNT_CREATION: 'Ein Konto erstellen',
  LOGIN_REPEAT_EMAIL: 'Bitte wiederholen Sie Ihre E-Mail-Adresse',

  // Linda input
  LINDA_SUGGESTIONS_DIALOG: 'Linda bekommt die Vorschläge',
  LINDA_FOOD_AND_BEVERAGE:
    'Hier können Sie vor oder nach Ihrer Veranstaltung Speisen und Getränke hinzufügen',
  LINDA_ADD_FOOD_BEFORE:
    'Fügen Sie vor Ihrer Veranstaltung Speisen und Getränke hinzu',
  LINDA_ADD_FOOD_AFTER:
    'Fügen Sie nach Ihrer Veranstaltung Speisen und Getränke hinzu',
  LINDA_SEARCHING: 'Linda is searching for your selected event',
  LINDA_LOGIN_WELCOME: 'Willkommen, ich heiße Linda.',
  LINDA_LOGIN_HELPING_HAND:
    'Ich werde Ihnen helfen, einen Tag zu planen, um sicherzustellen, dass Sie das Maximum aus Ihrem Tag herausholen und die Massen umgehen.',
  LINDA_LOGIN_SHORT_INFO:
    'Mit Linda können Sie innerhalb von 5 Minuten einen Termin vereinbaren. Mit diesem Termin sorgt Linda dafür, dass Ihr Tag nachlässig und verkehrsfrei ist.',
  LINDA_WELCOME: 'Herzlich willkommen!',
  LINDA_REGISTER_USERINFO:
    'Zu Beginn benötige ich einige Informationen, damit ich weiß, für wen ich plane.',
  LINDA_REGISTER_LATER:
    'This way i can notice you in a later stage for your appointment.',
  LINDA_REGISTER_DONE: 'Danke für die Registrierung!',
  LINDA_REGISTER_MAIL:
    ' Fertig! Vielen Dank, dass Sie Ihren accountName-Pass erstellt haben. Wir haben Ihnen eine Bestätigungs-E-Mail mit einem Link zur Aktivierung Ihres Reisepasses gesendet. Bitte klicken Sie auf den Link, um Ihren Reisepass zu aktivieren. Überprüfen Sie Ihren Spam-Ordner, falls Sie die Bestätigungs-E-Mail nicht erhalten haben. ',

  LINDA_BIGGER_GAP_OR_GROUPSIZE:
    'Versuchen Sie, die Zeitlücke zu vergrößern und / oder die Gruppengröße zu verkleinern.',
  LINDA_ACCOUNT_CREATION_FIRST_STEP: 'Großartig! Ihr Konto wurde erstellt',
  LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC:
    'Ich habe dir eine E-Mail mit einem Link geschickt.\n' +
    'Klicken Sie auf den Link in Ihrer E-Mail, um Ihr Konto zu aktivieren',
  LINDA_ACCOUNT_CREATION: 'Herzlich willkommen!',
  LINDA_WELCOME_BACK: 'Willkommen zurück!',
  LINDA_ACCOUNT_READY_TO_CREATE:
    'Zunächst muss ich wissen, wer Sie sind, damit ich ein Konto für Sie erstellen kann.',
  LINDA_USER_TRIPLIST:
    'Sehen Sie sich Ihre Termine an oder erstellen Sie einen neuen. Sie können Ihre Tickets abrufen, indem Sie auf einen Termin klicken.',
  LINDA_WHERE_TO: 'Wohin willst du gehen?',
  LINDA_SEARCH_EVENT: 'Wählen Sie ein Ereignis aus, um fortzufahren',
  LINDA_DATE_PICKER_WELCOME: 'Okay, lass uns ein Datum auswählen.',
  LINDA_DATE_PICKER: 'Wann planen Sie zu gehen?',
  LINDA_SPECIAL_CODE: 'Haben Sie per Post einen VIP-Code erhalten?',
  LINDA_TRIP_DETAIL:
    'Mit wem wollen Sie gehen und zu welcher Zeit werden Sie wohl ankommen und gehen?',
  LINDA_ACTIVITY_LIST:
    'Ich möchte eine Liste der Aktivitäten erstellen, die Sie sehen und ausführen möchten. Auf diese Weise stelle ich sicher, dass Sie sicher alle besuchen können.',
  LINDA_ADJUST_INFO:
    'Diese Informationen können zu einem späteren Zeitpunkt angepasst werden.',
  LINDA_MODE_OF_TRANSPORT: 'Wie planen Sie zu reisen?',
  LINDA_SAVING_A_SPOT:
    'Auf diese Weise kann ich Ihnen helfen, einen Parkplatz zu retten oder zu überprüfen, ob öffentliche Verkehrsmittel / Shuttlebusse verfügbar sind.',
  LINDA_CHECK_INPUT:
    'Bitte überprüfen Sie alle Daten, damit wir sicherstellen können, dass nichts schief geht.',
  LINDA_MEETING_SET: 'Der Buchungsvorgang ist abgeschlossen',
  LINDA_MEETING_SET2:
    'Ihre Buchungsanfrage wurde zur Bestätigung an unseren Partner weitergeleitet.',
  LINDA_ERROR: 'Etwas ist schief gelaufen.',
  LINDA_ERROR_PAYMENT:
    'Ihre Zahlung wurde nicht erhalten. Überprüfen Sie Ihr Konto',
  LINDA_ADJUST_TIME:
    'Sie können die Zeit und das Transportmittel ändern, wenn es nicht mehr korrekt ist.',
  REGISTER_LINDA: 'Registrieren',
  LINDA_EVENT_NAME: 'Wählen Sie eine Veranstaltung',
  LINDA_VIP: 'Rabattcode',
  LINDA_VIP_DIALOG:
    'Wenn Sie einen Rabattcode in Ihrer E-Mail erhalten haben, geben Sie diesen bitte unten ein oder klicken Sie auf Weiter.',
  LINDA_USERGROUP_DIALOG:
    'Wenn Sie einen speziellen Code erhalten haben, geben Sie diesen bitte unten ein',
  LINDA_VIP_INPUT: 'Bitte geben Sie hier Ihren Rabattcode ein',
  LINDA_GROUP_SIZE: 'Gruppengröße',
  LINDA_GS_INPUT: 'Gruppengröße festlegen',
  LINDA_ARRIVAL: 'Erwartete Ankunft',
  LINDA_ARRIVAL_LABEL: 'Arrival time',
  LINDA_DEPARTURE_LABEL: 'Abfahrtszeit',
  LINDA_DEPARTURE: 'Voraussichtliche Abreise',
  LINDA_TRANSPORT_TYPE: 'Transportart',
  LINDA_ATTEND: 'Was möchtest du besuchen?',
  LINDA_NO_SUBEVENTS: 'Es sind keine Unterereignisse verfügbar',
  LINDA_FILL_REQUIRED: 'Please fill in all the required fields',
  LINDA_NEW_APPOINTMENT: 'Neuer Termin',
  LINDA_APPOINTMENTS: 'Ihre Termine',
  LINDA_NO_APPOINTMENTS: 'Keine Termine',
  LINDA_GO_TO_APPOINTMENTS: 'Gehe zu meinen Aktivitäten ',
  LINDA_ORDER: 'Deine Bestellung',
  LINDA_STARTTIME: 'Startzeit',
  LINDA_ENDTIME: 'Endzeit',
  LINDA_DELETE_APPOINTMENT: 'Möchten Sie den Termin wirklich löschen?',
  LINDA_CALENDAR_CROWDED: 'Überfüllt ',
  LINDA_CALENDAR_CALM: 'Ruhe ',
  LINDA_CALENDAR_AVERAGE: 'Durchschnittlich ',
  LINDA_CALENDAR_SELECTED: 'Ausgewählt ',
  LINDA_TRANSPORT_MODE: 'Transportart',
  LINDA_NO_TRANSPORT_AVAILABLE: 'Es ist kein Transportmittel verfügbar',
  LINDA_MANDATORY_TRANSPORT:
    'Bitte wählen Sie ein Transportmittel, um fortzufahren',
  LINDA_TOTAL_PRICE: 'Gesamtpreis',
  LINDA_CANCEL_ORDER: 'Stornieren',
  LINDA_CONFIRM_ORDER: 'Bestätigen',
  LINDA_ORDER_FAILED:
    'Der Termin wurde gelöscht. Weitere Anweisungen finden Sie in Ihrer E-Mail.',
  CLOSE: 'Schließen',
  LINDA_REGISTER_TO: 'Registrieren Sie sich für ...',
  LINDA_MISS_NOTHING: 'Nichts vermissen',
  LINDA_OWN_PROGRAM: 'Erstellen Sie Ihr eigenes Programm',
  LINDA_AVOID: 'Vermeiden Sie Warteschlangen',
  LINDA_PLAN_VISIT: 'Planen Sie Ihren Besuch mit Linda',
  LINDA_ENJOY: 'In vollen Zügen genießen',
  LINDA_ADVANTAGE: 'Profitieren Sie von Extras und Rabatten',
  LINDA_ACCOUNT_MADE_TITLE:
    'Großartig! Das Konto wird erstellt. Um das Konto zu aktivieren, benötige ich den Stil Ihres Unternehmens.',
  LINDA_ACCOUNT_MADE_BODY:
    'Ich werde sicherstellen, dass Ihr Konto so aussieht, als ob es Ihnen gehört',
  LINDA_NONE: 'Keiner',
  LINDA_PLANNED_SUCCESSFULL: 'Eine Bestätigungs-E-Mail wurde gesendet',
  LINDA_PLANNED_SUCCESSFULL2:
    'Sie erhalten eine Nachricht, wenn der Partner Ihre Buchungsanfrage bestätigt oder abgelehnt hat.',
  LINDA_KEEPS_PROMISE: 'Den Termin finden Sie in meinen Aktivitäten§',
  LINDA_TICKETS_TO_MAIL:
    'Ich habe die Tickets per Post an Ihr Mail-Konto gesendet!',
  LINDA_TICKET_INFO_ACCOUNT:
    'Sie können die Tickets auch abrufen, indem Sie auf die Informationen Ihres Termins klicken.',
  LINDA_BG_MEANING:
    'Um die Benutzer auf Ihre Einrichtungen zu verteilen, müssen Sie Stapelgruppen erstellen. Diese Chargengruppen bestehen aus verschiedenen Chargen.',
  LINDA_BG_FILLING:
    'Damit kann ich die Benutzer für verschiedene Chargen einplanen und sicherstellen, dass alle Chargen gut gefüllt sind.',
  LINDA_THEME: 'Thema',
  LINDA_GETTING_EVENTS: 'Linda bekommt die Ereignisse',
  LINDA_CHECK_YOUR_ORDER: 'Überprüfen Sie Ihre Auswahl',
  LINDA_PLEASE_FILL_IN: 'Bitte füllen Sie die Felder aus',

  // Web stepper two

  STEP_THEME: 'Thema auswählen',
  STEP_DETAILS: 'Reisedetails',
  STEP_WISHLIST: 'Wunschzettel',
  STEP_PLAN: 'Planen Sie Ihren Tag',
  STEP_TRANSPORT: 'Transportmodus',
  STEP_ISSUES: 'Probleme',
  STEP_CONFIRM: 'Bestätigung',

  PREVIOUS: 'Bisherige',
  CONTINUE: 'Fortsetzen',
  NEXT: 'Nächster',
  CANCEL: 'Stornieren',
  CANCEL_TOOLTIP: 'Stornieren',
  LOGIN: 'Anmeldung',
  USERNAME: 'Nutzername',
  PASSWORD: 'Passwort',
  LOGIN_TEXT: 'Hast du schon einen Account?',
  REGISTER_TEXT: 'Ein Konto erstellen',
  ACTIVATION_CODE_REQUIRED: 'Aktivierungscode ist erforderlich',
  ACTIVATION_CODE_TITLE: 'Aktivierungscode: Erstellen Sie Ihr Konto. ',
  ACTIVATION_CODE_TEXT:
    'Bitte geben Sie den Aktivierungscode ein, den Sie nach dem Erstellen Ihres Kontos per E-Mail erhalten haben. ',
  ACTIVATION_CODE_INPUT: 'Geben Sie Ihren Aktivierungscode ein',
  ALERT:
    'Die App ist noch nicht verfügbar. Sie erhalten eine E-Mail, sobald die App zum Herunterladen verfügbar ist.',
  MAKE_ROUTE: 'Route machen',

  TITLE: 'Titel',
  TEXT: 'Text',
  DESTINATION: 'Ziel',
  ACCOUNT_PREFERENCES_SAVED_CORRECTLY:
    'Kontoeinstellungen werden korrekt gespeichert!',
  PARTNER_PREFERENCES_SAVED_CORRECTLY:
    'Partnereinstellungen werden korrekt gespeichert!',
  ACCOUNT_ALREADY_ACTIVATED: 'Dein Benutzerkonto ist bereits aktiviert!',
  LOCATION_CREATION_OK: 'Standort erfolgreich erstellt ',
  LOCATION_EDITING_OK: 'Speicherort erfolgreich bearbeitet',
  USERGROUP_INFO_SAVED_OK:
    'Benutzergruppeninformationen wurden erfolgreich gespeichert',
  ACCOUNT_SAVED_OK: 'Konto erfolgreich gespeichert',
  USERGROUP: 'Benutzergruppe',
  DELETE_USERGROUP_TITLE: 'Sind Sie sicher, die Benutzergruppe zu löschen?',
  ACCOUNT_MNG: 'Kontoverwaltung',
  CREATE: 'Erstellen',
  SEND: 'Senden',
  SAVE: 'speichern',
  DELETE: 'Löschen',
  SAVE_TOOLTIP: 'Änderungen speichern',
  SEND_VIP_CODE: 'VIP-Code senden',
  SEND_USERGROUP_CODE: 'Code senden',

  ONCE_ONLY_NOTIFICATION: 'Nur einmalige Benachrichtigung',
  CREATE_NEW_NOTIFICATION: 'Neue Benachrichtigung erstellen',
  LOCATION_NOTIFICATION: 'Standortbenachrichtigungen',
  ALL_NOTIFICATION: 'Alle Benachrichtigungen',
  EDIT_NOTIFICATION: 'Benachrichtigung bearbeiten',

  CONFIRM_REGISTER: 'Registrierung bestätigt',

  NO_ACCOUNT_ID:
    'In der URL ist keine Konto-ID angegeben, oder das Konto ist für dieses Konto nicht vorhanden',
  NO_PARTNER_ID:
    'Die Partner-ID ist ungültig oder nicht in der URL angegeben. Bitte geben Sie eine gültige Partner-ID ein.',
  ACCOUNT_NAME: 'Kontobezeichnung',
  ACCOUNT_DESCRIPTION: 'Account Beschreibung',
  LOCATION_OVERVIEW: 'Standortübersicht',
  EVENT_OVERVIEW: 'Ereignisübersicht',
  LOCATIONS: 'Standorte',
  CREATE_TOUR: 'Tour erstellen',
  CONFIGURE_ROUTE: 'Route konfigurieren',
  SHOW_ROUTE: 'zeige Weg',
  SHOW_WAYPOINTS: 'Wegpunkte anzeigen',
  ACCOUNT_TITLE: 'Konto',
  DASHBOARD_TITLE: 'Instrumententafel',
  ACCOUNT_URL: 'Webadresse',
  ACCOUNT_EMAIL: 'Administrator der E-Mail-Adresse',
  ACCOUNT_TITLE_AUTOCOMPLETE: 'Organisation benennen',
  ACCOUNT_TITLE_CREATE_STYLE: 'Kreieren Sie Ihren eigenen Stil',
  ACCOUNT_URL_AUTOCOMPLETE: 'Webadresse',
  ACCOUNT_EMAIL_AUTOCOMPLETE: 'Administrator der E-Mail-Adresse',
  ACCOUNT_CONFIRMATION: 'Account Bestätigung',
  ACCOUNT_SELECTION_CONFIRMATION:
    'Möchten Sie Ihr Konto wirklich mit diesen Daten bestätigen?',
  ACCOUNT_CHANGES_LATER: 'Sie können es später noch ändern',
  ACCOUNT_LINK: 'Verknüpfung',
  ACCOUNT_MAIN_LOCATION: 'Hauptstandort',
  ACCOUNT_ADMIN_NUMBER_SALE: 'Verkaufsverwaltungsnummer',
  ACCOUNT_ADMIN_NUMBER_FEE: 'Verwaltungskosten',
  ACCOUNT_SERVICE_PERCENTAGE: 'Service-Rate',
  ACCOUNT_MAX_PREBOOKS: 'Max Prebooks',
  ACCOUNT_HIGH_VAT: 'Hoch VAT',
  ACCOUNT_LOW_VAT: 'Niedrig VAT',
  'ACCOUNT_SALES_&_FEES': 'Verkaufs- und Kosteneinstellungen für',
  ACCOUNT_BOOKNUMBER_FEE: 'Buchnummer Gebühren',
  ACCOUNT_JOURNAL_NUMBER_SALES: 'Journalnummer Vertrieb',
  ACCOUNT_JOURNAL_NUMBER_FEES: 'Journalnummer Gebühren',
  ACCOUNT_NAME_OF_FILE: 'Name der Datei',
  ACCOUNT_MONTHLY_FEE_GENERATION_DAY: 'Tag der monatlichen Gebühr',
  ACCOUNT_GENERATION_DAY: 'Generationentag',
  ACCOUNT_SAVE_SALES_FEE:
    'Bitte speichern Sie die Einstellungen für Umsatz und Kosten, bevor Sie auf die folgenden Schaltflächen klicken.',
  ACCOUNT_BOTH_BUTTONS: 'Beide Tasten werden auf Rechnung aufgerufen',
  ACCOUNT_GENERATE_SALES_FEES: 'Verkaufskosten generieren',
  ACCOUNT_GENERATE_MONTHLY_FEES: 'Generieren Sie monatliche Kosten',
  ACCOUNT_USERGROUP_NAME: 'Benutzergruppenname',
  ACCOUNT_NEW_USERGROUP: 'Neue Benutzergruppe',
  ACCOUNT_EDIT_USERGROUP: 'Benutzergruppe bearbeiten',
  ACCOUNT_USER_ID: 'Benutzer ID',
  ACCOUNT_DELETE_USER: 'Sind Sie sicher, dass Sie den Benutzer löschen möchten',
  ACCOUNT_VAT_NUMBER: 'VAT nummer',
  ACCOUNT_VAT_BTW: 'Partner VAT nummer (BTW)',
  ACCOUNT_CAMPAIGN_BUDGET: 'Budgetkampagne',
  ACCOUNT_PARTNER_SUPPLIER_CODE: 'Partner-Lieferantencode',
  ACCOUNT_SUPPLIER_CODE: 'Lieferantencode',
  // Tool Bar
  FINANCIAL_MANAGEMENT: 'Finanzverwaltung',
  FINANCIAL: 'Finanziell',
  THEME_LIST: 'Startseite',
  THEMES: 'Höhepunkte',
  STATISTICS: 'Statistiken',

  // home
  REGISTER: 'Registrieren',
  REGISTER_HEAD: 'Verpassen Sie nichts ',
  WHY_REGISTER: `Warum registrieren für ${appConfig.dss.environmentName}-app?`,
  REGISTER_LIST: `Genieß das ${appConfig.dss.environmentName} in vollem Umfang mit diesen Vorteilen nur für App-Benutzer.`,
  REGISTER_CONFIRMATION_EMAIL:
    'Wir haben Ihnen eine Bestätigungs-E-Mail mit einem Link zur Aktivierung Ihres Kontos gesendet.',
  REGISTER_SPAM_WARNING:
    'Überprüfen Sie Ihren Spam-Ordner, falls Sie die Bestätigungs-E-Mail nicht erhalten haben.',
  REGISTER_LIST_1:
    'Wir halten Sie über Ihre Lieblingsveranstaltungen auf dem Laufenden.',
  REGISTER_LIST_2: 'Gewinne tolle Preise.',
  REGISTER_LIST_3: 'Kaufen Sie Ihr Parkticket online.',
  REGISTER_LIST_4: 'Erhalten Sie Sonderangebote und Rabatte.',
  REGISTER_LIST_5: 'Finden Sie einfach Ihren Weg mit der praktischen Karte.  ',
  REGISTER_LIST_6: `Registrieren Sie sich für ein Konto und laden Sie das herunter ${appConfig.dss.environmentName} im Apple App Store oder bei Google Play.`,
  REGISTER_NOW: 'Jetzt registrieren',
  // register
  REGISTER_DETAILS: 'Ein Konto erstellen',
  REGISTER_DETAILS_INFO:
    'Bitte geben Sie uns einige persönliche Daten, damit wir ein Konto für Sie erstellen können',
  REGISTER_INFO: 'Warum fragen wir nach diesen Informationen?',
  REGISTER_PHONE: 'Handynummer: ',
  REGISTER_PHONE_TEXT:
    'Wir werden Sie mit Textnachrichten auf dem Laufenden halten, wenn es ein Problem mit der App gibt.',
  REGISTER_VIP: 'Sondercode ',
  REGISTER_VIP_TEXT: `Haben Sie einen Code von der erhalten? ${appConfig.dss.environmentName} Organisation? Bitte gebe es hier ein. Ansonsten lassen Sie bitte das Feld leer. `,
  REGISTER_ZIPCODE: 'Postal code: ',
  REGISTER_ZIPCODE_TEXT:
    'Früher haben wir Einblicke erhalten, woher unsere Besucher kommen, damit wir mehr Sponsoren gewinnen und die Veranstaltung für Besucher kostenlos halten können. ',
  REGISTER_LICENSE: 'Nummernschild: ',
  REGISTER_LICENSE_TEXT:
    'Wenn Sie mit dem Auto anreisen, geben Sie Ihr Nummernschild ein, um schnell zum Parkplatz zu gelangen. ',
  REGISTER_CHECKBOX: 'Ich stimme dem zu',
  REGISTER_PRIVACY_STATEMENT: 'Datenschutzerklärung',
  AGREE_PRIVACY_STATEMENT:
    'Durch die Erstellung eines Kontos stimmen Sie unseren zu',
  REGISTER_KEEP_ME_UP_TO_DATE: `Ja, bitte halten Sie mich auf dem Laufenden ${appConfig.dss.environmentName}`,
  REGISTER_FORM_NAME: 'Name',
  REGISTER_FORM_LASTNAME: 'Nachname',
  REGISTER_FORM_EMAIL: 'Email',
  REGISTER_FORM_PHONE: 'Handynummer',
  REGISTER_FORM_ZIP: 'Postleitzahl',
  REGISTER_FORM_COUNTRY: 'Wähle ein Land',
  REGISTER_FORM_VIP: 'Sondercode',
  REGISTER_FORM_LICENSE: 'Nummernschild',
  REGISTER_ACCOUNT: 'Registrieren Sie einen Account',
  REGISTER_INTEREST_TITLE: 'Interessen',
  REGISTER_INTEREST:
    'Teilen Sie uns mit, woran Sie interessiert sind, damit wir Ihnen bevorstehende Veranstaltungen anbieten können, die Ihren Interessen entsprechen',
  REGISTER_ACCOMPANY:
    'Lassen Sie uns wissen, wer Sie begleitet, damit wir Ihnen bei der Auswahl geeigneter Veranstaltungen helfen können.',
  REGISTER_ACCOMPANY_TITLE: 'Ich werde mit besuchen',
  REGISTER_ACCOUNT_EXIST:
    'Konto existiert. Sie können sich mit Ihrem PG_NAME-Konto anmelden.',
  REGISTER_ACCOUNT_EXIST_CURR_PG:
    'Konto existiert. Sie können sich direkt einloggen oder Ihr Passwort zurücksetzen, falls Sie es vergessen haben.',
  REGISTER_ACCOUNT_NOT_ACTIVATED:
    'Konto erstellt, aber noch nicht aktiviert. Gehen Sie zu Ihrem Postfach, um Ihr Konto zu aktivieren.',
  REGISTER_ACCOUNT_RESEND_ACTIVATION_EMAIL:
    'Sie haben die Aktivierungs-E-Mail nicht erhalten? Klicken Sie auf die Schaltfläche unten, um die E-Mail erneut zu senden.',
  RESEND_ACTIVATION_MAIL_SUCCESS_TITLE:
    'Die Aktivierung E-Mail wurde an Ihre Mailbox gesendet. Überprüfen Sie Ihre E-Mails und aktivieren Sie Ihr Konto.',
  GENERATE_PASS: 'Generiere Passwort',

  GRAPH_0_LABEL_0: 'Ist eingetroffen',
  GRAPH_0_LABEL_1: 'Erwartet',
  GRAPH_0_OPT: 'Bezoekers',
  GRAPH_N_ARRIVALS: 'Anzahl der Ankünfte',
  GRAPH_N_ARRIVALS_OPT: 'Optimierte Anzahl der Ankünfte',
  GRAPH_N_DEPARTURE_OPT: 'Optimierte Anzahl der Abfahrten',
  GRAPH_N_DEPARTURE: 'Anzahl der Abfahrten',

  GRAPH_0: 'Gesamt',
  GRAPH_1: 'Fest',
  GRAPH_2: 'Biegen',
  GRAPH_3: 'Locker',
  GRAPH_4: 'Warteschlangenlänge',
  GRAPH_5: 'Aktuell',

  EVENT_GRAPH_ORDER_TYPE:
    'Das ausgewählte Ereignis verfügt möglicherweise über eine Zustellungs- und eine Mitnahmeoption. Wählen Sie eine aus (falls möglich), um das Diagramm anzuzeigen:',
  EVENT_GRAPH_SELECT_ORDER_TYPE: 'Bitte wählen Sie die Bestellart',
  EVENT_GRAPH_DATE_PICKER:
    'Wählen Sie ein Datum aus, um die erwarteten Besucherzahlen basierend auf der Anzahl der Reservierungen an diesem Tag anzuzeigen',
  EVENT_GRAPH_DETAILS: 'erwartete Menschenmengen',
  EVENT_LOCATION_MAP: 'Veranstaltungsort',

  ERROR_EVENT2_01: 'Ankünfte überschreiten die Kapazität dieser Veranstaltung',
  ERROR_EVENT2_02:
    'Warteschlangenlänge oder Wartezeit überschreiten den Schwellenwert ',

  ERROR_DESTINATION_01: 'Datenbankverbindungsfehler',
  ERROR_DESTINATION_02: 'PushNotificationBridge-Verbindungsfehler',
  ERROR_DESTINATION_03:
    'Ereignis in der Vergangenheit neu planen (nicht möglich)',
  ERROR_DESTINATION_04:
    'Inkonsistente Ereignisdaten (Zeitfenster, in dem endTime <= startTime)',
  ERROR_DESTINATION_05:
    'Maximale Kapazität überschritten (beim Versuch, ein Ereignis neu zu planen)',
  ERROR_DESTINATION_06:
    'Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)',
  ERROR_DESTINATION_07: 'Endzeit - Startzeit größer als die Intervalldauer',
  ERROR_DESTINATION_08: 'Das übergeordnete Objekt ist nicht vom Typ Ziel',
  ERROR_DESTINATION_09: 'Übergeordnetes Objekt null',
  ERROR_DESTINATION_10: 'Aktuelles Objekt null',
  ERROR_DESTINATION_11: 'Ereignis in der Vergangenheit zurückgesetzt',
  ERROR_DIT_01:
    'Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)',
  ERROR_DIS_01:
    'Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)',
  ERROR_DIT_02: 'Dit Thread läuft bereits',
  ERROR_EVENT_01: 'Übergebene Ereignis-ID nicht korrekt bestanden',
  ERROR_EVENT_02: 'Übergebene Steckplatz-ID nicht korrekt',

  REGISTER_VISIT_WITH: `ich werde besuchen ${appConfig.dss.environmentName} mit`,
  REGISTER_MYSELF: 'Myself',
  REGISTER_PARTNER: 'Meine Partnerin',
  REGISTER_FRIENDS: 'Freunde',
  REGISTER_KIDS: 'Kinder',
  REGISTER_SCHOOL: 'Schule',

  SUCCES_REGISTER: 'Hurra! Ihr Konto wurde erstellt',
  SUCCES_REGISTER_TEXT_1:
    'Sie haben eine E-Mail mit einem Link zur Aktivierung Ihres Kontos erhalten',
  SUCCES_REGISTER_TEXT_2:
    'Hier ist Ihre eindeutige Benutzer-ID. Verwenden Sie diese Option, um die App nach dem Herunterladen im Apple App Store oder bei Google Play zu aktivieren. Sie erhalten außerdem Ihre Benutzer-ID in Ihrer E-Mail mit Anweisungen zum Aktivieren der App.',
  SUCCES_REGISTER_USER_ID: 'Ihre Benutzer-ID:',
  DOWNLOAD: 'Laden Sie die App herunter',
  APPLE: 'für Apple',
  ANDROID: 'für Android',

  APPLY: 'Anwenden',

  TAGS: 'Stichworte',
  TAGS_EVENT: 'Wählen Sie Ihre Lieblings-Tags aus',
  TAGS_TEXT:
    'Bitte wählen Sie die Tags aus, die Ihnen gefallen, damit wir Ihnen Ereignisse im Zusammenhang mit diesen Tags anzeigen können.',
  TAGS_REQ: 'Bitte wählen Sie die Tags aus',

  // Ticket
  TICKET_NEW: 'Neuer Ticket-Typ',
  TICKETS_PRICING_EXPLANATION:
    'Da die Preisgestaltung extern verwaltet wird, besteht keine Möglichkeit, ein Ticket hinzuzufügen',
  TICKET_SOME_EXPLANATION: 'Einige Erklärungen zu den Ticketarten',
  TICKET: 'Tickets',
  TICKET_EVENT: 'Wählen Sie Ihre Lieblingsereignisse',
  TICKET_TEXT:
    'Bitte wählen Sie die Tage aus, an denen Sie uns besuchen, damit wir Sie über Ihre Lieblingsveranstaltungen auf dem Laufenden halten können. Sie können auch sofort Tickets für bezahlte Veranstaltungen kaufen.',
  TICKET_WARNING: 'bitte beachten Sie',
  TICKET_TEXT_1:
    ' Das Parken wird am Samstag, den 30. Juni bezahlt. Kaufen Sie Ihr Ticket online, indem Sie rechts „Parken“ auswählen. Mit einem Online-Ticket können Sie die Warteschlange überspringen und den Aufwand der Barzahlung vermeiden.',
  TICKET_TEXT_2:
    'Die gekauften Tickets sind nicht erstattungsfähig und nicht übertragbar. Sie erhalten Ihre Tickets von 30 Minuten nach Abschluss des Zahlungsvorgangs per E-Mail. ',
  TICKET_TEXT_3: 'Durch den Online-Kauf Ihrer Tickets stimmen Sie unseren zu',
  TICKET_TEXT_TERMS: 'allgemeine Begriffe.',
  TICKET_ATTEND: 'An welchen Tagen möchten Sie teilnehmen?',
  TICKET_ARRIVING: 'Wann kommen Sie an?',
  TICKET_INFORMATION: 'Tickets werden von der Eventorganisation bearbeitet.',
  TICKET_INFORMATION2: 'Am Standort kann eine Eintrittsgebühr erhoben werden.',

  // Linda output
  TRIPS: 'Reisen',
  TRIP_WELCOME: 'Willkommen in Ihrer Triplist',
  TRIP_CHOICE:
    'Bitte wählen Sie eine Reise in Ihrer speziellen Dreifachliste aus, um sie anzuzeigen oder zu löschen. Wenn Ihre Dreierliste keine Reise enthält, können Sie eine Reise für dieses Ereignis erstellen, indem Sie auf das Symbol "+" in der oberen rechten Ecke klicken.',
  TRIP_STARTED: 'Lassen Sie uns Ihre Reise personalisieren',
  TRIP_EVENT_PICKER:
    'Bitte wählen Sie aus den folgenden Veranstaltungen eine Auswahl aus. Wenn Sie einen weiteren Tag für dieselbe Veranstaltung oder eine neue Reise hinzufügen möchten, ist dies nach Abschluss dieser Veranstaltungsregistrierung möglich!',
  TRIP_DATEPICKER:
    'Nachdem Sie nun wissen, welche Veranstaltung Sie besuchen werden, können Sie das richtige Datum für die Besichtigung der Veranstaltung auswählen. Bitte klicken Sie auf das Datum, an dem Sie die Veranstaltung besuchen möchten.',
  TRIP_PLAN: 'Planen Sie meine Reise',

  PAYMENT: 'Bitte bestätigen Sie Ihre Auswahl',
  PAYMENT_TEXT:
    'Bitte überprüfen Sie die folgenden Daten und bestätigen Sie Ihre Auswahl, um Ihre Ticketregistrierung abzuschließen.',
  PAYMENT_CONFIRM: 'Bestätigen',
  PAYMENT_CONFIRM_PAY: 'Bestätigen und zahlen',
  PAYMENT_OVERVIEW: 'Veranstaltungsübersicht:',
  ARRIVAL_INFO: 'Ausgewählte Veranstaltungstage:',
  ARRIVAL_TIME: 'Voraussichtliche Ankunftszeit:',
  TOTAL_PRICE: 'Gesamtpreis:',

  TICKET_SUCCES: 'Hurra! Wir freuen uns, Sie begrüßen zu dürfen.',
  // 'TICKET_SUCCES_1': 'Your registration is successful. We’ll send you a confirmation by email.',
  TICKET_SUCCES_1: `Ihre Registrierung ist erfolgreich. Viel Glück und genießen Sie die ${appConfig.dss.environmentName} !`,
  TICKET_SUCCES_2: `Jetzt ist es Zeit, die App herunterzuladen und zu aktivieren, um die Chance auf diese schönen Preise zu haben. Viel Glück und genießen Sie die ${appConfig.dss.environmentName} !`,

  TICKET_ORDER: 'Tickets bestellen',
  TICKET_ORDER_1: 'Bestätige deine Bestellung',
  TICKET_ORDER_2: '',
  EVENT_PAYMENT: 'Zahlungsvorgang',
  EVENT_PAYMENT_INFO:
    'Sie werden zu Mollie-Zahlungen weitergeleitet, um Ihren Zahlungsvorgang abzuschließen',
  EVENT_PAYMENT_INFO_1: '',
  TRIP_TICKETS: 'Tickets herunterladen',

  PAYMENT_SUCCESS: 'Zahlung erfolgreich abgeschlossen',
  PAYMENT_FAILED: 'Bezahlung fehlgeschlagen',
  TO_APP_USERS:
    'Wenn Sie ein App-Benutzer sind, kehren Sie bitte zur App zurück, um fortzufahren!',

  TICKET_UNSUCCESSFUL:
    'Hoppla! Es tut uns sehr leid, aber Ihre Zahlung war nicht erfolgreich',
  TICKET_UNSUCCESSFUL_TEXT:
    'Bitte versuchen Sie es erneut. Wir sind sicher, dass dies nur eine Panne ist. Wenn dieses Problem weiterhin auftritt, wenden Sie sich an das Kundendienstzentrum von The Driving Force unter customerservice@thedrivingforce.nl oder telefonisch unter +31 297 51 44 55.',
  RETRY: 'Wiederholen',

  SUCCES_PAYMENT: 'Hurra! Ihre Zahlung war erfolgreich.',
  SUCCES_PAYMENT_1:
    'Ihre Registrierung ist nun abgeschlossen. Wir senden Ihnen eine Bestätigung per E-Mail mit Ihren Tickets. Wir freuen uns, Sie begrüßen zu dürfen.',
  SUCCES_PAYMENT_2: `Jetzt ist es Zeit, die App herunterzuladen und zu aktivieren, um die Chance auf diese schönen Preise zu haben. Viel Glück und genießen Sie die ${appConfig.dss.environmentName}. `,
  Website_Down_1:
    'Es tut uns sehr leid, aber die Website ist vorübergehend nicht verfügbar.',
  Website_Down_2: 'Wir arbeiten daran und es wird sehr bald zurück sein.',

  DRIP_OBJECT_NAME: 'Name DRIP',
  DRIP_OBJECT_DESCRIPTION: 'Description von DRIP',
  DRIP_LOCATION: 'Klicken Sie mit der rechten Maustaste auf den DRIP',
  DRIP_IPADDRESS: 'IP adres von DRIP',
  DRIP_PORT: 'Port number von DRIP',
  DRIP_WINDOWNAME: 'Window name von DRIP',
  DRIP_HEIGHT: 'Height von DRIP',
  DRIP_BREADTH: 'Width von DRIP',

  PRIS_OBJECT_NAME: 'Name von PRIS',
  PRIS_OBJECT_DESCRIPTION: 'Beschreibung von PRIS',
  PRIS_LOCATION: 'Klicken Sie mit der rechten Maustaste auf PRIS',
  PRIS_IPADDRESS: 'IP adres von PRIS',
  PRIS_PORT: 'Portnummer von PRIS',
  PRIS_WINDOWNAME: 'Fenstername von PRIS',
  PRIS_HEIGHT: 'Höhe von PRIS',
  PRIS_BREADTH: 'Breite von PRIS',

  VRI_OBJECT_NAME: 'Name von PRIS',
  VRI_OBJECT_DESCRIPTION: 'Beschreibung von PRIS',
  VRI_WEBSITE: 'Webseite',
  VRI_IP: 'IP-Adressen',
  VRI_IVERA: 'Ivera',
  VRI_IVERA_NAME: 'Ivera name',
  VRI_PASSWORD: 'Ivera Passwort',
  VRI_ITS: 'Seinen Namen',
  VRI_ITS_PASSWORD: 'SEIN Passwort',
  VRI_TRIGGER_CERT: 'Zertifikat auslösen',
  VRI_CERT: 'VRI-Zertifikat',
  VRI_TRIGGER_IP: 'IP auslösen',
  VRI_VTYPE: 'V Art',
  VRI_VVERSION: 'V Ausführung',
  VRI_VNAME: 'V name',
  VRI_VPASSWORD: 'V Passwort',
  VRI_VSOURCE: 'V Quelle',
  VRI_VIP: 'VIP',
  VRI_VPORT: 'V Port',
  VRI_CAPACITY: 'Kapazität',
  VRI_NOTES: 'Anmerkungen',
  VRI_CONFIG: 'Konfigurieren',
  VRI_XY: 'XY',
  VRI_KPP: 'KPP',
  VRI_ATTACHMENT: 'Anhänge',

  NO_RELATION: 'Keine Beziehungen',
  NO_TRAFFIC_OBJECTS: 'Keine Verkehrsobjekte',
  NO_SENSOR_ACTUATOR: 'Keine Sensoraktoren',
  NO_EVENTS: 'Keine Ereignisse',
  NO_EVENTS_AVAILABLE: 'Keine Veranstaltungen verfügbar',
  AVAILABLE: 'Verfügbar',
  ADD_RELATION: 'Beziehung hinzufügen',
  ADD_TRAFFIC_OBJECT: 'Verkehrsobjekt hinzufügen',
  ADD_SENSOR_ACTUATOR: 'Sensoraktor hinzufügen',
  ADD_EVENTS: 'Ereignis hinzufügen',
  NO_ENTRY_EXIT_POINTS: 'Keine Ein- / Ausstiegspunkte',
  ENTRY_EXIT_POINTS: 'Ein- und Ausstiegspunkte ',
  INCIDENTS: 'Vorfälle',
  RELATIONS: 'Beziehungen',
  TRAFFIC_OBJECTS: 'Verkehrsobjekt',
  SENSOR_ACTUATOR: 'Sensor / Aktoren',
  SAVE_RELATION: 'Beziehung speichern',

  OP_SCREEN: 'Betriebsbildschirme',
  MAP_TITLE: 'Karte',
  ROUTE_MAP_TITLE: 'Straßenkarte',
  ROUTE_MAP_DESC:
    'Klicken Sie auf die Karte, um den Routeneditor aufzurufen. Im Routeneditor können Sie die Route anpassen, Ihrer Route Stopps hinzufügen und vieles mehr.',
  TRAVEL_MODE: 'Reisemodus',
  EVENT_START_PLANNING: 'Planen',
  ORDERS: 'Aufträge',
  EVENT_START_SIMULATE: 'Simulieren',
  FILTER_OPTIONS: 'Filteroptionen',

  INVALID_ENDDATE: 'Das Enddatum liegt vor dem Startdatum.',
  INVALID_ENDTIME: 'Die Abfahrtszeit liegt vor der Ankunftszeit.',
  INVALID_INPUT: 'Die Eingabefelder sind falsch ausgefüllt.',
  INVALID_WEBSITE: 'Ungültige Website',
  INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
  FIELD_REQUIRED: 'Feld ist erforderlich',
  FIELD_MAX_LENGTH_32: 'Die Feldlänge darf 32 Zeichen nicht überschreiten!',
  FIELD_MAX_LENGTH_1024: 'Die Feldlänge darf 1024 Zeichen nicht überschreiten!',
  FIELD_MAX_LENGTH_64: 'Die Feldlänge darf 64 Zeichen nicht überschreiten!',
  FIELD_MAX_LENGTH_45: 'Die Feldlänge darf 45 Zeichen nicht überschreiten!',
  FIELD_MAX_LENGTH_128: 'Die Feldlänge darf 128 Zeichen nicht überschreiten!',
  FIELD_NO_SPECIAL_CHARS:
    'Sonderzeichen nicht zugelassen, / "\'{} [] () # $% ^ & * |',

  DELETE_EVENT_NOK:
    'Sie sind nicht der Eigentümer von Event, Sie können es nicht löschen!',
  DELETE_EVENT: 'Möchten Sie das Ereignis wirklich löschen?',

  DELETE_USER: 'Benutzer löschen',
  TAGS_CATEGORIES: 'Kategorien',
  DELETE_FILTERS: 'Filter löschen',

  // New > still to sort out
  DIRECT_BOOKING: 'Direktbuchungen',
  ASPECTS: 'Aspekte',
  NEW_ASPECT: 'Neu aspect',
  BRAND: 'Marke',
  COPY: 'Kopieren',
  REQUIRED: 'erforderlich',
  SORT: 'Sortieren',
  ACTIVE: 'Aktiv',
  INACTIVE: 'Inaktiv',
  EDIT_TRANSLATIONS: 'Übersetzungen bearbeiten',
  EDIT_BATCHGROUPS: 'Batchgruppen bearbeiten',
  CREATE_USER: 'Konto erstellen',
  START_TYPING: 'Beginnen Sie mit der Eingabe in Search',
  SQUARE_PER_PERSON: 'Quadratmeter pro Person (in M2)',
  ACTIVITY: 'Aktivität',
  ADD_TO_CARD: 'In den Warenkorb gelegt',
  VIEW_ORDER: 'Bestellung anzeigen',
  UPDATE_YOUR_ACCOUNT: ' Möchten Sie, dass wir Ihr Konto aktualisieren?',
  UPDATE_USER: 'Benutzer aktualisieren',
  HOUSE_NUMBER: 'Hausnummer',
  SELECT_TIME: 'Wählen Sie eine Zeit',
  INPUT_FIELDS_EMPTY: 'Die Eingabefelder sind leer.',
  NOTHING_FILLED_IN: 'Nichts ausgefüllt ',
  RETURN_TO_MY_ACTIVITIES:
    'Die Bestellung wird gespeichert. Sie kehren zur Seite "Meine Aktivitäten" zurück.',
  REDIRECT_TO_APPOINTMENTS:
    'Sie werden automatisch zu Ihren Terminen weitergeleitet',
  REDIRECT_TO_PAYMENT:
    'Sie werden automatisch zur Zahlungsseite weitergeleitet. ',
  ORDER_RECEIVED: 'Ihre Bestellung ist eingegangen.',
  ORDER_INFO: 'Bestellinfo ',
  ORDER_OVERVIEW: 'Bestellübersicht',
  ACTIVITY_PRICE: 'Aktivitätspreis:',
  ORDER_ID: 'Ihre Bestellnummer:',
  YOUR_ORDER: 'Deine Bestellung',
  FILL_PERSONAL_DETAILS: 'Geben Sie Ihre persönlichen Daten ein. ',
  CHOOSE_PRODUCTS: 'Wählen Sie Ihre Produkte',
  CHOOSE_DATE: 'Wählen Sie ein Datum und eine Uhrzeit',
  CHOOSE_DELIVERY_PICKUP_METHOD: 'Wählen Sie Abholung oder Versand',
  PICKUP_LOCATIONS: 'Abholorte',
  MORE_INFO: 'Mehr Info',
  ARRIVAL: 'Ankunft',
  ADD_ACCOMMODATION: ' Unterkunft hinzufügen',
  DAILY_ACTIVITIES: 'Ihre täglichen Aktivitäten',
  DEPARTURE: 'Abfahrt',
  GENERAL: 'Allgemeines',
  ADDRESS: 'Adresse',
  POSTAL_CODE: 'Postleitzahl',
  COMPANY_NAME: 'Name der Firma',
  COMPANY_EMAIL: 'Firmen-E-Mail',
  PREFERENCES: 'Einstellungen',
  CUSTOMERS: 'Kunden',
  SEARCH: 'Suche',
  ADD: 'Hinzufügen',
  CREATE_USERGROUP: 'Neue Benutzergruppe erstellen',
  EDIT_USERGROUP: 'Benutzergruppe bearbeiten',
  DELETE_USERGROUP: 'Benutzergruppe löschen',
  GROUP: 'Gruppe',
  USERGROUPS: 'Benutzergruppen',
  USERGROUP_NAME: 'Name der Benutzergruppe',
  SEARCH_FAILED_FIRST_PART: 'Ihre Suche nach',
  SEARCH_FAILED_SECOND_PART: ' fand keine Ergebnisse.',
  BATCHGROUPS: 'Batchgruppen',
  OPTIONS: 'Optionen',
  VIEW_BATCHGROUP: 'Batchgruppe anzeigen',
  CREATE_BATCHGROUP: 'Erstellen einer Batchgruppe ',
  DAY_MON: 'Mon',
  DAY_TUE: 'Tue',
  DAY_WED: 'Wed',
  DAY_THU: 'Thu',
  DAY_FRI: 'Fri',
  DAY_SAT: 'Sam',
  DAY_SUN: 'Son',
  SELECTED_DATES: 'Ausgewählte Daten',
  START_END_DATE_EQUAL_ERROR:
    'Das Enddatum entspricht dem Startdatum. Bitte ändern Sie das Enddatum, um fortzufahren.',
  DETAILS: 'Einzelheiten',
  OWNED_BY: 'Gehört',
  VISIBLE_FOR: 'Sichtbar für',
  MAIN_EVENT: 'Hauptveranstaltung',
  EVENT_DELETION: 'Ereignis löschen',
  ADD_LANGUAGE_PLUS: '+ Neue Sprache hinzufügen',
  ADD_LANGUAGE: 'Neue Sprache hinzufügen',
  LANGUAGE: 'Sprache',
  DESCRIPTION: 'Beschreibung',
  ARRIVAL_TEXT_MSG: 'Ankunftstextnachricht',
  DEPARTURE_TEXT_MSG: 'Abflug-Textnachricht',
  PREV_SCREEN: 'Zum vorherigen Bildschirm wechseln',
  DONE: 'Erledigt',
  ADD_CHOICE: 'Auswahl hinzufügen',
  ITEMS: 'Artikel',
  ADD_ITEMS: 'Artikel hinzufügen',
  CLOSE_EDIT_WINDOW: 'Bearbeitungsfenster schließen',
  WARNING: 'Warnung',
  UNSAVED_CHANGES:
    'Sie haben noch nicht gespeicherte Änderungen! Sind Sie sicher, dass Sie die Änderungen rückgängig machen möchten?',
  EVENT_DETAILS: 'Veranstaltungsdetails',
  EVENT_INFO: 'Die Info',
  MESSAGE_DELETION: 'Löschen von Nachrichten',
  PLAY_AUDIO: 'Audio abspielen',
  DELETE_AUDIO: 'Audio löschen',
  UPLOAD_EVENT_PIC: 'Laden Sie ein Ereignisbild hoch',
  DELETE_LOGO: 'Logo löschen',
  RESULT: 'Ergebnis',
  IMAGE: 'Bild',
  GO: 'Gehen',
  SEARCH_OSM: 'Suchen Sie in OpenStreetMap',
  STREET: 'Straße',
  CITY: 'Stadt',
  COUNTRY: 'Land',
  TELEPHONE: 'Telefon',
  OPENING_HOURS: 'Öffnungszeiten (Mo - Fr 08:00 - 17:30)',
  TRANSPORTATION: 'Transport',
  OK: 'Ok',
  MY_APPOINTMENTS: 'Meine Aktivitäten',
  INPUT_RELATION_NAME: 'Geben Sie den Namen der Beziehung ein',
  MIN_GROUPSIZE: 'Die Gruppengröße muss mindestens 1 betragen',
  NO_VALID_TIME_INPUT:
    'Die Zeitangabe ist ungültig. Bitte geben Sie eine gültige Zeit ein.',
  EVENT_EDITING: 'Ereignis bearbeiten',
  DELETING_EVENT: 'Ereignis löschen',
  NEW_EVENT: 'Neues Event',
  EDITING: 'Bearbeitung ',
  LOCATION: 'Standort',
  EVENT_CAPACITY: 'Maximale Kapazität in Personen',
  LEAD_TIME: 'Vorlaufzeit',
  COOLDOWN_TIME: 'Abklingzeit',
  DURATION: 'Dauer',
  SELECT_SUBACTIVITIES: 'Wählen Sie Unteraktivitäten aus',
  SELECTED_SUBACTIVITIES: 'Ausgewählte Unteraktivitäten',
  EVENT_PICTURE: 'Ereignisbild',
  CATEGORIES: 'Kategorien',
  AVAILABLE_OTHER_ACCOUNTS: 'Verfügbar für andere Konten',
  VISIBILITY: 'Sichtweite',
  ALL_EVENTS: 'Alle Veranstaltungen',
  NO_EVENT_AVAILABLE: 'Keine Veranstaltungen verfügbar',
  NAME: 'Name',
  UPLOAD_IMAGE: 'Bild hochladen',
  IMAGE_SIZE_NOT_REGULAR: 'Die Bildgröße ist nicht normal',
  IMAGE_SIZE_NOT_REGULAR_SAVE:
    'Möchten Sie das ausgewählte Bild wirklich hochladen? In der App auf Mobiltelefonen ist das Verhältnis deaktiviert',
  IMG_UPLOAD_ERR: 'Beim Speichern Ihres Fotos ist ein Fehler aufgetreten.',
  FLIP_X: 'Horizontal drehen',
  FLIP_Y: 'Vertikal drehen',
  CROP_EXPL:
    'Bevor Sie Ihr Foto hinzufügen, können Sie Ihr Foto hier wie gewünscht ändern.',
  UPLOAD_VIDEO: 'Ein Video hochladen',
  DELETE_VIDEO: 'Löschen Sie das Video',
  FILE_SIZE_EXCEED_MAX: 'Die Dateigröße sollte nicht größer als %s MB sein',
  UPLOAD_FILE_FAILED:
    'Fehler beim Hochladen der Datei. Bitte versuchen Sie es später erneut.',
  VIDEO_NOT_SUPPORT: 'Ihr Browser unterstützt keine eingebetteten Videos',
  USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS:
    'Leider sind Sie nicht angemeldet, um Zahlungsinformationen abzurufen. Bitte einloggen und erneut versuchen!',
  GROUP_SIZE: 'Gruppengröße',
  QUANTITY: 'Menge',
  TOTAL: 'Gesamt',
  SUBTOTAL: 'Zwischensumme',
  ADD_TAGS: 'Tags hinzufügen',
  TOTAL_INCIDENTS: 'Gesamtzahl der Vorfälle',
  ADD_INCIDENT: 'Vorfall hinzufügen',
  VIEW_DETAILS: 'Details anzeigen',
  SAVE_INCIDENT: 'Vorfall speichern',
  SAVE_IMAGE: 'Bild speichern',
  ADD_LOCATION: 'Ort hinzufügen',
  ADD_A_LOCATION: 'Füge einen Ort hinzu',
  EDIT_LOCATION: 'Standort bearbeiten',
  DEL_LOCATION: 'Ort löschen',
  LINK_ACTIVATE_ACCOUNT:
    'Öffnen Sie den Link in der Mail, um Ihr Konto zu aktivieren.',
  WRONG_TIME_INPUT:
    'Die Zeitangabe ist ungültig. Bitte geben Sie eine gültige Zeit ein.',
  MESSAGE_TITLE_TEXT:
    'Bitte geben Sie den Titel und den Text der Nachricht ein, um fortzufahren',
  ERROR_MSG_NO_PLACE_SUB_EVENT:
    'There is no place available for a chosen sub event(s): ',
  ERROR_MSG_INVALID_TIME: 'Ungültige Zeiteingabe',
  ERROR_MSG_INVALID_DATE: 'Ungültige Datumsangabe',
  ERROR_MSG_NO_ENTRY_TRANSPORT:
    'Für diese Art des Transports sind keine Einstiegspunkte mehr verfügbar',
  ERROR_MSG_EVENTS_RESET:
    'Ihre Ereignisse wurden zurückgesetzt, bitte wählen Sie sie erneut aus.',
  ERROR_MSG_ARRIVAL_DEPARTURE:
    'Bitte ändern Sie die Ankunfts- oder Abfahrtszeit.',
  WARNING_MSG_EARLY: 'Sind Sie sicher, dass Sie ankommen möchten?',
  MAIN_EVENT_START: 'Das Main Event beginnt um',
  ERROR_MSG_NO_PLACE_MAIN_EVENT:
    'Für das Main Event ist kein Platz verfügbar: ',
  ERROR_MSG_NO_PLACE_TRANSPORT_MODE:
    'Für das gewählte Transportmittel sind keine Plätze mehr verfügbar',
  ERROR_MSG_NO_MAIN_BATCH_CHOSEN_TIME:
    'Keine Hauptcharge im Zeitbereich, bitte wählen Sie einen anderen Zeitbereich',
  SELECT_TRIP_DAY:
    'Bitte wählen Sie den Tag aus, an dem Ihre Reiseliste angezeigt werden soll',
  ENTER_SPECIAL_CODE: 'Geben Sie einen speziellen Code ein',
  WRONG_INPUT: 'Falsche Eingabe',
  INPUT_NOT_COMPLETE: 'Ihre Eingabe ist nicht vollständig oder richtig',
  VALID_VIP_CODE: 'Bitte geben Sie einen gültigen VIP-Code ein',
  MY_EVENTS: 'Meine Veranstaltungen',
  PART_OF: 'Teil von',
  SELECTION_OF_USERS: 'Auswahl der Benutzer',
  CRITERIA_BOTH: 'Registrierte und nicht registrierte Benutzer',
  CRITERIA_REG: 'Registrierte Benutzer',
  CRITERIA_NOT_REG: 'Nicht registrierte Benutzer',
  UG_FOR_USER: 'Verfügbare Benutzergruppen',
  SELECTED_UG_FOR_USER: 'Benutzer ist bereits registriert für:',
  WEB_BROWSER_VERSION: 'Chrome-Browserversion',
  UPDATE_BROWSER_DETECTION:
    'Das System hat festgestellt, dass die Version des Chrome-Browsers, an dem Sie arbeiten, nicht aktuell ist.',
  UPDATE_BROWSER_FAILS:
    'Aus diesem Grund konnten einige Funktionen nicht ordnungsgemäß funktionieren.',
  UPDATE_BROWSER:
    'Bitte aktualisieren Sie Ihren Chrome-Browser auf die neueste Version.',
  CALENDAR: 'Was läuft',
  ONLY: 'Nur',
  FREE_PLACES: 'Plätze verfügbar',
  MINUTES: 'Protokoll',
  BOOK: 'Buch',
  LOCATION_PICTURE: 'Standortbild',
  UPLOAD_LOCATION_PIC: 'Laden Sie ein Standortbild hoch',
  TOGGLE_MAP: 'Karte umschalten',
  TOGGLE_ACTIVITYLIST: 'Tägliche Aktivitäten anzeigen',

  // Partner
  PARTNER_SELECT: 'Wählen Sie einen Partner',
  PARTNER_LEVEL: 'Partnerebene',
  PARTNERS: 'Partner',
  PARTNER_DETAILS: 'Partnerdetails',
  DELETE_PARTNER_TITLE: 'Sind Sie sicher, den Partner zu löschen?',
  PARTNER_NAME: 'Partnername',
  PARTNER_ADDRESS: 'Partneradresse',
  PARTNER_CITY: 'Partnerstadt',
  PARTNER_EMAIL: 'Partner-E-Mail',
  PARTNER_POSTAL_CODE: 'Postleitzahl des Partners',
  PARTNER_IBAN: 'Partner IBAN',
  PARTNER_TYPE: 'Partnertyp',
  SERVICE_PRICE: 'Servicepreis',
  SERVICE_PRICE_PERCENTAGE: 'Servicepreisprozentsatz',
  SERVICE_MINIMUM_PRICE: 'Minimaler Servicepreis',
  PLANNING_CONTRACT: 'Planungsvertrag',
  PAYMENT_CONTRACT: 'Zahlungsvertrag',
  PAYMENT_PLATFORM: 'Zahlungsplattform',
  CREATE_PARTNER: 'Partner erstellen',
  TERMS_ACCEPT: 'Ich akzeptiere das',
  DIRECT_DEBIT: 'Ich akzeptiere Lastschrift',
  ACTIVE_PARTNER: 'Partner aktivieren',
  MIN_MONTHLY_FEE: 'Minimale monatliche Gebühr',

  // Empty slots
  EMPTY_SLOTS_TITLE: 'Sind Sie sicher, diese Steckplätze zu leeren?',

  // Suggestions
  SUGGESTIONS_SELECTED: 'Ausgewählte Vorschläge',
  SUGGESTIONS_SELECT: 'Vorschläge auswählen',
  SUGGESTIONS: 'Vorschläge',
  SUGGESTIONS_NO_PLACES:
    'Die Vorschläge haben keine Plätze mehr. Sie können einen anderen Vorschlag wählen.',
  SUGGESTION_BOOK_FAILED: 'Buchvorschlag nicht möglich',
  NO_SUGGESTIONS_FOUND: 'Keine Vorschläge gefunden',
  NO_SUGGESTIONS: 'Es wurden keine Vorschläge gefunden',
  NO_CAPACITY: 'Keine Kapazität',
  LIST_OF_SUGGESTIONS: 'Liste der Vorschläge',
  ADD_SUGGESTION: 'Vorschlag hinzufügen',
  ADD_SUGGESTION_ACCEPT:
    'Möchten Sie diesen Vorschlag wirklich zu Ihrer Bestellung hinzufügen?',
  CANCEL_YOUR_ORDER: 'Bestellung stornieren',
  CANCEL_YOUR_ORDER_ACCEPT: 'Möchten Sie Ihre Bestellung wirklich stornieren?',
  REMOVE_SUGGESTION: 'Vorschlag entfernen',
  REMOVE_SUGGESTION_ACCEPT: 'Möchten Sie diesen Vorschlag wirklich entfernen?',
  NO_IM_NOT: 'Nein, bin ich nicht',
  YES_I_AM: 'Ja, ich bin',
  SUGGESTION_MAKE_CHOICE: 'Entscheide dich',
  SUGGESTION_DRINKING: 'ich möchte etwas zu trinken',
  SUGGESTION_EATING: 'ich will etwas zu essen haben',
  SUGGESTIONS_CLICK_HERE: 'Klicke hier',
  ORDER_ALL_PRODUCT_SUGGESTIONS: 'Alle Produkte hinzufügen',
  FAILED_PRODUCTS_CAPACITY_ERROR:
    'Die unten aufgeführten Produkte sind nicht auf Lager und wurden nicht in Ihren Warenkorb gelegt',
  FAILED_PRODUCTS_ALREADY_IN_CART:
    'Produkt(e) unten befinden sich bereits in Ihrem Warenkorb und werden nicht erneut hinzugefügt',
  ORDER_ALL_PRODUCT_SUGGESTIONS_FAILED:
    'Fehler beim Hinzufügen von Produkten zu Ihrem Warenkorb. Bitte versuchen Sie es später erneut.',
  JOIN_QUIZ: 'Verbinden',

  // Calendar
  CALENDAR_EVENT_STARTTIME: 'Startzeit',
  CALENDAR_EVENT_ENDTIME: 'Endzeit',
  CALANDER_NAME: 'Kalender',
  CALENDAR_NO_ITEMS:
    'Für die ausgewählten Tage gibt es keine Kalenderelemente.',

  // Statistics
  GET_STATISTICS: 'Statistiken abrufen',
  STATISTICS_OF_TRIPS: 'Statistik der Reisen',
  STATISTICS_OF_SUGGESTIONS: 'Statistik der Vorschläge',
  STATISTICS_OF_DIRECT_BOOKING: 'Statistik der Direktbuchungen',
  STATISTICS_OF_PARTNERS: 'Statistik der Partner',
  STATISTICS_OF_USERS: 'Statistik der Benutzer',
  STATISTICS_SELECT_THE_DATES: 'Wählen Sie die Daten aus',
  STATISTICS_SELECT_THE_PARTNER: 'Wählen Sie den Partner aus',

  // Activity details screen
  CHOOSE_A_LOCATION: 'Wählen Sie einen Ort',
  CHOICES: 'Entscheidungen',
  READ_MORE: 'Weiterlesen',
  READ_LESS: 'Lese weniger',
  DELIVERY_FEE: 'Zustellgebühr',
  OPTIONS_EXTRA_FEE: 'Zusatzkosten für ausgewählte Optionen',
  MORE_PRODUCTS: 'mehr Produkte',
  OR_ORDER_FOR: 'Oder bestellen für',
  SELECT_THIS: 'Wenn Sie diese auswählen, müssen Sie bezahlen',
  CONFIRM_YOUR_CHOICES: 'Bestätigen Sie Ihre Auswahl',
  CONFIRM_YOUR_CHOICES_EXPLANATION:
    'Überprüfen Sie Ihre Auswahl und drücken Sie Komplett.',
  PERSONAL_DETAILS_EXPLANATION:
    'Geben Sie die erforderlichen persönlichen Daten ein und hinterlassen Sie auf Wunsch einen Kommentar für Sonderwünsche.',
  ENTER_YOUR_PERSONAL_DETAILS: 'Geben Sie ihre Persönliche Daten ein',
  CHOOSE_AN_OPTION: 'Zusätzliche Kosten und Optionen',
  CLICK_TO_OPEN: 'Klicken Sie zum Öffnen',
  STARTING_AT: 'von',
  AND: 'Und',
  SHOWING_OPTION:
    'Geben Sie die Anzahl der Personen der gewünschten Option oder des gewünschten Tickets an.',
  SELECTED_DATA_EXPLANATION:
    'Wählen Sie ein Datum oder einen Zeitraum sowie eine Start- und Endzeit sofern anwendbar.',
  PRODUCT_BELOW_EXPLANATION:
    'Nachfolgend finden Sie die Produkte. Fügen Sie die gewünschten Produkte hinzu und klicken Sie dann auf Jetzt bestellen.',
  BOOKING_FLOW_EXPLANATION:
    'Sie befinden sich jetzt im Buchungsprozess und füllen die folgenden Felder aus, um fortzufahren.',
  EXPLAINING_COLOR_CHIPS:
    'Die folgenden Farben geben an, wie beschäftigt es in bestimmten Zeitfenstern ist',
  NO_PRODUCTS: 'In Ihrem Warenkorb befinden sich keine Produkte',
  NO_DAYS_AVAILABLE: 'Keine Tage verfügbar',
  NO_BOOKINGS_YET: 'Es wurde noch nichts gebucht',
  PRE_EVENT_NOTIFICATIONS: 'Aktivieren Sie Benachrichtigungen vor dem Ereignis',
  PRE_EVENT_NOTIFICATIONS_EXPLANATION:
    'Wenn Sie dies auswählen, erhalten Sie einige Minuten vor Beginn des Ereignisses eine Nachricht.',
  NO_ENDTIMES:
    'Endzeiten mit der gewählten Startzeit können nicht ermittelt werden. Bitte wählen Sie eine andere Startzeit.',
  CANT_FIND_STARTIME:
    'Mit diesem Startdatum kann keine Startzeit gefunden werden',
  CANT_FIND_ENDDATE: 'Mit dieser Startzeit kann kein Enddatum gefunden werden',
  CANT_FIND_ENDTIME: 'Mit diesem Enddatum kann keine Endzeit gefunden werden',
  CHOSEN_DETAILS: 'Ausgewählte Details',
  STARTDATE: 'Anfangsdatum',
  ENDDATE: 'Endtermin',
  ACCEPT: 'Akzeptieren',
  AMOUNT: 'Menge',
  AMOUNT_OF_PRODUCTS: 'Menge',
  AVA_DAYS: 'Verfügbare Tage',
  TIMES: 'Mal',
  OPEN_HOURS: 'Öffnungszeiten',
  HOURS: 'Stunde',
  PRICE: 'Preise ab',
  PRICE2: 'Preis',
  PHONE_NR: 'Telefonnummer',
  PHONE_NR_REQUIRED: 'Telefonnummer (erforderlich)',
  REQUEST_CLIENT1: 'Wähle eine Zeit',
  REQUEST_CLIENT2: 'Bitte wählen Sie eine Anzahl von Tickets.',
  OPENED_AT: 'Geöffnet um',
  CLOSED_AT: 'Geschlossen um',
  SAVE_DETAILS:
    'Speichern Sie die persönlichen Daten in meinem Konto für zukünftige Reservierungen oder Bestellungen',
  NO_PLACE: 'Kein Platz',
  NO_PLACE_BATCH:
    'Kein Platz in diesem Zeitfenster, bitte wählen Sie einen anderen',
  FREE_DELIVERY: 'Kostenlose Lieferung',
  FREE: 'Kostenlos',
  EX_DELIVERY_FEE: 'excl. Liefergebühr',
  MONDAY: 'Montag',
  TUESDAY: 'Dienstag',
  WEDNESDAY: 'Mittwoch',
  THURSDAY: 'Donnerstag',
  FRIDAY: 'Freitag',
  SATURDAY: 'Samstag',
  SUNDAY: 'Sonntag',
  PRICE_PERCENTAGE: 'Preisprozentsatz',
  PRICE_OVERVIEW: 'Preisübersicht',
  PERCENTAGE_EXPLANATION:
    'Dieser Prozentsatz zeigt den Prozentsatz des ursprünglichen Preises an.',
  UNAVAILABLE: 'Nicht verfügbare Artikel',
  UNAVAILABLE_TEXT:
    'Es sind keine Artikel verfügbar. Akzeptieren Sie, dass Sie diese Artikel nicht kaufen können?',
  PLEASE_STARTDATE: 'Bitte wählen Sie ein Startdatum',
  PLEASE_ENDDATE: 'Bitte wählen Sie ein Enddatum',
  PLEASE_STARTTIME: 'Wählen Sie einen Ankunftszeitraum/Ankunftszeit',
  PLEASE_ENDTIME: 'Wählen Sie einen Abfahrtszeitraum/Abfahrtszeit',
  CROWDED: 'Überfüllt',
  UNCROWDED: 'Nicht überfüllt',
  NORMAL: 'Normal',
  BOOKED: 'Gebucht',
  OUT_OF_STOCK: 'Dieses Produkt ist nicht auf Lager',
  AVAILABLE_PRICES: 'Verfügbare Preise',
  PRODUCT_INFO: 'Produktinformation',
  PRICE_STARTING_AT: 'Preis ab',
  NOT_AVAILABLE: 'Nicht verfügbar',
  ALMOST_FULL: 'Fast voll',
  NOT_BUSY: 'Nicht beschäftigt',
  SELECT_ORDERTYPE: 'Bitte wählen Sie die Art der Bestellung',
  REMARK: 'Bemerkungen',
  REMARK_OPTIONAL: 'Bemerkungen (optional)',
  DELIVERY_DISTANCE: 'Lieferentfernung',

  REGISTER_PAGE_TEXT:
    'Um Ihren persönlichen AccountName-Pass zu erstellen, benötigen wir nur Ihre E-Mail-Adresse. Ihre E-Mail-Adresse wird auch verwendet, um Ihnen Buchungsbestätigungen und Tickets zu senden, wenn Sie Aktivitäten buchen.',
  REGISTER_EMAIL_USAGE:
    'Erstellen Sie ein Konto, um schnell und einfach zu bestellen, sparen Sie große Rabatte und wiederholen Sie Bestellungen einfach.',
  REGISTER_PAGE_WELCOME:
    'Zum Erstellen Ihres Kontos benötigen wir nur Ihre E-Mail-Adresse. Ihre E-Mail-Adresse wird auch verwendet, um Ihnen Buchungsbestätigungen und Tickets zu senden, wenn Sie Aktivitäten buchen.',
  LOGIN_PERSONAL:
    'Bitte melden Sie sich bei Ihrem persönlichen AccountName-Pass an. Sie haben noch keinen Reisepass? Registrieren Sie sich, um eine in nur einer Minute zu erstellen. Mit Ihrem AccountName-Pass können Sie Ihren Besuch bei accountName ganz einfach planen und buchen, Ihre Lieblingsaktivitäten speichern und Rabatte für Ihren Besuch bei accountName erhalten.',

  // Coupon code order
  DETAILS_FROM_RECIPIENT: 'Details zum Gutscheinempfänger',
  RECIPIENT_MESSAGE: 'Nachricht an den Empfänger',
  RECIPIENT_FIRSTNAME: 'Vorname des Empfängers',
  RECIPIENT_LASTNAME: 'Nachname des Empfängers',
  RECIPIENT_EMAIL: 'Empfänger E-Mail',
  RECIPIENT_DETAILS_DESCRIPTION:
    'Wenn Sie den Coupon direkt an den Empfänger versenden möchten, können Sie hier seine Daten eingeben.<br>Wenn Sie den Coupon selbst erhalten möchten, können Sie die Felder leer lassen.<br>Sie erhalten auch selbst eine Kopie des Gutscheincodes.',

  // orders
  ORDER: 'Wählen ereignis',
  ORDER_LIST_EMPTY: 'Liste ist leer',
  ORDER_NO_ORDERS: 'keine Bestellungen',
  ORDER_NO_ORDERS_FOUND: 'Es wurden keine Bestellungen gefunden',
  ORDER_DOWNLOAD: 'herunterladen',
  ORDER_NOW: 'Jetzt bestellen',
  ORDER_TYPE: 'Auftragsart',
  ORDER_NR: 'Bestellnummer',
  ORDER_DETAILS: 'Bestelldetails',
  ORDER_COMPLETED: 'Bestellung abgeschlossen',
  ORDER_COMPLETED_DEFAULT:
    'Vielen Dank für Ihren Auftrag. Ihre Bestellung wurde erfolgreich erstellt.',
  ORDER_COMPLETED_DEBIT: 'Ihre Zahlung wird per Lastschrift abgewickelt.',
  ORDER_COMPLETED_INVOICE:
    'Sie erhalten die Rechnung per E-Mail. Bitte bezahlen Sie die Rechnung vor dem Fälligkeitsdatum.',
  ORDER_THANKS: 'Vielen Dank für Ihre Bestellung.',
  ORDER_VIEW_BELOW:
    'Sie können Ihre Aktivität anzeigen, indem Sie auf die Schaltfläche unten klicken.',
  ORDER_COUPON_CODE: 'Gutscheincode',
  ORDER_CHECK_COUPON_CODE: 'Überprüfen Sie den Gutscheincode',
  COUPON_NOT_APPLIED_TITLE: 'Fügen Sie Ihren Gutscheincode hinzu',
  COUPON_NOT_APPLIED_MESSAGE:
    'Der Gutscheincode ist ausgefüllt, aber noch nicht zu Ihrer Bestellung hinzugefügt. Möchten Sie es jetzt hinzufügen?',
  ORDER_WAIT_FOR_PARTNER_CONFIRMATION:
    'Ihre Buchungsanfrage wurde zur Bestätigung an unseren Partner weitergeleitet. Sie erhalten eine Nachricht, wenn der Partner Ihre Buchungsanfrage bestätigt oder abgelehnt hat.',
  CANCEL_ORDER_GROUP_SUCCESS: 'Ihre Bestellung wurde erfolgreich storniert.',
  CANCEL_ORDER_GROUP_ERROR:
    'Fehlgeschlagen Ihre Bestellung zu stornieren. Bitte versuchen Sie es später erneut.',

  // Error codes
  E_00_00:
    'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
  E_PO_010:
    'Die verschiedenen Slots für die Aktivität waren momentan nicht verfügbar. Bitte versuchen Sie es später erneut',
  E_PO_011:
    'Es war nicht möglich, der Planboard eine Aktivität hinzuzufügen. Überprüfen Sie Ihre Planboard und versuchen Sie es mit einem anderen Datum oder einer anderen Uhrzeit.',
  E_PO_012:
    'Es war nicht möglich, der Planboard eine Aktivität hinzuzufügen. Bitte versuchen Sie es später erneut',
  E_PO_013:
    'Der ausgewählte Steckplatz hat keine Kapazität. Bitte versuchen Sie es mit einem anderen Steckplatz, falls verfügbar.',
  E_PO_014:
    'Es war nicht möglich, die ausgewählte Aktivität in Ihrem Planboard zu ändern',
  E_PO_015:
    "Sie dürfen diese Aktivität nicht bearbeiten, da der Zahlungsstatus nicht 'bezahlt' ist.",
  E_PO_016:
    'Die gewählte Zeit ist in einer anderen Slots-Gruppe, bitte wählen Sie eine andere Zeit',
  E_BK_001:
    'Leider ist der gewählte Veranstaltungsort zu voll. Bitte versuchen Sie, die Ankunfts- oder Abfahrtszeit zu ändern und versuchen Sie es erneut.',
  E_BK_002:
    'Keines der von Ihnen ausgewählten Produkte ist verfügbar. Bitte wählen Sie eine andere Zeit oder ein anderes Produkt und fahren Sie fort.',
  E_PC_003:
    'Sie können keine Preiskategorie löschen, die bereits mit einem Zeitfenster verknüpft ist',
  E_PB_001: 'Keine Ankunftskapazität verfügbar',
  E_PB_002: 'Keine Abflugkapazität verfügbar',
  E_PB_003: 'Keine Veranstaltungskapazität verfügbar',
  E_OB_002:
    'Das ausgewählte Ereignis konnte seine Daten nicht abrufen. Bitte versuchen Sie es später erneut',
  E_UG_002: 'Die Bestellung gehört nicht dem aktuellen Partner',
  E_UG_003: 'Die Bestellung wurde bereits gescannt',
  E_UG_004: 'Die Tickets innerhalb der Bestellung werden nicht bestätigt',

  E_ROUTE_001: 'keine Kapazität',
  E_ROUTE_002:
    'Es gab keine Bestellungen in der Datenbank für die angegebene Eingabe',
  E_ROUTE_003:
    'Der Routengenerator hat innerhalb der angegebenen Zeit keine Lösung gefunden',
  E_ROUTE_004: 'Es gibt keine Lösung für das angegebene Routing-Problem',
  E_ROUTE_005: 'Routengenerator nicht richtig konfiguriert',
  E_ROUTE_006:
    'Keine Route gefunden, bitte versuchen Sie es mit einem anderen Reisemodus',

  E_MPID_001: 'Die Zahlungs-ID fehlt',

  E_GSD_001: 'Es gibt keine Startdaten',
  E_GSD_002: 'Es gibt keine Enddaten',
  E_GSD_003: 'Es gibt keine Startzeiten',
  E_GSD_004: 'Es gibt keine Enddaten',
  E_RA_001:
    'Das Abrufen der Ereignisdaten ist fehlgeschlagen. Bitte versuchen Sie es später erneut',
  E_RA_002:
    'Das Abrufen der Routenaspektdaten ist fehlgeschlagen. Versuchen Sie es später erneut',
  E_RA_003:
    'Die empfangenen Routenaspektdaten sind nicht für das richtige Ereignis. Bitte versuchen Sie es später erneut',
  E_RA_004:
    'Das Abrufen der Pfadpunkte innerhalb der Routenaspektdaten ist fehlgeschlagen. Versuchen Sie es später erneut',

  E_OM_001: 'Die Bestellnummer ist falsch.',
  E_OM_002: 'Die Bestätigungs-ID gehört nicht zur Bestell-ID.',
  E_OM_003: 'Die Bestellung wurde bereits angenommen / abgelehnt.',

  // Back-End Failure
  W_BEF_001:
    'Die empfangenen Daten sind unvollständig, versuchen Sie es später erneut.',
  W_BEF_002:
    'Der Server ist derzeit offline, SuperLinda und ihr Team arbeiten sehr hart daran, ihn zu lösen.',

  // CouponCode
  E_GV_001: 'Sie haben diesen Gutscheincode bereits verwendet.',
  E_GV_002: 'Dieser Gutscheincode ist ungültig.',
  E_GV_004:
    'Dieser Gutscheincode kann nur von bestimmten Benutzerklassen verwendet werden.',
  E_GV_005: 'Ungültiger Gutscheincode. Der Gutschein ist abgelaufen.',

  // GetAccountInfo
  W_GAI_001:
    'Die Kontodaten sind unvollständig, bitte versuchen Sie es erneut. ',

  // GetUserData
  W_GUD_001:
    'Die Benutzerdaten sind unvollständig, bitte versuchen Sie es erneut. ',
  W_GUD_002:
    'Wir konnten die Benutzerdaten nicht empfangen. Bitte versuchen Sie es erneut. ',

  // GetEventDetails
  W_GED_001:
    'Das Laden des Bildes ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',
  W_GED_002:
    'Das Laden der Beschreibung ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',
  W_GED_003:
    'Das Laden der Ereignis-ID ist fehlgeschlagen. Versuchen Sie es erneut. ',
  W_GED_004:
    'Das Laden der Ereignisdetails ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // GetCalendar
  W_GC_001:
    'Das Laden des Kalenders ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetTourActivities
  W_GTA_001:
    'Das Abrufen der Touraktivitäten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetThemes
  W_GT_001:
    'Das Laden der Themen für das aktuelle Konto ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetChildrenEvents
  W_GCE_001:
    'Das Laden der Ereignisse aus dem ausgewählten Thema ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // GetFavourites
  W_GF_001:
    'Das Laden Ihrer Favoriten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // Add/Delete Favourite
  W_ADF_001:
    'Das Hinzufügen / Löschen eines neuen Favoriten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetEventsForLocation
  W_GEFL_001:
    'Das Abrufen der Ereignisse für den Speicherort ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // GetLocationDetails
  W_GLD_001:
    'Das Abrufen der Standortdetails ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetEventsBasedOnUserLevel
  W_GEBOU_001:
    'Das Laden der Ereignisse ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // GetLocations
  W_GL_001:
    'Das Laden der Speicherorte ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // DeleteEvent
  W_DE_001:
    'Beim Löschen des Ereignisses ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. ',

  // GetPostOfEvent
  W_GPOE_001:
    'Das Laden des Event-Posters ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetAccounts
  W_GA_001:
    'Das Laden der Konten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // SaveEvent
  W_SE_001:
    'Das Speichern des Ereignisses ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ',

  // ActivateAccount
  W_AA_001:
    'Nach der Aktivierung des Kontos wurden keine Token empfangen. Bitte versuchen Sie es erneut.. ',
  W_AA_002:
    'Die Aktivierung des Kontos ist fehlgeschlagen. Bitte versuchen Sie es erneut.',

  // CreateAccount
  W_CA_001:
    'Die E-Mail konnte nicht bestätigt werden, da keine E-Mail empfangen wurde. Bitte versuchen Sie es erneut. ',
  W_CA_002:
    'Die Erstellung des Kontos ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // UpdateAccount
  W_UA_001:
    'Das Aktualisieren des Kontos ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ',

  // GetExactCsvs
  W_GEC_001:
    'Das Laden der Exact-Dateien ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ',

  // GenerateSalesFees
  W_GSF_001:
    'Die Generierung der Verkaufsgebühren ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GenerateMonthlyFees
  W_GMF_001:
    'Die Generierung der monatlichen Gebühren ist fehlgeschlagen. Bitte versuchen Sie es erneut. ',

  // GetSalesFeesPref
  W_GSFP_001:
    'Es wurde kein Startdatum erhalten. Bitte versuchen Sie es erneut. ',
  W_GSFP_002:
    'Es wurde kein Enddatum erhalten. Bitte versuchen Sie es erneut. ',
  W_GSFP_003:
    'Es wurde kein Generierungsdatum empfangen. Bitte versuchen Sie es erneut. ',
  W_GSFP_004:
    'Das Laden der Einstellungen für Verkauf und Gebühren ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // SetSalesFeesPref
  W_SSFP_001:
    'Das Speichern der Einstellungen für Verkauf und Gebühren ist fehlgeschlagen. Versuchen Sie es erneut. ',

  // Standard Contact Helpdesk
  W_HELPDESK_001:
    'Wenn dieses Problem weiterhin auftritt, wenden Sie sich bitte an den Helpdesk von SuperLinda. ',

  // Book
  NOT_CHOSEN: 'Sie haben noch nichts ausgewählt',

  // shopping cart
  SHOPPINGCART_NOT_EMPTY_DESCRIPTION:
    'Es befinden sich noch Produkte in Ihrem Warenkorb. Wenn Sie sich abmelden, werden diese Produkte auch aus dem Warenkorb entfernt.',
  SHOPPINGCART_SURE_ABOUT_LOGGING_OUT: 'Möchten Sie sich abmelden?',
  SHOPPINGCART_NOT_EMPTY: 'Ihr Warenkorb ist nicht leer',
  SHOPPINGCART: 'Einkaufswagen',
  ADD_REQUEST: 'Fügen Sie eine Anfrage hinzu',
  REQUEST: 'Anfrage',
  SHOPPINGCART_EMPTY: 'Dein Einkaufswagen ist leer',
  CARTITEM_REMOVED: 'Artikel wird aus dem Warenkorb entfernt',
  CARTITEM_NOT_REMOVED:
    'Artikel wird nicht aus dem Warenkorb entfernt. Versuchen Sie es erneut',
  FAILED_ADD_CART:
    'Failed adding your product(s) to your shopping cart, please try again',
  FAILED_ADD_SHOPPINGLIST:
    'Failed adding your product(s) to your shopping list, please try again',
  ADD_CART: 'Your product(s) have been added to your shopping cart',

  TICKETS_RESERVED: 'Ihr(e) Ticket(s) wurden reserviert',
  TICKETS_FAIL_RESERVED: 'Failed reservering your ticket(s), please try again',
  PARTNER_DOESNT_EXIST: 'This partner group does not exist.',
  BOOKING_FAIL: 'Failed booking your order, please try again.',

  // DeliveryRouteGenerate screen
  'TIME/DATEINFO': 'Uhrzeit/Datum info',
  DELIVERY: 'Lieferung',
  PICKUP: 'Pick up',
  TRANSPORT: 'Transport',
  GENERATE_ROUTE: 'Route generieren',
  ADD_DELIVERY_PERSON: 'Zusteller hinzufügen',
  DELIVERY_CONFIG: 'Konfigurator liefern',
  DELIVERER: 'Zusteller',
  ORDERID: 'Auftragsnummer',
  DELIVERYNR: 'Lieferungsnummer',
  NOTHING_DROPPED: 'Nichts fiel herunter',
  DROPPED: 'Fallen gelassen',
  LOCATION_NOT_FOUND: 'Ort nicht gefunden',
  CAR: 'Auto',
  BICYCLE: 'Fahrrad',
  WALKING: 'Gehen',
  HOUR: 'Stunde',
  START_CONFIGURE: 'Starten Sie zuerst die Konfiguration',

  // Lorenzo added new translations not in Deutsch
  UNCONFIRMED: 'Unbestätigt',
  CONFIRMED: 'Bestätigt',
  WAITING_FOR_PAYMENT: 'Warten auf Zahlung',
  ARRIVED: 'Ist eingetroffen',
  FIRSTNAME: 'Vorname',
  LASTNAME: 'Nachname',
  PLACE_OF_RESIDENCE: 'Wohnort',
  DATE_OF_BIRTH: 'Geburtsdatum',

  USER_SUCCESS_UNSUBSCRIBED: 'Sie wurden erfolgreich abgemeldet',
  USER_FAILED_UNSUBSCRIBED:
    'Fehler beim Abbestellen dieses Benutzers. Bitte versuchen Sie es später erneut',
  USER_PROGRESS_UNSUBSCRIBED: 'Benutzer abbestellen',
  USER_PROGRESS_ACTIVATION: 'Benutzer aktivieren',
  USER_SUCCESS_ACTIVATED: 'Die Aktivierung Ihres Kontos ist abgeschlossen!',
  USER_SUCCESS_ACTIVATED_LINK: 'Registrieren Sie Ihr Konto bei der App?',
  USER_SUCCESS_ACTIVATED_DOWN:
    'Sind Sie ein Webbenutzer? Wir haben auch eine App zur Verfügung. Klicken Sie auf den richtigen Store, um die App herunterzuladen oder im Internet fortzufahren',
  USER_ACTIVATION_FAILED: 'Die Aktivierung Ihres Kontos fehlgeschlagen',

  USER_NOT_ACTIVATED_TEXT:
    'Ihr Konto wurde noch nicht aktiviert. Klicken Sie in der Aktivierungsmail, die Sie erhalten haben, auf den Aktivierungslink, um fortzufahren.',
  USER_NOT_ACTIVATED_MAIL:
    'Wenn Sie die E-Mail nicht finden können oder die E-Mail noch nicht erhalten haben, klicken Sie auf die Schaltfläche unten, um die Aktivierungs-E-Mail erneut zu senden an: ',
  RESEND_ACTIVATION: 'Aktivierungs-Mail senden',
  ACTIVATION_MAIL_IS_SEND: 'Die Mail wurde gesendet an: ',
  USER_FORGOT_PASSWORD:
    'Ihre Anmeldedaten werden erneut an Ihre E-Mail gesendet.',
  USER_FORGOT_PASSWORD_SEND:
    'Ihre Anmeldedaten wurden erneut an Ihre E-Mail gesendet.',
  RESEND_LOGIN_DETAILS: 'Anmeldedaten senden',
  FORGOT_PASS: 'Passwort vergessen? ',
  USER_PASS:
    "Gehen Sie dann zurück zur App, klicken Sie auf 'Anmelden' und melden Sie sich unten mit Ihrer E-Mail-Adresse und Ihrem Passwort an:",
  FORGOT_PASSWORD_BACK: 'Zurück',
  RESET_PASS_TITLE: 'Setze dein Passwort zurück',
  RESET_EMAIL_TITLE: 'E-Mail adresse ändern',
  RESET_PASS_SUBTITLE:
    'Der Link zum Zurücksetzen Ihres Passworts wird an Ihre Mailbox gesendet',
  RESET_PASS_MAIL_SENT_TITLE:
    'Überprüfen Sie Ihren Spam-Ordner, falls Sie nicht erhalten die E-Mail',
  RESET_EMAIL_SENT_TITLE:
    'Der Link zum Zurücksetzen Ihrer E-Mail-Adresse wurde an Ihre Mailbox gesendet',
  OLD_PASS: 'Altes Passwort',
  NEW_PASS: 'Neues Kennwort',
  CONFIRM_NEW_PASS: 'Bestätige neues Passwort',
  PASS_NOT_MATCH: 'Neues Passwort ist Kennwort bestätigen nicht überein',
  SAVE_AND_LOGIN: 'Speichern und einloggen',
  PASS_CHANGED_DESC: 'Ihr neues Passwort wurde erfolgreich gespeichert',
  NEW_EMAIL: 'Neue e-mail',
  CONFIRM_NEW_EMAIL: 'Neue e-mail bestätigen',
  CONFIRM_EMAIL_CHANGE_TITLE: 'Aktualisierte E-Mail',
  CONFIRM_EMAIL_CHANGE_DESC:
    'Melden Sie sich mit Ihrer neuen E-Mail-Adresse <b>%s</b> und Ihrem alten Passwort an, um fortzufahren.',
  ERROR_EMAIL_CHANGE_TITLE: 'E-Mail konnte nicht zurückgesetzt werden',
  EMAIL_CHANGE_ERROR_MSG:
    'Beim Zurücksetzen der E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal',
  EMAIL_CHANGED_DESC: 'Ihre neue E-Mail wurde erfolgreich gespeichert',
  REGISTER_PASS_NOT_MATCH: 'Kennwort nicht das bestätigen Kennwort überein',
  PASS_LENGTH_LIMIT: 'Die Länge muss zwischen 8 und 48 Zeichen betragen',
  CONFIRM_PASS: 'Bestätigen Sie das Passwort',

  EVENT_DESCRIPTION_EC: 'Eventbeschreibung',
  EVENT_DURATION_EC: 'Durchschnittliche Dauer',
  EVENT_PART_OF_THEMES_EC: 'Teil der Themen: ',
  EVENT_BUDGET_EC: 'Veranstaltungsbudget',
  EVENT_REM_BUDGET_EC: 'Verbleibendes Veranstaltungsbudget',
  EVENT_PRE_EVENT_Q_EC: 'Frage vor dem Event (Antwort ist immer Ja / Nein)',
  EVENT_PRE_EVENT_Q_SMALL_EC: 'Frage vor dem Event',
  EVENT_MANAGED_EC:
    'Bitte wählen Sie diese Option, wenn das Ereignis von einer Planboard verwaltet wird',
  EVENT_TICKET_TYPES_EC:
    'Um Tickets zur Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten',
  EVENT_BOOKING_POL_EC:
    'Um Buchungsrichtlinien für die Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten',
  EVENT_SUG_EC:
    'Um der Veranstaltung Vorschläge hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten',
  EVENT_ALTER_EC:
    'Um Alternativen zur Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten',
  EVENT_SUB_ACT_EC:
    'Um der Veranstaltung Unteraktivitäten hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten',

  // Partner confirmation
  PAR_CON_LEAD_P1: 'Die Bestätigung der Bestellung: ',
  PAR_CON_LEAD_P2: ' wurde erhalten. Der neue bestätigte Status ist: ',
  PAR_CON_LEAD_P3:
    'Es wurde keine Bestätigung erhalten. Klicken Sie erneut auf den Link in Ihrer E-Mail, um es erneut zu versuchen. ',
  PAR_CON_OR_ST_ACC: 'Akzeptiert',
  PAR_CON_OR_ST_REJ: 'Abgelehnt',
  PAR_CON_OR_ST_FAI: 'Gescheitert',
  PAR_CON_ORDER: 'Order-ID: ',
  PAR_CON_CONFIRMATION: 'Confirmation-ID: ',
  PAR_CON_STATUS: 'Status: ',

  // Stock details
  CHANGE_STOCK: 'Lagerbestand ändern',
  VALID_CAPACITY: 'Bitte geben Sie eine gültige Kapazität ein',
  STOCK_PRO_SUC_CHANGED:
    'Der Bestand für das ausgewählte Produkt wurde erfolgreich geändert',
  STOCK_ITEM_SUC_CHANGED:
    'Der Bestand für den ausgewählten Produktartikel wurde erfolgreich geändert',
  CONFIRM_PRODUCT_PART_1: 'Sind Sie sicher, dass Sie das Product ',
  CONFIRM_PRODUCT_PART_2: " auf 'Nicht vorrätig' setzen möchten? ",
  ENTER_NEW_PRO_STOCK:
    'Bitte geben Sie den neuen Bestand für das Produkt ein: ',
  CONFIRM_ITEM:
    "Bitte bestätigen Sie, dass Sie das ausgewählte Produkt auf 'Nicht vorrätig' setzen möchten. ",
  ENTER_NEW_ITEM_STOCK:
    'Bitte geben Sie den neuen Bestand unten für den Produktartikel ein.',

  // location
  LOCATION_SQUARE_PER_PERSON: 'Geben Sie den Mindestmeter pro Person ein',
  LOCATION_PUBLIC_TRANSPORT: 'öffentlicher Verkehr',
  LOCATION_MARK_LOCATION: 'Position markieren',
  LOCATION_BOUNDARIES: 'Grenzen',
  LOCATION_LATITUDE: 'Latitude',
  LOCATION_LONGITUDE: 'Longitude',
  LOCATION_RADIUS: 'Strahl',
  LOCATION_USED_BY: 'Benutzt von',
  LOCATION_ENTRY_POINT: 'Einstiegspunkt',
  LOCATION_ENTRY: 'Eingang',
  LOCATION_EXIT: 'Ausgang',
  'LOCATION_ENTRY/EXIT': 'Eingang / ausgang',
  LOCATIONS_CONTAINS: 'Ort enthält',
  LOCATION_ARE_YOU_SURE: 'Kinder! bist du sicher?',

  // map
  MAP_SELECT_LOCATION: 'Wählen Sie einen Ort mit: Rechts + Klicken.',
  MAP_TOUR_CONFIGURATION: 'Konfiguration für die Tour',
  MAP_SELECTED_TOUR_ACTIVITIES: 'Ausgewählte Touraktivitäten',

  // Policies
  POLICIES_EXPLANATION: 'Einige Erklärungen zu Ereignisrichtlinien',
  POLICIES_NEW: 'Neue Richtlinien',

  // Filter
  FILTER_SELECT: 'Filter auswählen',
  FILTER_NO_SELECTED: 'Keine Filter ausgewählt',
  FILTER_SELECTED: 'Ausgewählte Filter',

  // Alternative
  ALTERNATIVE_SELECT: 'Wählen Sie Alternativen aus',

  // Reviews
  LOAD_MORE: 'Mehr laden',
  REVIEWS: 'Bewertungen',
  NEWEST_REVIEWS: 'Neue bewertungen',
  REVIEW: 'Bewertung',
  REVIEW_WRITE: 'eine Rezension schreiben',
  REVIEW_SUCCESS: 'Bewertung erfolgreich veröffentlicht.',
  REVIEW_FAIL:
    'Beim Veröffentlichen Ihrer Bewertung ist ein Fehler aufgetreten.',
  REVIEWS_SEE_MORE: 'Mehr sehen',
  REVIEWS_NO_MESSAGES_YET: 'Es sind noch keine Bewertungen vorhanden',
  REVIEWS_TITLE: 'Was die Leute über uns denken',

  // HomepageBanner
  BANNER_SEARCH_EVENT_TITLE:
    'Suchen Sie die Veranstaltung, die Ihren Anforderungen entspricht!',
  BANNER_SEARCH_EVENT_SUBTITLE:
    'Drücken Sie während der Suche die Eingabetaste, um unseren Filterbildschirm für Ereignisse zu verwenden..',

  // HomepageThemes
  DISCOVER_THEMES: 'Entdecken Sie unsere Themen',

  // HomepageApp
  CHOOSE_THE_APP_REASON_1:
    'Begeben Sie sich auf Abenteuer und folgen Sie einer unserer vielen Routen',
  CHOOSE_THE_APP_REASON_2:
    'Melden Sie Vorfälle, um sich selbst und anderen zu helfen',
  CHOOSE_THE_APP_REASON_3: 'Verwalten Sie Ihre Buchungen unterwegs',

  // Header
  ALL_LANGUAGES: 'Alle Sprachen',

  // ProductInfo
  PRODUCT_WEIGHTED_ATTENTION_TEXT:
    'Dieses Produkt wird nach Menge und Stückpreis verkauft. Die genaue Menge wird nach der Bestellung festgelegt, sodass der Endpreis geringfügig variieren kann',

  // EventDetails Products
  ATTENTION: 'Beachtung',
  OVERWRITE_SHOPPING_CART_ITEM:
    'Dieses Produkt befindet sich bereits in Ihrem Warenkorb. Wenn Sie auf "Zum Warenkorb hinzufügen" klicken, wird Ihr Warenkorbartikel überschrieben.',
  ADD_TO_SHOPPING_CART: 'Warenkorb hinzufügen',
  PRODUCT_INFO_TEXT:
    'Dieses Produkt wird nach Menge und Stückpreis verkauft. Die genaue Menge wird nach der Bestellung festgelegt, sodass der Endpreis geringfügig variieren kann.',
  REQUEST_INFO_TEXT:
    'Ihre Anfrage wird bearbeitet, sobald Sie Ihre Bestellung abgeschlossen haben. Sie erhalten zu einem späteren Zeitpunkt eine Nachricht über die Kosten und können Ihre Bestellung bezahlen.',
  AVAILABLE_CATEGORIES: 'Verfügbare Kategorien',

  // HomepageFooter
  IOS_APP: 'iOS app',
  AND_APP: 'Android app',
  MENU: 'Menü',
  HOME: 'Startseite',
  ABOUT_US: 'Über uns',
  ABOUT_BUYFRESH: 'Über BuyFresh',
  CONTACT: 'Kontakt',
  NEED_HELP: 'Brauchen Sie Hilfe?',
  CONTACT_PAGE: 'Gehen Sie zur Kontaktseite',
  VIEW_FAQ: 'FAQ anzeigen',
  PAGE_SELECT: 'Wählen Sie eine Seite aus',
  PARTNER: 'Partner',

  // Delivery & pickup
  DELIVERY_PICKUP: 'Delivery & pickup',
  INCLUDED_AREAS: 'We deliver to the following areas: ',
  EXCLUDED_AREAS: 'We do not deliver to the following areas: ',
  NO_DELIVERY_OR_PICKUP:
    'Liefer- und Abholveranstaltungen können nicht durchgeführt werden ...',
  DELIVERY_STARTS_FROM: 'Minimaler Bestellwert für die Lieferung ist',
  DELIVERY_NO_ENOUGH_PRODUCTS:
    'Fügen Sie Ihrer Bestellung weitere Produkte hinzu, um den Versand zu aktivieren, oder wählen Sie eine andere Versandart (price übrig)',

  // succes.vue
  BACK_HOME_PAGE: 'Zurück zur Startseite',

  // UserConfirmation
  ALERT_TEXT_CONFIRMED:
    'Wir haben Ihre Anfrage erhalten, aber die Bestellung ist bereits bestätigt. Dieses Fenster wird automatisch geschlossen.',
  ALERT_TEXT_WAI_FOR_PAY_ACCEPT:
    'Wir haben Ihre Zustimmung erhalten, Sie werden automatisch auf die Zahlungsseite weitergeleitet.',
  ALERT_TEXT_WAI_FOR_PAY_REJECT:
    'Wir haben Ihre Ablehnung erhalten, Ihre Bestellung wurde storniert. Dieses Fenster wird automatisch geschlossen.',
  ALERT_TEXT_CANCELLED:
    'Ihre Bestellung wird storniert, bei dieser Bestellung sind keine Aktionen möglich. Dieses Fenster wird automatisch geschlossen.',
  ALERT_TEXT_DONE:
    'Ihre Bestellung ist bereits abgeschlossen, bei dieser Bestellung sind keine Aktionen möglich. Dieses Fenster wird automatisch geschlossen.',
  ALERT_TEXT_PAR_CONF:
    'Sie haben diese Bestellung bereits angenommen / abgelehnt. Die Bestellung wartet auf Zahlungsbestätigung. Bei dieser Bestellung sind keine Aktionen möglich. Dieses Fenster wird automatisch geschlossen',
  ALERT_TEXT_ERROR:
    'Etwas ging schief. Bitte versuche es erneut. Dieses Fenster wird automatisch geschlossen',

  // About us page
  ABOUTUS: 'Über uns',
  ABOUTUS_INFO_PART1:
    'Buy Fresh ist eine Online-Plattform für die Zusammenarbeit lokaler Erzeuger, Metzger, Bäcker und Käsebauern. Buy Fresh ist die ideale Kombination aus Online- und physischem Geschäft.',
  ABOUTUS_INFO_PART2:
    'Mit Buy Fresh können Sie ganz einfach die Qualität des lokalen Frischspezialisten auswählen. Sie können Produkte von mehreren Spezialisten gleichzeitig über einen Webshop bestellen.',
  ABOUTUS_INFO_PART3:
    'Mit Buy Fresh können die Spezialisten die Bearbeitung von Bestellungen, die Einrichtung von Abholpunkten oder die Lieferung von Bestellungen problemlos gemeinsam organisieren.',
  ABOUTUS_INFO_PART4:
    'Durch die intelligente Online-Zusammenarbeit profitieren die Spezialisten von den Kunden des jeweils anderen und teilen sich die Kosten für Abholpunkte und Lieferung, wodurch dies rentabler wird.',
  ABOUTUS_INFO_PART5:
    'Der Komfort des Online-Supermarkts mit der Qualität des lokalen Spezialisten. Das ist Buy Fresh.',
  ABOUTUS_INFO_PART6: 'Interessiert? Mail an ',

  // Error codes for booking flow
  E_PO_006_SUBSCRIPTION_PRODUCT:
    'Einige Produkte in Ihrem Abonnement sind nicht mehr verfügbar.',
  E_PO_006_PRODUCT: 'Dieses Produkt ist nicht mehr verfügbar.',
  E_PO_006_TICKET:
    'Diese Veranstaltung hat nicht genügend Kapazität. Bitte versuchen Sie es mit einem anderen Datum / einer anderen Uhrzeit oder einer anderen Anzahl von Tickets.',
  E_PO_011:
    'Diese Buchung steht im Widerspruch zu früher geplanten Aktivitäten! Bist du dir sicher, dass du weitermachen willst?',
  E_PO_023_ADDPRODUCT:
    'Dieses Produkt kann nicht zu Ihren Warenkorbartikeln hinzugefügt werden, da die Artikel abgelaufen sind. Ihr Warenkorb wird geleert und dieses Produkt wird hinzugefügt.',
  E_PO_023_CHANGEPRODUCT:
    'Dieses Produkt kann nicht geändert werden, da die Artikel in Ihrem Warenkorb abgelaufen sind. Ihr Warenkorb wird geleert und dieses Produkt mit Änderung wird hinzugefügt.',
  E_PO_023_BOOKWITHRESERVATIONS:
    'Der Warenkorb kann nicht gebucht werden, da er abgelaufen ist. Ihr Warenkorb wird geleert. Sie können neue Elemente hinzufügen.',
  E_PO_024_ADDPRODUCT:
    'Dieses Produkt kann nicht hinzugefügt werden, da es nicht mehr Teil Ihrer Bestellung ist.',
  E_PO_024_CHANGEPRODUCT:
    'Dieses Produkt kann nicht geändert werden, da es nicht mehr Teil Ihrer Bestellung ist.',
  E_PO_024_ADDSPECIALREQUEST:
    'Diese spezielle Anfrage kann nicht hinzugefügt werden, da sie nicht mehr Teil Ihrer Bestellung ist.',
  E_DEL_007_DELIVERY_ADD_PRODUCT:
    'Das Produkt konnte nicht hinzugefügt werden, da es von Ihrem ausgewählten Lieferservice ausgeschlossen wurde. Bitte bestellen Sie dieses Produkt separat.',
  E_DEL_007_PICKUP_ADD_PRODUCT:
    'Fehler beim Hinzufügen des Produkts, das nicht am ausgewählten Abholort abgeholt werden kann. Bitte bestellen Sie dieses Produkt separat.',
  E_SL_001:
    'Dieses Produkt erfordert eine Partnerbestätigung und kann daher nicht zu Ihrer Bestellliste hinzugefügt werden.',
  E_USR_077_ADD_TO_LIST:
    'Dieses Produkt kann nicht zu Ihrer Bestellliste hinzugefügt werden, da Bankeinzug oder Kauf auf Rechnung aktiviert sein müssen.',
  E_DEL_002:
    'Der Mindestbestellwert ist nicht erreicht, um die Produkte zu reservieren. Bitte fügen Sie weitere Produkte hinzu oder wählen Sie eine andere Versandart.',
  E_ORD_001_FAILED_PRODUCTS:
    'In Ihrer Bestellliste befinden sich Produkte, die derzeit nicht verfügbar sind :',
  FAILED_PRODUCT_DESC:
    'Bitte entfernen Sie die oben genannten Produkte aus Ihrem Warenkorb oder überprüfen Sie die Produktverfügbarkeit, um das Datum zu ändern.',

  // Account
  SIGN_IN: 'Annmelden',
  NOT_A_MEMBER: 'Kein Mitglied?',
  BACK_TO: 'Zurück zu',

  // Activities
  HISTORY: 'Geschichte',
  NO_UPCOMING_ACTIVITIES: 'Sie haben keine bevorstehenden Aktivitäten ..',
  NO_PAST_ACTIVITIES: 'Sie haben keine früheren Aktivitäten ..',
  NOTE: 'Hinweis',
  GET_TICKETS: 'Tickets bekommen',
  CANCEL_ACTIVITY: 'Aktivität abbrechen',
  LEAVE_A_REVIEW: 'Hinterlassen Sie eine Bewertung',
  REVIEWED: 'Bewertet',
  PICK_A_RATING: 'Bitte wählen Sie eine Bewertung',
  SUBMIT: 'einreichen',
  DELETE_ACTIVITY: 'Aktivität löschen',
  SURE_CANCEL_ACTIVITY: 'Möchten Sie diese Aktivität wirklich abbrechen?',

  // Booking
  DELIVERY_SERVICES: 'Lieferservice',
  TAKE_AWAY: 'Wegbringen',
  SPECIAL_REQUEST: 'Besondere Bitte',
  ORDER_CONFIRMATION: 'Bestellbestätigung',
  BOOKING_CREDIT:
    'Wenn Sie ein Guthaben für diesen Webshop haben, wird es automatisch von der Bestellung abgezogen!',
  BOOKING_COMPLETE: 'Komplett',
  BOOKING_OUR_SUGGESTIONS: 'Unsere Vorschläge',
  BOOKING_CREATE_ACCOUNT:
    'Ich möchte ein Konto für zukünftige Buchungen erstellen',
  AGREE_PRIVACY_STATEMENT_BOOK:
    'Mit der Erstellung eines Kontos oder einer Bestellung stimmen Sie unseren',

  // Event
  ADD_SPECIAL_REQUEST: 'Sonderwunsch hinzufügen',
  SEND_SPECIAL_REQUEST: 'Sonderwunsch senden',

  // Yet to be placed correctly
  LOG_IN: 'Anmeldung',
  EMAIL_REQUIRED: 'E-Mail ist erforderlich',
  EMAIL_VALID: 'Email muss gültig sein',
  EMAIL_NO_MATCH: 'Die eingegebenen E-Mail-Adressen stimmen nicht überein',
  PASSWORD_REQUIRED: 'Passwort wird benötigt',
  FIRST_NAME_REQUIRED: 'Vorname ist erforderlich',
  LAST_NAME_REQUIRED: 'Nachname ist erforderlich',
  STREET_REQUIRED: 'Straße ist erforderlich',
  HOUSE_NR_REQUIRED: 'Hausnummer ist erforderlich',
  POSTAL_CODE_REQUIRED: 'Postleitzahl ist erforderlich',
  LOGIN_GOOGLE: 'Mit Google anmelden',
  LOGIN_FACEBOOK: 'Mit Facebook anmelden',
  LOGIN_APPLE: 'Mit Apple anmelden',
  OR: 'Oder',
  NO_SUCCESS_LOGGED_IN: 'Login fehlgeschlagen',
  LOGIN_ERROR:
    'Login fehlgeschlagen! Überprüfen Sie, ob Sie alles richtig eingegeben haben.',
  SUCCESS_LOGGED_IN: 'Erfolgreich eingeloggt',
  SUCCESS_LOGGED_OUT: 'Erfolgreich abgemeldet',
  LOADING_ACTIVITIES_FAILED:
    'Beim Laden Ihrer Aktivitäten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
  BOOK_ORDER_FAILED:
    'Bei der Buchung Ihrer Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
  NO_DELIVERY_FOR_POSTAL_CODE:
    'Für die ausgewählte Postleitzahl ist keine Zustellung möglich',
  FAILED_RESERVING_TICKETS:
    'Wenn Sie Ihre Tickets nicht reserviert haben, versuchen Sie es erneut',
  ONE_MOMENT: 'Einen Moment...',
  WAITING_PAYMENT_PROCESS: 'Warten auf die Bearbeitung der Zahlung',
  PAYMENT_RECEIVED: 'Zahlung erhalten',
  PAYMENT_RECEIVED_DESC:
    'Ihre Zahlung wurde erhalten. Sie können Ihre geplanten Aktivitäten anzeigen, indem Sie auf die Schaltfläche unten klicken',
  PAYMENT_FAILED_DESC:
    'Die Transaktion ist fehlgeschlagen und Ihre Zahlung wurde nicht empfangen. Bitte überprüfen Sie Ihre Mail für Anweisungen.',
  PRODUCT_OVERWRITED_ITEM_IN_SHOPPING_CART:
    'Das Produkt hat Ihren Artikel in Ihrem Warenkorb erfolgreich überschrieben',
  ADD_SPECIAL_REQUEST_HERE: 'Fügen Sie hier Ihre spezielle Anfrage hinzu',
  SPECIAL_REQUEST_SEND: 'Die spezielle Anfrage wurde an den Partner gesendet',
  FAILED_ADDING_SPECIAL_REQUEST:
    'Wenn Sie Ihre spezielle Anfrage nicht zu Ihrer Reservierung hinzugefügt haben, versuchen Sie es erneut',
  FAILED_BOOKING_SPECIAL_REQUEST:
    'Wenn Sie Ihre spezielle Anfrage nicht gebucht haben, versuchen Sie es erneut',
  THE_EVENT: 'Das Ereignis ',
  THE_PRODUCT: 'Das Produkt ',
  THE_CATEGORY: 'Die Kategorie ',
  ADDED_TO_FAV: ' wurde zu Ihren Favoriten hinzugefügt',
  ADDED_TO_FAV_GENERIC: 'Erfolgreich zu Ihren Favoriten hinzugefügt',
  DELETED_FROM_FAV: ' wurde aus Ihren Favoriten gelöscht',
  DELETED_FROM_FAV_GENERIC: 'Erfolgreich aus Ihren Favoriten entfernt',
  SHOW_VIDEO: 'Video anzeigen',
  SHOW_URL: 'URL anzeigen',
  UNIT_PRICE: 'Stückpreis',
  UPLOAD_AN_IMAGE: 'Lade ein Bild hoch',
  FILE_NOT_BIGGER_THAN_10MB: 'Die Datei darf nicht größer als 10 MB sein',
  FILE_NOT_AVAILABLE: 'Datei ist nicht verfügbar',
  BANNER_NOT_LOADED: 'Das Banner wurde nicht geladen',
  NO_LOCATIONS_LOADED: 'Keine Standorte geladen',
  ACCOUNT_SETTINGS: 'Account Einstellungen',
  INTERESTS: 'Interests',
  FAVOURITES: 'Favoriten',
  NOTIFICATIONS: 'Benachrichtigungen',
  FIRST_NAME: 'Vorname',
  LAST_NAME: 'Familienname',
  HOUSE_NR: 'Hausnummer',
  PICK_AN_AVATAR: 'Wähle einen Avatar',
  DIRECT_DEBIT_TITLE: 'Mehr Komfort bei der Bestellung?',
  DIRECT_DEBIT_DESC_1: 'Bestellen Sie häufig?',
  DIRECT_DEBIT_DESC_2:
    'Machen Sie es sich einfach und zahlen Sie mit Lastschrift. Sie können schnell und ohne Flaum bestellen. Sie finden, Sie wählen und Sie sind fertig.',
  DIRECT_DEBIT_DESC_3: 'Möchten Sie auch per Lastschrift bezahlen?',
  DIRECT_DEBIT_DESC_4: 'Jetzt anfangen!',
  DIRECT_DEBIT_DESC_LIST_1: '1. Geben Sie Ihre Daten ein und bestätigen Sie.',
  DIRECT_DEBIT_DESC_LIST_2: '2. Machen Sie eine erste Zahlung mit ideal.',
  DIRECT_DEBIT_DESC_LIST_3:
    '3. Innerhalb von zwei Arbeitstagen ist die Lastschrift aktiviert.',
  I_WANT_TO_USE_DIRECT_DEBIT: 'Ja, ich möchte Lastschrift verwenden',
  ACTIVATE_DIRECT_DEBIT: 'Lastschrift aktivieren',
  DEACTIVATE_DIRECT_DEBIT: 'Lastschrift deaktivieren',
  DEACTIVATE_DIRECT_DEBIT_MSG:
    'Wenn das Lastschriftverfahren deaktiviert ist, benötigen Sie weitere Schritte, um Ihre Bestellungen abzuschließen. Sie können den Lastschrifteinzug trotzdem wieder aktivieren, wenn Sie mehr Komfort bei der Bestellung wünschen. Möchten Sie mit der Deaktivierung fortfahren?',
  DIRECT_DEBIT_ACTIVATED: 'Lastschrift aktiviert',
  DIRECT_DEBIT_NOT_ACTIVATED: 'Lastschrift nicht aktiviert',
  DEACTIVATE_DIRECT_DEBIT_GENERIC_ERROR:
    'Lastschrift konnte nicht deaktiviert werden. Bitte versuchen Sie es später erneut.',
  DEACTIVATE_DIRECT_DEBIT_SUBSCRIPTION_ERROR:
    'Lastschrift konnte aufgrund aktiver Abonnements unten nicht deaktiviert werden. Beenden Sie zuerst die Verfolgung von Abonnements und versuchen Sie es dann erneut.',
  ACTIVATE_DIRECT_DEBIT_ERROR:
    'Lastschrift konnte nicht aktiviert werden. Bitte versuchen Sie es später erneut.',
  DIRECT_DEBIT_PAYMENT_SUCCESS_DESC:
    'Ihre Zahlung zur Aktivierung des Lastschriftverfahrens ist eingegangen. Genießen Sie Ihre Bestellung mit einem sichereren und bequemeren Erlebnis.',
  DIRECT_DEBIT_PAYMENT_FAILED_DESC:
    'Die Transaktion ist fehlgeschlagen und die Lastschrift ist nicht aktiviert. Bitte versuchen Sie es später erneut.',
  ACCOUNT_HOLDER_NAME: 'Name des Kontoinhabers',
  SUCCESS_SAVING_SETTINGS: 'Deine Einstellungen wurden gespeichert',
  FAILED_SAVING_SETTINGS:
    'Fehler beim Speichern Ihrer Einstellungen, versuchen Sie es erneut',
  AVATAR_SIZE_MAX_2MB: 'Die Größe des Avatars sollte weniger als 2 MB betragen',
  FAILED_SAVING_FAVOURITES: 'Fehler beim Speichern Ihrer Favoriten',
  FAILED_GET_INTERESTS:
    'Wenn Sie Ihre Interessen nicht abrufen konnten, versuchen Sie es erneut',
  FAILED_SAVING_INTERESTS:
    'Wenn Sie Ihre Interessen nicht speichern konnten, versuchen Sie es erneut',
  AGREE_NOTIFICATIONS:
    'Durch Aktivieren dieses Kontrollkästchens stimmen Sie dem Erhalt von Benachrichtigungen zu',
  FAILED_GET_NOTIFICATIONS:
    'Fehler beim Abrufen Ihrer Benachrichtigungseinstellungen',
  SUCCESS_SAVE_NOTIFICATIONS:
    'Ihre Benachrichtigungseinstellungen wurden gespeichert',
  FAILED_SAVE_NOTIFICATIONS:
    'Versuchen Sie erneut, Ihre Benachrichtigungseinstellungen nicht zu speichern',
  STAT_VIEWS: 'Ansichten',
  TRENDING_PRODUCTS: 'Trendprodukts',
  TRENDING_EVENTS: 'Trendaktivitäten',
  TRENDING: 'Dies sind unsere Top-Picks',
  TRENDING_NO_ITEMS: 'Keine Trendartikel',
  GO_TO_ACCOUNT_SETTINGS: 'Gehe zu Einstellungen',

  // Subscriptions
  SUBSCRIPTION_TEXT:
    'Wie möchten Sie für neue benachrichtigt werden (recepten):',
  SUBSCRIPTION_EMAILS: 'E-Mails',
  SUBSCRIPTION_PUSH: 'Mitteilungen',
  CANCEL: 'Stornieren',

  NO_REVIEWS_AVAILABLE: 'Es sind noch keine Bewertungen verfügbar',
  PICKUP_POINT: 'Abholpunkt',
  NO_NAME_AVAILABLE: 'Kein Name verfügbar',
  NO_ADDRESS_AVAILABLE: 'Keine Adresse verfügbar',
  NO_PHONE_NUMBER_AVAILABLE: 'Keine Telefonnummer verfügbar',
  NO_OPENING_HOURS_AVAILABLE: 'Keine Öffnungszeiten verfügbar',

  VIEW: 'Aussicht',
  MAINTENANCE_1:
    'Kann keine Verbindung zum Server herstellen. Möglicher Grund ist keine oder eine langsame Internetverbindung oder Plattform Wartungsarbeiten.',
  MAINTENANCE_2:
    'Wir versuchen, die Verbindung automatisch wiederherzustellen...',
  MAINTENANCE_3: 'In ',
  MAINTENANCE_4: ' Sekunden',
  SOMETHING_WENT_WRONG: 'Etwas ist schief gelaufen',
  ITEMS_ADDED_TO_BASKET: 'Artikel wurden Ihrem Warenkorb hinzugefügt',
  ITEMS_ADDED_TO_BASKET_FOR_SHOPPINGLIST: 'Artikel wurden hinzugefügt zu',
  ITEMS_CHANGED_TO_BASKET_FOR_SHOPPINGLIST: 'Artikel wurden geändert am',
  GO_TO_SHOPPING_CART: 'Zum Warenkorb gehen',
  GO_TO_SHOPPING_LIST: 'Zur Bestellliste gehen',
  CONTINUE_SHOPPING: 'Mit dem Einkaufen fortfahren',
  EMPTY_CART: 'Leerer Warenkorb',
  ADD_TO_SHOPPING_LIST: 'Auf die Merkliste',

  // Chats
  SELECT_PARTNER_TO_CHAT:
    'Bitte wählen Sie einen Partner aus, mit dem Sie chatten möchten',
  YOUR_CHAT_WITH: 'Dein Chat mit ',
  NEW_SUBJECT: 'Neues Thema: ',
  TYPE_MESSAGE_HERE: 'Schreiben Sie ihre Nachricht hier...',
  MESSAGE_NOT_SEND: 'Nachricht wird nicht gesendet',
  PARTNER_SELECT: 'Wählen Sie einen Partner',

  // promotions
  PROMOTIONS_STAY_INFORMED: 'Bleib informiert',
  PROMOTIONS_INFORMATION:
    'Tippe auf das Herz, um über lustige Aktionen wie diese auf dem Laufenden zu bleiben.',

  // newsletter
  NEWSLETTER: 'Newsletter',
  NEWSLETTER_TITLE: 'Seien Sie der Erste, der es weiß?',
  NEWSLETTER_DESCRIPTION:
    'Bleiben Sie auf dem Laufenden und erhalten Sie als Erster unterhaltsame Werbeaktionen und wettbewerbsfähige Angebote in Ihrer Mailbox',
  NEWS_LETTER_BUTTON: 'Halte mich auf dem Laufenden',
  NEWS_LETTER_BUTTON_HTML: 'Halte mich auf<br>dem Laufenden',

  NO_ACTIVITIES: 'Keine Aktivitäten verfügbar',

  // auction
  AUCTION_EXPLANATION:
    "Das Bieten funktioniert folgendermaßen: <br> - Zum Auktionsereignis gehen <br> - Wählen Sie ein Produkt aus, auf das geboten werden soll <br> - Der Betrag läuft ab. Warten Sie also, bis der Betrag Ihren gewünschten Betrag erreicht hat. <br> - Wählen Sie die gewünschte Menge und drücken Sie 'my' <br> - Das Produkt gehört jetzt Ihnen für den Preis, auf dem es endete",
  SHOPPING_CART_NAME: 'Warenkorb',
  SHOPPING_LIST_NAME: 'Name der Bestellliste',
  PICK_A_LIST: 'Wähle eine Liste',
  NEW_SHOPPING_LIST: '+ neue Bestellliste',
  TO_CONTINUE_PROVIDE_NAME:
    'Bitte geben Sie Ihrer Bestellliste einen Namen, um fortzufahren',
  NO_SHOPLIST_YET: 'Keine Bestellliste verfügbar, bitte erstellen Sie eine',
  SHOPPINGLISTS: 'Bestellliste',
  SHOPPINGLISTS_PRODUCTS: 'Bestelllistenprodukte',
  SHOPPINGLISTS_DETAILS: 'Details zur Bestellliste',
  NO_PRODUCTS_FOR_SHOPPINGLIST: 'Noch keine Produkte für die Bestellliste',
  COPY_TO_SHOPPINGCART: 'in den Warenkorb kopieren',
  ADD_USER_TO_SHOPPINGLIST: 'Neuen Benutzer hinzufügen',
  ADD_USER: 'Neuen Benutzer',
  ENTER_MAIL: 'Geben Sie die E-Mail-Adresse ein',
  CHANGE_SHOPPINGLIST_NAME: 'Ändern Sie den Namen der Bestellliste',
  DELETE_SHOPPINGLIST: 'Bestellliste löschen',
  CANCEL_SHOPPINGLIST: 'Bestellung stornieren',
  SURE_CANCEL_SHOPPINGLIST: 'Möchten Sie die Bestellung wirklich stornieren?',
  SURE_DELETE_SHOPPINGLIST: 'Möchten Sie die Bestellliste wirklich löschen?: ',
  DELETE_USER_FROM_MAIL_LIST: 'Benutzer aus Mail-Liste löschen',
  SURE_DELETE_USER_FROM_MAIL_LIST:
    'Möchten Sie den folgenden Benutzer wirklich aus der Mailingliste löschen?: ',
  NEWSLETTER_ALERT_SUCCESS:
    'Vielen Dank für Ihre Registrierung. Sie erhalten jetzt unterhaltsame Aktivitäten und die besten Angebote per E-Mail',
  NEWSLETTER_ALERT_USEREXISTED:
    'Die Registrierung kann nicht erfolgreich abgeschlossen werden, da diese E-Mail bereits die besten Angebote und unterhaltsamen Aktivitäten enthält',
  NEWSLETTER_ALERT_ERROR: 'Etwas ist schief gelaufen. Bitte versuche es erneut',
  STATUS: 'Status',
  PAY: 'Zahlen',
  SEARCH_ORDERS: 'Aufträge durchsuchen...',
  DELIVERY_INFORMATION: 'Lieferinformationen',
  DELIVERY_COST: 'Versandkosten',
  GIVE_SHOPPING_LIST_NAME: 'Geben Sie einen Namen für die Bestellliste ein',
  CLEAR_SHOP_LIST: 'Bestellliste löschen',
  SURE_CLEAR_SHOP_LIST:
    'Möchten Sie alle Produkte in dieser Bestellliste löschen: ',
  CLEAR: 'klar',
  LEAVE: 'Verlassen',
  DUTCHSTAMPS: 'Dichtungen',
  SAVING_DUTCH_STAMPS: 'Sparstempel',
  STORE_CREDIT: 'Guthaben speichern',
  YOUR_STORE_CREDIT: 'Ihr Guthaben für den ',
  CONTAINS: 'ist: ',
  CURRENT_STAMP_AMOUNT: 'Aktueller Stempelbetrag: ',
  CURRENT_FILLED_STAMP_BOOKS: 'Komplette Sets verfügbar: ',
  TOTAL_STAMP_AMOUNT: 'Gesamtstempelbetrag: ',
  REDEEM_EXPL:
    'Wenn Sie alle Ihre gefüllten Briefmarkenbücher in das Guthaben übertragen möchten, klicken Sie bitte auf die Schaltfläche unten',
  REDEEM: 'Einlösen',
  SKIP_DELIVERY: 'Nächste Lieferung überspringen',
  SKIP_DELIVERY_CONFIRM_TITLE: 'Nächste Lieferung überspringen',
  SKIP_DELIVERY_CONFIRM_MESSAGE:
    'Möchten Sie die nächste Lieferung wirklich überspringen? Wenn dies der Fall ist, wird das System die Lieferung basierend auf Ihrer Wiederholungsoption automatisch für Sie neu planen.',
  SKIP_DELIVERY_SUCCESS:
    'Die nächste Lieferung wurde übersprungen und eine neue ist geplant.',
  SKIP_DELIVERY_ERROR:
    'Fehler beim Überspringen der nächsten Lieferung. Bitte versuchen Sie es später erneut.',
  PAY_SHOPPING_LIST_TITLE: 'Bestellliste bezahlen',
  PAY_SHOPPING_LIST_MESSAGE: 'Möchten Sie wirklich mit der Zahlung fortfahren?',
  NEW_SHOPPING_LIST_TITLE: 'Neue Bestellliste',
  SAVE_SHOPPING_LIST_ERROR:
    'Fehler beim Speichern der Bestellliste. Bitte versuchen Sie es später erneut.',

  EMPTY_SHOPPINGLIST: 'Bestellliste löschen',
  PICK_YOUR_MOMENT: 'Wählen Sie den Abhol- / Lieferzeitpunkt',
  PAY_NOW: 'Bestellen',
  SHOPPING_LIST_DETAILS: 'Details zur Bestellliste',
  ORDER_ONCE:
    'Sie haben ausgewählt, dass die Bestellung nur einmal ausgeführt wird',
  ORDER_EVERY_WEEK:
    'Sie haben ausgewählt, dass die Bestellung jede Woche wiederholt wird',
  ORDER_EVERY_TWO_WEEKS:
    'Sie haben ausgewählt, dass die Bestellung alle zwei Wochen wiederholt wird',
  ORDER_EVERY_THREE_WEEKS:
    'Sie haben ausgewählt, dass die Bestellung alle drei Wochen wiederholt wird',
  ORDER_EVERY_FOUR_WEEKS:
    'Sie haben ausgewählt, dass die Bestellung jeden Monat wiederholt wird',
  SHOPPING_LIST_DEADLINE: 'Frist für Änderungen',
  DELIVERY_SERVICE: 'Lieferservice',
  CLEAR_SHOPPING_LIST_MOMENT:
    'Ich möchte auch meinen Abhol- / Lieferzeitpunkt löschen',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT:
    'Sie haben erfolgreich einen Abhol- / Lieferzeitpunkt für diese Bestellliste ausgewählt',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT_EXTRA:
    'Die Liste wird automatisch bestellt, wenn Sie die Berechtigung haben, auf Rechnung oder per Lastschrift zu bestellen. Andernfalls bezahlen Sie die Bestellung manuell vor Ablauf der Frist. Sie erhalten automatisch eine E-Mail mit einem Zahlungslink.',
  MOMENT_FOR_SHOPPINGLIST: 'Abhol- / Lieferzeitpunkt für Bestellliste',
  PICK_YOUR_DATE_AND_TIME: 'Wählen Sie Datum und Uhrzeit',
  AUTOMATICALLY_REPEAT_ORDER:
    'Möchten Sie die Bestellung automatisch wiederholen?',
  REPEATING: 'Wiederholen',
  CLEAR_SHOPPING_LIST_AFTER_PAYMENT:
    'Löschen Sie die Bestellliste nach der Zahlung',
  CONFIRM_PICKUP_DELIVERY_MOMENT: 'Bestätigen Sie den Abhol- / Lieferzeitpunkt',
  ONCE: 'Einmal',
  EVERY_WEEK: 'Jede Woche',
  EVERY_TWO_WEEKS: 'Alle zwei Wochen',
  EVERY_THREE_WEEKS: 'Alle drei Wochen',
  EVERY_FOUR_WEEKS: 'Jeden Monat',
  EMAIL_NO_MATCH: 'Email stimmt nicht überein',
  PAYMENT_SHOPPINGLIST: 'Zahlungs-Bestellliste',
  PAYMENT_SHOPPINGLIST_SURE:
    'Sind Sie sicher, dass Sie mit der Zahlung für die Bestellliste fortfahren möchten?',
  GO_TO_ACCOUNT: 'Gehe zum Konto',
  REVIEW_ONLY_WITH_NAME:
    'Eine Meinungsäußerung ist nur möglich, wenn Sie in Ihren Kontodaten Ihren Namen eingetragen haben. Um eine Bewertung zu hinterlassen, müssen Sie Ihren Namen in Ihrem Konto angeben.',
  CLICK_TO_SET_NAME:
    'Klicken Sie auf die Schaltfläche unten, um zu Ihrem Konto zu gelangen und Ihren Vor- / Nachnamen einzugeben.',

  // header texts
  HOMEPAGE: 'Startseite',
  CATEGORIES: 'Kategorien',
  ORDER: 'Bestellen',
  KLANTENSERVICE: 'Bedienung',
  REWARD_CLUB: 'Belohnungsclub',
  CATEGORIES_TITLE: 'Stöbern Sie durch unsere Produkte',

  // customer service
  WHAT_HELP_WITH: 'Mit was können wir dir helfen?',
  MY_ACCOUNT: 'Mein Konto',
  MY_ORDERS: 'Meine Bestellungen',
  BUG_REPORT: 'Fehlerbericht',
  M_A_Q: 'Häufig gestellte Fragen',
  SHOW_MORE: 'Zeig mehr',
  SHOW_LESS: 'Zeige weniger',
  REPORT_A_BUG: 'Melden Sie Fehler',
  GO_TO_ACCOUNT: 'Gehen Sie zu Ihren Kontoeinstellungen',
  GO_ORDER: 'Gehen Sie zu Ihren Bestellungen',
  REPORT: 'Report',
  BUG_DESC: 'Fehlerbeschreibung',
  ACTIONS: 'Wie ist der Fehler entstanden?',
  PLATFORM: 'Plattform',
  OTHER_QUESTIONS:
    'Haben Sie noch weitere Fragen? Bitte zögern Sie nicht uns zu kontaktieren.',
  VOORDELEN_ONLINE: 'Warum online statt im Geschäft bestellen?',
  VOORDELEN_ONLINE_DESC:
    'Online zu bestellen ist einfach, sicher und spart Zeit. Sie bestellen bequem zu Hause in unserem benutzerfreundlichen Webshop oder in unserer App und bezahlen kontaktlos und sicher online. Ihre Bestellung wird zu Ihnen nach Hause geliefert oder steht am Abholpunkt im Geschäft für Sie bereit. Sie vermeiden Menschenmassen und müssen nicht anstehen. Außerdem können Sie sicher sein, dass Ihnen die gewünschten Produkte zur Verfügung stehen. Selbstverständlich sind Ihre (Zahlungs-)Daten gut vor böswilligen Parteien geschützt.',
  WHY_ACCOUNT: 'Warum ist es eine gute Idee, ein Konto zu erstellen?',
  WHY_ACCOUNT_DESC:
    'Mit einem Konto genießen Sie zusätzlichen Komfort und tolle Vorteile. Wiederholen Sie einfach frühere Bestellungen, oder nutzen Sie unseren Online-Einkaufszettel, in den Sie unter der Woche ganz einfach die benötigten Lebensmittel hinzufügen und diese dann per Knopfdruck bestellen können. Damit Sie den Bezahlvorgang nicht jedes Mal wiederholen müssen, ist die Zahlung per Lastschrift möglich. Außerdem profitieren Sie von tollen Sparaktionen, exklusiven Aktivitäten und Rabatten.',
  QUESTIONS_ORDERS:
    'Wohin kann ich mich bei Fragen zu meiner Bestellung wenden?',
  QUESTIONS_ORDERS_DESC:
    'Bei Fragen oder Problemen mit Ihrer Bestellung wenden Sie sich bitte an den Namen des Partners. Dies kann über <a href="mailto:partnermail"> partneremail </a> oder <a href="tel:partnernum"> partnernumb </a> während der Öffnungszeiten unseres Geschäfts erfolgen.',
  QUESTIONS_ORDERS_DESC_2:
    'Bei Fragen oder Problemen mit Ihrer Bestellung wenden Sie sich bitte an den Namen des Partners. Dies kann über <a href="mailto:partnermail"> partneremail </a> während der Öffnungszeiten unseres Geschäfts erfolgen.',
  QUESTIONS_PRODUCTS:
    'Was ist, wenn ich einen Wunsch oder eine Frage zu einem Produkt habe?',
  QUESTIONS_PRODUCTS_DESC:
    'Bei Fragen zum Sortiment, zu Produkten oder besonderen Wünschen und Wünschen wenden Sie sich bitte an den Partnernamen. Dies kann über <a href="mailto:partnermail"> partneremail </a> oder <a href="tel:partnernum"> partnernumb </a> während der Öffnungszeiten unseres Geschäfts erfolgen.',
  QUESTIONS_PRODUCTS_DESC_2:
    'Bei Fragen zum Sortiment, zu Produkten oder besonderen Wünschen und Wünschen wenden Sie sich bitte an den Partnernamen. Dies kann über <a href="mailto:partnermail"> partneremail </a> während der Öffnungszeiten unseres Geschäfts erfolgen.',
  WORKING_SHOPCREDITS: 'Wie funktioniert das Guthaben im Online-Shop?',
  WORKING_SHOPCREDITS_DESC:
    'Online-Shop-Guthaben steht nur Kunden mit einem Konto zur Verfügung. Sie werden benachrichtigt, wenn Sie ein neues Online-Shop-Guthaben haben. Das Guthaben des Online-Shops wird automatisch von Ihrer nächsten Online-Bestellung abgezogen. Sie müssen angemeldet sein, um das Online-Shop-Guthaben nutzen zu können. Erst im letzten Schritt des Bestellvorgangs zum Zeitpunkt der Zahlung wird das Guthaben vom Bestellbetrag abgezogen. Dort sehen Sie, dass der Betrag Ihrer Bestellung reduziert wurde. Bei Fragen oder Problemen wenden Sie sich bitte an den Helpdesk Buy Fresh unter helpdesk@buyfresh.nl oder 0297 382468.',
  PROBLEMS_WEBSHOP:
    'Was ist, wenn ich Probleme mit dem Webshop oder der App habe?',
  PROBLEMS_WEBSHOP_DESC:
    'Haben Sie ein Problem mit dem Webshop oder der App? Wir finden das sehr nervig, wir entschuldigen uns! Wir helfen Ihnen gerne, so schnell wie möglich wieder auf Kurs zu kommen. Bei Problemen oder technischen Fragen wenden Sie sich bitte an den Helpdesk Buy Fresh unter helpdesk@buyfresh.nl oder 0297 382468.',
  WHAT_BUYFRESH: 'Was ist Buy Fresh?',
  WHAT_BUYFRESH_DESC:
    'Buy Fresh ist eine Online-Plattform, auf der Sie handwerkliche Produkte direkt bei lokalen Erzeugern, Bauern, Metzgern, Bäckern und Geflügelhändlern bestellen können. Buy Fresh ist die ideale Kombination aus Online- und physischem Geschäft. Mit Buy Fresh können Sie ganz einfach die Qualität des lokalen Frischspezialisten auswählen. Durch den Kauf über Buy Fresh unterstützen Sie lokale Geschäfte und entscheiden sich in vielen Fällen für nachhaltigere Produkte aus der Region. Weitere Informationen finden Sie unter www.buyfresh.nl.',
  OPEN: 'Geöffnet',
  MAIL_WITH_US: 'Mailen Sie mit uns',
  CALL_US: 'Rufen Sie uns an',
  TECHINCAL_HELP: 'Für technischen Support wenden Sie sich bitte an',

  // bug report
  WHEN_OCCURANCE: 'Wann ist das Problem aufgetreten?',
  DESCRIPTION_PROBLEM: 'Beschreibung des Problems ',
  WHAT_PLATFORM:
    'Auf welcher Plattform ist das Problem aufgetreten? Website, mobile Website, Android oder Apple App?',
  TECHINCAL_SUPPORT: 'Technischer Support',

  // logout
  ARE_YOU_SURE_LOGOUT: 'Möchten Sie sich abmelden?',

  ONLY_FOR_MEMBERS: 'Dieses Produkt ist nur für Mitglieder verfügbar',

  YOUR_DUTCH_STAMPS: 'Deine Siegel',
  CREATE_ACCOUNT_FOR_STAMPS:
    'Erstellen Sie ein Konto, um für niederländische Briefmarken und viele andere Vorteile zu sparen.',
  YOUR_FAVOURITES: 'Ihre Favoriten!',
  YOU_HAVE: 'Du hast',
  FULL_CARDS: 'volle Karten',
  STAMPS_YOUR_PARTNER_STAMPS: 'Ihre (partner)Briefmarken',
  OPEN_STAMPS: 'Öffne meine Dichtungen',

  // rental changes
  RENTAL_DIALOG_TITLE: 'Fügen Sie weitere Artikel hinzu?',
  RENTAL_DIALOG_DESC:
    'Möchten Sie weitere Artikel dieser Kategorie <b>%s</b> zu Ihrer Bestellung hinzufügen?',
  NO_STARTDATES:
    'Es gibt leider keine Termine, an denen Produkten verfügbar sind',

  ALERT_NO_DATES:
    'Derzeit gibt es keine Termine, an denen Ihre Bestellung geliefert oder abgeholt werden kann',

  // Search
  SEARCH_SENTENCE: 'Was suchen Sie?',

  // open url
  GO_TO: 'Gehe zu',

  RESULTS: 'Ergebnisse',

  // blog posts
  BLOG_POSTS: 'Erfahrung',
  BLOGS: 'Aktuelle Artikel',
  BLOGS_TITLE: 'Schauen Sie sich unsere Blogs an',

  COPY_TO_CLIPBOARD_SUCCEEDED: 'Erfolgreich in die Zwischenablage kopiert',
  COPY_TO_CLIPBOARD_FAILED: 'Fehler beim Kopieren in die Zwischenablage',
  AGENDA: 'Agenda',
  AGENDA_NO_EVENTS: 'Keine bevorstehenden Veranstaltungen',

  // app promotion
  DOWNLOAD_APP: 'Entdecken Sie den Komfort unserer App',
  APP_TEXT:
    'Bestellen Sie einfach, sicher und schnell mit der PARTNERNAAM App. Jetzt für Android oder Apple herunterladen.',

  // delete account
  ERROR_DELETE_USER:
    'Beim Löschen des Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
  SUCCESS_DELETE_ACC: 'Konto erfolgreich gelöscht',
  DELETE_ACCOUNT: 'Konto löschen',
  DELETE_ACCOUNT_ARE_YOU_SURE:
    'Wenn Sie Ihr Konto löschen, können Sie keine Ihrer Bestellungen sehen. Möchten Sie Ihr Konto wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',

  DAYS: 'Tage',
  CHARACTERISTICS: 'Merkmale',

  DELIVERY_ADDRESS: 'Lieferadresse',
  NO_CONFIDENCE_ADDRESS:
    'Wir konnten Ihre Adresse mit der von Ihnen angegebenen Postleitzahl und Hausnummer nicht finden, bitte geben Sie diese selbst ein',
  ENTER_EMAIL_TEXT:
    'Geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden, ein Konto zu erstellen oder über Ihre Bestellung informiert zu bleiben',

  // order overview
  ORDER_OV_PRICE: 'Preis',
  CONTACT_DETAILS: 'Kontaktdetails',

  CONTINUE_AS_GUEST: 'Als Gast fortfahren',
  DELIVERY_DETAILS: 'Lieferdetails',
  DELIVERY_DATE: 'Lieferdatum und -uhrzeit',
  RESERVE_ORDER: 'Bestellung reservieren',
  ENTER_EMAIL: 'Geben sie ihre E-Mail Adresse ein',
  PHONE_NO_RECOGNITION: 'Falsche Telefonnummer',
  PHONE_NO_RECOGNITION_DESC:
    'Wir erkennen dieses Telefonnummernformat nicht. Bist du sicher, dass es richtig ist?',
  PHONE_WHY:
    'Wir bitten um Ihre Telefonnummer, damit wir Sie telefonisch informieren können, wenn bei Ihrer Bestellung etwas schief geht',
  RETURNING_CUSTOMER: 'Wiederkehrender Kunde',
  NEW_CUSTOMER: 'Neukunde',
  CREATE_ACCOUNT: 'Ein Konto erstellen',
  RENTAL_DETAILS: 'Mietdetails',
  CHECKOUT: 'Auschecken',
  ENTER_YOUR_EMAIL: 'Geben sie ihre E-Mail Adresse ein',
  EMAIL_WHY:
    'Geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden, ein Konto zu erstellen oder als Gast fortzufahren',
  LOGIN_INFO:
    'Wir haben ein Konto mit der eingegebenen E-Mail gefunden, möchten Sie sich einloggen?',
  WHY_LOGIN:
    'Durch die Anmeldung können Sie Ihr Benutzerguthaben und mehr verwenden',
  FOUND_AN_ACCOUNT:
    'Wir haben ein Konto mit Ihrer eingegebenen E-Mail-Adresse gefunden. Möchten Sie sich einloggen?',
  BENEFITS_REGISTERING:
    'Wenn Sie ein Konto registrieren, erhalten Sie Zugang zu diesen Vorteilen und vielem mehr!',
  LOGIN_OR_CONTINUE: 'Einloggen oder als Gast fortfahren',
  CREATE_ACCOUNT_OR_CONTINUE:
    'Erstellen Sie ein Konto oder fahren Sie als Gast fort',
  SUCCESS_REGISTER:
    'Sie haben sich erfolgreich registriert, Sie haben eine Bestätigungs-E-Mail erhalten, bitte bestätigen Sie Ihr Konto.',
  ORDER_ACCOUNT_NOT_ACTIVATED:
    'Konto erstellt, aber noch nicht aktiviert. Gehen Sie zu Ihrem Postfach, um Ihr Konto zu aktivieren, bevor Sie sich anmelden und fortfahren können.',

  // Subscription
  SUBSCRIBE: 'Abonnieren',
  SUBSCRIPTION: 'Abonnement',
  CREATE_SUBSCRIPTION: 'Abonnement erstellen',
  TAKE_SUBSCRIPTION: 'Abonnement schließen',
  TAKE_SUBSCRIPTION_HTML: 'Flex-Abonnement<br>schließen',
  ITEMS_NOT_SELECTED: 'Artikel nicht ausgewählt',
  ITEMS_SELECTED: 'Artikel ausgewählt',
  ADD_ALL: 'Füge alle Hinzu',
  REMOVE_ALL: 'Alles entfernen',
  REMOVE: 'Entfernen',
  CANCEL_ORDER: 'Absagen',
  ADD_SUBSCRIPTION_PRODUCTS_TITLE: 'Wähle aus der Liste',
  NO_START_DATES: 'Startdaten sind für Ihre Auswahl nicht verfügbar',
  NO_START_TIMES: 'Startzeiten sind für Ihre Auswahl nicht verfügbar',
  SUBSCRIPTION_REPETITION_TITLE:
    'In welcher Häufigkeit möchten Sie Ihr Abonnement wiederholen?',
  SUBSCRIPTION_REPETITION_FREQUENCY: 'Wiederholungsfrequenz Ihres Abonnements',
  SUBSCRIPTION_OVERVIEW: 'Abonnementübersicht',
  SUBSCRIPTION_NAME: 'Abonnementname',
  SUBSCRIPTION_NAME_TOOLTIP:
    'Sie können Ihren bevorzugten Abonnementnamen eingeben, um den Standardnamen zu ersetzen',
  SUBSCRIPTION_PRODUCTS: 'Abonnementprodukte',
  PICKUP_DATE_TIME: 'Uhrzeit',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_ON:
    'Sie haben das Lastschriftverfahren aktiviert. Ihre Zahlung wird automatisch per Lastschrift abgewickelt.',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_OFF:
    'Lastschrift ist erforderlich, um ein Abonnement zu erstellen. Wenn Sie Ihr Abonnement speichern, zahlen Sie <b>1 Cent</b>, um zuerst die Lastschrift zu aktivieren. Ihr Abonnement wird erstellt, wenn die Zahlung erfolgreich eingegangen ist.',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_TITLE:
    'Lastschrift aktivieren, um das Abonnement abzuschließen',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_DESC:
    'Sie werden auf die Zahlungsseite weitergeleitet, um <b>1 Cent</b> zu bezahlen, der Ihrem Guthaben hinzugefügt wird, um die Lastschrift zu aktivieren. Der Zweck der Zahlung besteht darin, uns Ihre Bankverbindung zum automatischen Abzug für Ihr Abonnement zur Verfügung zu stellen. Ihr Abonnement wird erstellt, wenn die Zahlung erfolgreich eingegangen ist.',
  CREATE_SUBSCRIPTION_SUCCESS_TITLE: 'Abonnement erstellt',
  CREATE_SUBSCRIPTION_SUCCESS: 'Das Abonnement wurde erfolgreich erstellt.',
  CREATE_SUBSCRIPTION_ERROR:
    'Fehler beim Erstellen des Abonnements. Bitte versuchen Sie es später erneut.',
  SUBSCRIPTION_PAYMENT_SUCCESS_MSG:
    'Die Zahlung zur Aktivierung des Lastschriftverfahrens ist eingegangen und Ihr Abonnement wurde erfolgreich erstellt. Sie können das Abonnement auf Ihrer Bestelllistenseite anzeigen.',
  SUBSCRIPTION_PAYMENT_ERROR_MSG:
    'Die Transaktion ist fehlgeschlagen. Die Lastschrift ist nicht aktiviert und Ihr Abonnement wird nicht erstellt. Versuchen Sie, die Lastschrift zuerst auf der Seite Kontoeinstellungen zu aktivieren und erstellen Sie dann Ihr Abonnement erneut. Bitte kontaktieren Sie uns, wenn das Problem weiterhin besteht.',
  CREATE_SUBSCRIPTION_EXPLAN:
    'Mit den folgenden Schritten können Sie ein neues Abonnement erstellen, mit dem Sie Ihre Wunschprodukte periodisch liefern oder abholen lassen können.',
  SUBSCRIPTION_TO_DELIVERY_EXPLAN:
    'Im nächsten Schritt können Sie die Liefer- oder Abholmethode und das Datum/die Uhrzeit auswählen, an dem diese Wiederholung beginnen soll.',
  SUBSCRIPTION_STEP1: 'Schritt 1: Wählen Sie Ihre Produkte',
  SUBSCRIPTION_STEP2: 'Schritt 2: Abonnementtyp',
  SUBSCRIPTION_STEP3: 'Schritt 3: Lieferoptionen',
  SUBSCRIPTION_STEP4: 'Schritt 4: Zusammenfassung',
  INVALID_POSTAL_CODE: 'Ungültige Postleitzahl',
  MIN_SUBSCRIPTION_VALUE:
    'Der Mindestgesamtwert Ihrer ausgewählten Produkte zum Erstellen eines Abonnements beträgt',
  MIN_SUBSCRIPTION_VALUE_ALERT:
    'Sie müssen der Liste weitere Produkte hinzufügen. Der Mindestgesamtwert Ihrer ausgewählten Produkte beträgt',
  SHOPPING_LISTS_AND_SUBSCRIPTIONS: 'Abonnements und Bestellliste',
  GO_TO_SUBSCRIPTION: 'Gehe zum Abo',
  SUBSCRIPTION_LOGIN_ALERT:
    'Melden Sie sich an oder erstellen Sie ein Konto, bevor Sie ein Abonnement erstellen können',
  SUBSCRIPTION_BENEFITS_TITLE: 'Abonnementmerkmale',
  ADD_PRODUCT: 'Produkt hinzufügen',
  REMOVE_ALL_PRODUCTS: 'Alle Produkte entfernen',
  DELETE_SUBSCRIPTION_TITLE: 'Abonnement löschen',
  DELETE_SUBSCRIPTION_DESC: 'Möchten Sie dieses Abonnement wirklich löschen?',
  LOGIN_REQUIRED: 'Anmeldung erforderlich',
  SUBSCRIPTION_INTRODUCTION_TITLE: 'Abo-Service',
  SUBSCRIPTION_INTRODUCTION_DESC:
    'Vergessen Sie manchmal, rechtzeitig zu bestellen oder möchten Sie einfach nicht jedes Mal eine neue Bestellliste erstellen? Wir bieten Ihnen die Möglichkeit, eine Liste mit Lebensmitteln zusammenzustellen, die Sie regelmäßig liefern lassen können. Sie können es sich liefern lassen oder selbst an einem der Standorte abholen. Kurz bevor Ihre Liste gepackt ist, haben Sie die Möglichkeit, die Liste anzupassen. Wenn Sie nichts tun, wird die Bestellung automatisch aufgegeben. Sie können es auch im Urlaub überspringen.<br><br>Das Schöne ist, dass Sie diese Liste mit Ihren Mitbewohnern teilen können, sodass jeder, den Sie einladen, Lebensmittel auf die Liste setzt.<br>',
  LIMITED_PRODUCT_LEFT: 'Nur noch %d Artikel für Ihre Auswahl verfügbar',
  SUBSCRIPTION_REPEATING_PRODUCTS: 'Sich wiederholende Produkte',
  SUBSCRIPTION_ONETIME_PRODUCTS: 'Einmalige Produkte',
  SUBSCRIPTION_QUANTITY: 'Abonnementmenge',
  ADD_TO_SUBSCRIPTION: 'Zum Abonnement hinzufügen',
  REMOVE_ITEM_ERROR:
    'Der Artikel konnte nicht entfernt werden. Bitte versuchen Sie es später erneut.',
  UPCOMING_ORDER: 'Kommende Bestellung',
  UPDATE_SUBSCRIPTION: 'Als Standard speichern',
  UPDATE_SUBSCRIPTION_DIALOG_MSG:
    'Möchten Sie Ihr Liste mit der anstehenden Bestellung aktualisieren?',
  UPDATE_SUBSCRIPTION_SUCCESS: 'Bestellliste wurde erfolgreich aktualisiert',
  UPDATE_SUBSCRIPTION_ERROR:
    'Ihre Liste konnte nicht aktualisiert werden. Bitte versuchen Sie es später erneut.',
  RESET_SUBSCRIPTION: 'Standardliste wiederherstellen',
  RESET_SUBSCRIPTION_DIALOG_MSG:
    'Möchten Sie Ihre Bestellliste auf die Standardliste wiederherstellen?',
  RESET_SUBSCRIPTION_SUCCESS:
    'Die Bestellliste wurde erfolgreich wiederhergestellt',
  RESET_SUBSCRIPTION_ERROR:
    'Ihre Bestellliste konnte nicht wiederhergestellt werden. Bitte versuchen Sie es später erneut.',
  ITEM_CHANGE_SAVED: 'Artikeländerung wurde gespeichert',
  ITEM_REMOVED: 'Artikel wurde entfernt',

  INTERNATIONAL_DELIVERY_DATE_ALERT:
    'Dies ist Ihr bevorzugtes Zeitfenster für die internationale Lieferung, das von der tatsächlichen Lieferzeit abweichen kann. Bitte überprüfen Sie Ihre E-Mail, um die Lieferaktualisierungen vom Kurierunternehmen zu erhalten.',

  PRODUCT_PERSONAL_DISCOUNT_TITLE: 'Ihr persönlicher Rabatt',
  PRODUCT_PERSONAL_DISCOUNT_DESC:
    'Fügen Sie dieses Produkt so schnell wie möglich Ihrem Warenkorb hinzu, um einen persönlichen Rabatt zu erhalten',

  PROF_USER_CHECKBOX_LABEL: 'Ich bin Firmenkunde',
  KVK_NUMBER: 'KvK-Nummer',
  VAT_NUMBER: 'MwSt.-Nummer',
  VAT: 'MwSt',
  TOTAL_PRICE_EXCL_VAT: 'Gesamtpreis exkl. MwSt',

  SUBSCRIPTION_BUY_BY_ACCOUNT_REMINDER_MSG:
    'Beim Kauf mit Abo-Liste gibt es zwei Bezahlmöglichkeiten: Kauf auf Rechnung oder Lastschrift. Die erste Option steht Ihnen für dieses Konto nicht zur Verfügung. Wenn Sie Kauf auf Rechnung nutzen möchten, wenden Sie sich bitte an Ihren Lieferanten. Andernfalls fahren Sie fort und Sie werden später aufgefordert, das Lastschriftverfahren zu aktivieren.',

  DELIVERY_OPTIONS: 'Lieferoptionen',
  SERVER_MAINTENANCE_TITLE: 'Serverwartung',
  SERVER_MAINTENANCE_MESSAGE:
    'Unser Server ist aufgrund von Wartungsarbeiten vorübergehend nicht verfügbar. Kommen Sie später wieder, um es erneut zu versuchen.',
  POOR_BANDWIDTH_TITLE: 'Langsame Internetverbindung',
  POOR_BANDWIDTH_MESSAGE: 'Bitte überprüfe deine Interneteinstellungen.',
  MAKE_CHOICE_FOR_DELIVERY_PICKUP: 'Triff eine Entscheidung',

  QUIZ_INTRO_TEXT:
    "Beantworten Sie die folgenden Fragen und klicken Sie auf die Schaltfläche 'Senden', wenn Sie fertig sind.",
  QUIZ_SEND_SUCCESS_TEXT: 'Ihre Antworten wurden erfolgreich gesendet.',
  QUIZ_SEND_FAILED_TEXT:
    'Die Antworten konnten nicht gesendet werden. Bitte versuchen Sie es später erneut.',
  QUIZ_MUST_CHOOSE_MULTI: 'Sie müssen eine der Optionen auswählen.',
  QUIZ_MUST_FILL_IN: 'Sie müssen eine Antwort ausfüllen.',
  QUIZ_MUST_CHOOSE_PHOTO: 'Sie müssen ein Foto auswählen.',
  QUIZ_MUST_CHOOSE_VIDEO: 'Sie müssen ein Video auswählen.',
  QUIZ_MUST_GIVE_NAME: 'Für die Kommunikation benötigen wir Ihren Vornamen.',
  QUIZ_TEXT_LABEL: 'Geben Sie hier die Antwort ein.',
  QUIZ_NUMBER_LABEL: 'Geben Sie hier eine Zahl ein.',
  QUIZ_EMAIL_DESC:
    'Geben Sie Ihre Kontaktdaten ein.',
  QUIZ_QUESTION_NOT_ANSW:
    'Kann Ihre Antworten nicht senden. Nicht alle Fragen sind ausgefüllt.',

  PRODUCT_OPTIONS_TITLE: 'Andere optionen',
  PRODUCT_OPTIONS_DESCR1: 'Minimum auswählen ',
  PRODUCT_OPTIONS_DESCR2: ' optionen und maximal ',
  PRODUCT_OPTIONS_DESCR3: ' option(en) zu wenig gewählt',
  PRODUCT_OPTIONS_DESCR4: ' option(en) zu stark gewählt',
  PRODUCT_OPTIONS_DESCR5: 'Auswählen ',
  PRODUCT_OPTIONS_DESCR6: ' option(en)',
  PRODUCT_OPTIONS_ERROR:
    'Die Anzahl der ausgewählten Produktoptionen ist nicht korrekt.',
  PRODUCT_OPTIONS_TEXT: 'Optionen',
  PRODUCT_OPTIONS_PICTURE: 'Bildoptionen',
  ENTER_MESSAGE: 'Text eingeben',
  MAX_CHAR: 'Maximal %s Zeichen',

  DEF_CHANGE_INVALID_QTY_TITLE: 'Mengenänderung erforderlich',
  DEF_CHANGE_NO_CAPACITY_MSG:
    'Dieser Artikel ist nicht auf Lager, bitte wählen Sie einen anderen aus.',
  LEAVE_SHARED_LIST_MSG:
    'Sie werden die aktuelle Liste verlassen. Nach links sehen Sie diese Liste nicht mehr. Willst du wirklich gehen?',
  DEF_CHANGE_QTY_LESS_THAN_CAPACITY_MSG:
    'Es sind nur noch %d Artikel übrig. Möchten Sie die Menge auf diesen Wert verringern?',

  SHOPPING_CART_LOWERCASE: 'Einkaufswagen',
  SHOPPING_LIST_LOWERCASE: 'Bestellliste',
  E_PCAP_001_ADD_PROD:
    'Das Produkt konnte nicht zu Ihrem %s hinzugefügt werden, da die Menge das Maximum überschreitet. Reduzieren Sie die Zahl und versuchen Sie es erneut.',
  E_PCAP_001_CHANGE_PROD:
    'Das Produkt in Ihrem %s konnte nicht geändert werden, da die Menge das Maximum überschreitet. Reduzieren Sie die Zahl und versuchen Sie es erneut.',
  E_PCAP_002_ADD_PROD:
    'Das Produkt konnte nicht zu Ihrem %s hinzugefügt werden, da die Menge unter dem Minimum liegt. Erhöhen Sie die Zahl und versuchen Sie es erneut.',
  E_PCAP_002_CHANGE_PROD:
    'Das Produkt in Ihrem %s konnte nicht geändert werden, da die Menge unter dem Minimum liegt. Erhöhen Sie die Zahl und versuchen Sie es erneut.',

  LEAVE_SHARED_LIST_TITLE: 'Verlassen Sie die Liste',

  PAYMENT_METHOD_AUTOMATIC: 'Online bezahlen',
  PAYMENT_METHOD_AUTOMATIC_INFO:
    'Bezahlen Sie die Bestellung je nach Kontoeinstellung mit iDEAL/Kreditkarte, Nutzerguthaben, Lastschrift oder Kauf auf Rechnung.',
  PAYMENT_METHOD_ON_DELIVERY: 'Bei Zustellung',
  PAYMENT_METHOD_ON_DELIVERY_INFO:
    'Bezahlen Sie die Bestellung je nach Versandart bei Lieferung oder Abholung.',
  PAYMENT_METHOD_IDEAL_INFO_DIRECT:
    'Bezahlen Sie die Bestellung mit iDeal. Sie werden auf die Internet-Zahlungsseite von Mollie weitergeleitet.',
  PAYMENT_METHOD_IDEAL_INFO_DELAYED:
    'Bezahlen Sie die Bestellung mit iDeal. Sie erhalten eine E-Mail mit einem Zahlungslink.',
  PAYMENT_METHOD_DIRECT_DEBIT_INFO:
    'Bezahlen Sie die Bestellung per Lastschrift. Der Betrag wird automatisch von Ihrem Konto abgebucht.',
  PAYMENT_METHOD_AT_EVENT_INFO:
    'Bezahlen Sie die Bestellung bei Abholung/Lieferung.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DIRECT:
    'Bezahlen Sie die Bestellung mit Ihrer Kreditkarte. Sie werden auf die Internet-Zahlungsseite von Mollie weitergeleitet.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DELAYED:
    'Bezahlen Sie die Bestellung mit Ihrer Kreditkarte. Sie erhalten eine E-Mail mit einem Zahlungslink.',
  PAYMENT_METHOD_ON_ACCOUNT_INFO:
    'Zahlen Sie die Bestellung auf Rechnung. Sie erhalten eine Rechnung.',
  SELECT_PAYMENT_METHOD: 'Zahlungsart auswählen',
  SELECTED_PAYMENT_METHOD: 'Ausgewählte zahlungsmethode',
  SELECTED_PAYMENT_METHOD_INFO_LIST:
    "Wenn Sie die Zahlungsmethode ändern möchten, klicken Sie auf die Schaltfläche 'Abbrechen', um die automatisch wiederkehrende Bestellung zu stoppen. Über den Button 'Lieferzeit wählen' können Sie dann die Zahlungsart erneut wählen.",
  SELECTED_PAYMENT_METHOD_INFO_SUBSC:
    "Wenn Sie die Zahlungsmethode ändern möchten, klicken Sie auf die Schaltfläche 'Löschen', um das Abonnement zu löschen. Sie können das Abonnement dann neu erstellen und die gewünschte Zahlungsmethode auswählen.",
  SELECT_PAYMENT_METHOD_NO_SELECT_ERROR:
    'Zahlungsmethode ist erforderlich. Bitte wählen Sie eine aus der Liste aus.',
  HOSTNET_ISSUE_ALERT_TITLE: 'E-Mail-Problem',
  HOSTNET_ISSUE_ALERT:
    'Leider hat unser E-Mail-Anbieter Hostnet derzeit Probleme bei der Verarbeitung von E-Mails. Infolgedessen kommen E-Mails zur Bestätigung einer Bestellung möglicherweise nicht sofort an. Sie arbeiten mit Hochdruck an einer Lösung. Sobald alles wieder einsatzbereit ist, versuchen wir es zu versenden. Entschuldigung für die Unannehmlichkeiten.\nTeam Buy Fresh',
  MINIMUM_ORDER_VALUE_TEMP: 'Mindestbestellwert %s',
  PICKUP_MINIMUM_ORDER_VALUE_ALERT:
    'Mindestbestellwert von %s für ausgewählte Abholoption nicht erreicht.',
  PICKUP_FEE_INFO: 'Abholgebühr: %s',
  PICKUP_FEE: 'Abholgebühr',
  PICKUP_NOT_POSSIBLE: 'Für Ihre Auswahl ist keine Abholung möglich.',
  PICKUP_FREE_ORDER_VALUE: 'Gratis für Bestellungen über %s',
  GET_PAYMENT_METHODS_ERROR:
    'Zahlungsmethoden konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.',
  PREVIOUS_BUTTON_PROMOTION: 'Vorherige',
  NEXT_BUTTON_PROMOTION: 'Nächste',
  PREVIOUS_BUTTON_BLOG: 'Vorheriger Artikel',
  NEXT_BUTTON_BLOG: 'Nächster Artikel',
  TERMS_AND_CONDITIONS: 'Geschäftsbedingungen',
  POWERED_BY: 'Bereitgestellt von',
  SELECTED: 'ausgewählt',
  OPEN_CATEGORY: 'offen',
  CLOSE_CATEGORY: 'schließen',
  E_PAYM_001_NO_PAYMENT:
    'Für das Abonnement ist keine Zahlungsmethode verfügbar. Kontaktieren Sie Ihren Partner, um mehr über andere Zahlungsoptionen zu erfahren.',
  PAYMENT_METHOD_NOT_AVAILABLE: 'Keine Zahlungsmethode verfügbar',
  COULD_NOT_GET_START_DATES:
    'Es konnten keine Starttermine für diese Veranstaltung ermittelt werden ...',
  SOLD_OUT: 'Ausverkauft! Tickets sind nicht mehr verfügbar.',
  BENEFITS_GLANCE: 'Alle Vorteile auf einen Blick:',
  MY_SHOPPING_LIST: 'Meine Einkaufsliste',
  SELECT_SHOPPING_LIST: 'Einkaufsliste auswählen',
  CREATE_NEW_LIST: 'Neue Liste',
  USERS: 'Benutzer',
  ADD_NEW_USER: 'Benutzer hinzufügen',
  SENT_NEW_CHILD_RELATION_REQUEST:
    'Der Benutzer erhält eine E-Mail mit einem Link zum Akzeptieren der Freigabe von Einkaufslisten',
  REQUEST_NEW_CHILD_RELATION_ERROR:
    'Anfrage wurde nicht gesendet. Bitte versuchen Sie es später noch einmal.',
  CONFIRM_NEW_CHILD_RELATION_SUCCESS:
    'Anfrage akzeptiert. Sie haben jetzt Zugriff auf die freigegebene Liste.',
  CONFIRM_NEW_CHILD_RELATION_ERROR:
    'Es gab ein Problem bei der Annahme der Anfrage. Bitte versuchen Sie es später noch einmal.',
  CONFIRMATION: 'Akzeptieren Sie diese Anfrage?',
  CONFIRMATION_MESSAGE:
    'Durch Bestätigen dieser Anfrage können Sie von %s aus auf die Einkaufsliste zugreifen',
  NO_USERS_FOUND:
    'Es wurden keine Benutzer gefunden. Klicken Sie auf die Schaltfläche „Benutzer hinzufügen“, um Benutzer hinzuzufügen.',
  DELETE_CHILD_RELATION_SUCCESS:
    'Der Benutzer wurde erfolgreich aus der freigegebenen Einkaufsliste entfernt.',
  DELETE_CHILD_RELATION_ERROR:
    'Der Benutzer kann nicht aus der freigegebenen Einkaufsliste entfernt werden. Versuchen Sie es später erneut.',
  MAKE_LIST_TEMP_SUCCESS: 'Die Einkaufsliste wurde vorübergehend storniert',
  MAKE_LIST_TEMP_ERROR:
    'Die Einkaufsliste kann nicht storniert werden. Bitte versuchen Sie es später noch einmal',
  DELETE_SHOPPING_LIST_SUCCESS: 'Einkaufsliste wurde erfolgreich gelöscht',
  DELETE_SHOPPING_LIST_ERROR:
    'Einkaufsliste konnte nicht gelöscht werden. Bitte versuchen Sie es später noch einmal.',
  SAVE_SHOPPING_LIST_SUCCESS: 'Einkaufsliste wurde erfolgreich gespeichert.',
  ORDER_SHOPPING_LIST_SUCCESS: 'Die Einkaufsliste ist zum Bestellen bereit',
  ORDER_SHOPPING_LIST_ERROR:
    'Beim Bestellen der Einkaufsliste ist ein Problem aufgetreten. Versuchen Sie es später erneut.',
  INVALID_PHONE_NO: 'Ungültige Telefonnummer oder Landesvorwahl',
  RECEIVE_WHATSAPP: 'Abonnieren Sie WhatsApp-Nachrichten',
  WHATSAPP_REQUEST_SUCCESS:
    'Eine Anfrage für den WhatsApp-Messaging-Dienst wurde erfolgreich gesendet.',
  WHATSAPP_REQUEST_FAILED:
    'Beim Anfordern des WhatsApp-Dienstes ist ein Problem aufgetreten. Bitte versuchen Sie es später noch einmal.',
  WHATSAPP_OPT_OUT_SUCCESS:
    'Sie wurden erfolgreich aus dem WhatsApp-Messaging-Dienst entfernt.',
  WHATSAPP_OPT_OUT_FAILED:
    'Der Benutzer konnte nicht aus dem WhatsApp-Messaging-Dienst entfernt werden. Versuchen Sie es später erneut.',
  COUNTRY_CODE: 'Landesvorwahl',
  SHARE_SHOPPING_LISTS: 'Einkaufsliste teilen',
  DAY: 'Tag',
  MONTH: 'Monat',
  YEAR: 'Jahr',
  LOGIN_REQUIRED_SHOPPING_LIST:
    'Sie müssen sich anmelden, um Einkaufslisten zu erstellen und zu verwalten.',
  OPT_OUT_MSG:
    'Wenn Sie den Empfang von WhatsApp-Nachrichten abbestellen möchten,',
  OPT_OUT_MSG_SMS:
    'Wenn Sie den Empfang von SMS-Nachrichten abbestellen möchten,',
  CLICK_HERE: ' klicken Sie hier.',
  JANUARY: 'Januar',
  FEBRUARY: 'Februar',
  MARCH: 'März',
  APRIL: 'April',
  MAY: 'Mai',
  JUNE: 'Juni',
  JULY: 'Juli',
  AUGUST: 'August',
  SEPTEMBER: 'September',
  OCTOBER: 'Oktober',
  NOVEMBER: 'November',
  DECEMBER: 'Dezember',
  INVALID_DATE_OF_BIRTH: 'Ungültiges Geburtsdatum',
  NOT_SUBSCRIBED_YET: 'WhatsApp nicht abonniert',
  SUBSCRIBED_TO_WHATSAPP: 'Gezeichnet',
  FAILED_SAVING_PHONENUMBER_SETTINGS: 'Einstellungen konnten nicht gespeichert werden, es existiert bereits ein Konto mit dieser Telefonnummer.',
  USE_DAY_PRICING: 'Bei Abonnementsverträgen verwenden wir Tagespreise, daher kann sich der Preis noch ändern',
  FULL_CALENDAR: 'Den vollständigen Kalender anzeigen',
  SUB_CATEGORIES: 'Unterkategorien',
  DEPOSIT_VALUE: 'Kaution',
  CHANGE_DELIVERY:'Ändern Sie die Abhol- oder Lieferzeit',
  SMS_REQUEST_SUCCESS: "Die Anforderung für SMS-Nachrichten war erfolgreich.",
  SMS_REQUEST_FAILED: "Beim Anfordern des SMS-Dienstes ist ein Problem aufgetreten. Bitte versuchen Sie es später noch einmal.",
  SMS_OPT_OUT_SUCCESS: "Der Benutzer wurde erfolgreich aus dem SMS-Messaging-Dienst entfernt.",
  SMS_OPT_OUT_FAILED: "Der Benutzer konnte nicht aus dem SMS-Messaging-Dienst entfernt werden. Versuchen Sie es später erneut.",
  RECEIVE_SMS: 'Abonnieren Sie SMS-Nachrichten',
  SHORT_URL_ERROR_TITLE: 'Der verwendete Link ist nicht mehr gültig',
  SHORT_URL_ERROR_MESSAGE_1: 'Aus Sicherheitsgründen sind die Glieder nur begrenzt haltbar. Bestellungen verfallen nach Ablauf der Bestellzeit. Sie erhalten rechtzeitig vor der nächsten Bestellung einen neuen Link.',
  SHORT_URL_ERROR_MESSAGE_2: 'Wenn Sie dennoch bestellen möchten, melden Sie sich beim Buy Fresh-Konto Ihres Anbieters an oder kontaktieren Sie uns.',
  SHOPPINGLIST_REMINDER_PREFERENCE: "Einstellungen für Einkaufslisten-Erinnerungen",
  USER_DOES_NOT_HAVE_PARTNERGROUP_APP: "Du hast die App dieser Partnergruppe nicht",
  CHANGE_COMMUNICATION_PREFERENCE_SUCCESS: 'Neue Präferenzen für Bestelllisten wurden erfolgreich gespeichert',
  PHONE_NUMBER_REQUIRED_FOR_SMS: "Telefonnummer ist für SMS erforderlich",
  REFRESH_SHOPPINGLISTS: "Bestelllisten erneut abrufen",
  SHOPPING_LIST_NO_LONGER_EXISTS: "Bestellliste existiert nicht mehr",
  PLEASE_DATE: "Wähle ein Datum",
  CHOOSE_OPTION: "Wähle Optionen",
  ACTIVITY_BOOK: 'Aktivität buchen',
  ORDER_START_MOMENT:
    'Nachbestellungen sind nur ab %s %s möglich. Wenn Sie früher bestellen oder Ihre Bestellung ändern möchten, wenden Sie sich bitte an den Partner.',
  NOTIFICATION: 'Benachrichtigung'
};

export { DE as default };
